/* ===========================================================================
 * quiz-bo-de-dung-man.js · dựng 21 câu hỏi, 4 câu chọn nhiều và CẢ MẢNG `SCREENS`
 * ---------------------------------------------------------------------------
 * VÌ SAO CÓ FILE NÀY
 *   Câu hỏi, thứ tự câu và nhãn trả lời của quiz v7.9 nằm trong DB, không nằm
 *   trong chữ của `quiz-inner-weather.js`. File này đọc `window.__msBoDeSnapshot`
 *   (snapshot sinh bằng `bin/q3_sinh_bo_de.py`) rồi dựng lại `QUIZ7.questions`,
 *   `QUIZ7.multi` và `SCREENS` trên dữ liệu đó.
 *
 *   Bundle 26.448 dòng là bản BÊ NGUYÊN, không sửa vào. Cách duy nhất là chồng
 *   lên từ một file nạp sau — đúng kiểu bundle vốn đã tự làm với chính nó.
 *
 * A0 (phase 18) — ĐÂY LÀ CHỖ DUY NHẤT DỰNG `SCREENS`
 *   Trước A0 có bảy chỗ dựng `SCREENS`, lớp sau đè lớp trước. A0 gom về một chỗ: file
 *   này dựng đủ 38 phần tử của v7.9 rồi cắm cờ `window.__msManA0`, và
 *   `quiz-giai-doan-1.js` (thẻ #6) đọc cờ đó để BỎ QUA đoạn cắt `dungLaiManHinh` của
 *   nó. Thêm hay bớt màn từ nay sửa ở `MAN_DUOI` và vòng dựng bên dưới, không sửa chỗ
 *   nào khác. Khi snapshot vắng thì file này thoát sớm, không cắm cờ, và lớp cắt cũ
 *   của `quiz-giai-doan-1.js` vẫn chạy như trước.
 *
 * VỊ TRÍ NẠP — kẹp giữa hai thẻ, không đổi được
 *   SAU  `quiz-inner-weather.js`: `QUIZ7`, `RAMPS7`, `SCREENS`, `MULTI_TAG` và
 *        `idxOf()` đều khai trong đó; `boot()` cũng chạy ở cuối chính file đó (:26447).
 *   TRƯỚC `quiz-giai-doan-1.js`: file đó cắt `SCREENS` TẠI CHỖ
 *        (`SCREENS.length = 0; push.apply`, :1219-1241) rồi vẽ lại màn đang hiện,
 *        nên mọi thay đổi `SCREENS` phải xong trước khi nó chạy.
 *   Không chờ được lời gọi mạng: `napSchema()` nằm trong `quiz-goi-api.js`, nạp
 *   SAU file này. Đó là lý do nguồn hiển thị là snapshot chứ không phải API.
 *
 * ĐẢO THANG — chỗ dễ chấm ngược nhất
 *   Điểm lấy bằng `RAMPS7[q.ramp][idx]` với `idx` là VỊ TRÍ NÚT khách bấm
 *   (`QUIZ7.pointsOf`, :630-641; `state.q7[qid] = +el.getAttribute('data-i')`, :10513).
 *   Bundle cũ đảo NHÃN theo `kind` (`V10_OPT`, :21001) nên câu tích cực có "Very true"
 *   đứng ở vị trí 0 và ăn 10 điểm của `linear`. v7.9 cố định nhãn Not true → Very true
 *   cho cả 21 câu, nên câu tích cực phải đổi sang thang ĐẢO, nếu không vị trí 0
 *   ("Not true") vẫn ăn 10 điểm và 11 câu bị chấm ngược, im lặng.
 *   `positive` lấy từ snapshot, không viết cứng danh sách mã câu vào đây.
 *
 * KHÔNG CÓ SNAPSHOT THÌ KHÔNG LÀM GÌ CẢ
 *   Snapshot vắng mặt hoặc thiếu trường bắt buộc → thoát sớm, bundle chạy nguyên
 *   bản cũ. Khối `v10Q(...)` trong bundle vì vậy phải giữ, nó là lớp dự phòng cuối.
 *   Không so `version` với `BO_DE` ở đây được: `BO_DE` khai trong `quiz-goi-api.js`,
 *   nạp sau file này và không phơi ra toàn cục. Việc ghim phiên bản do
 *   `bin/q3_sinh_bo_de.py --kiem` làm trong CI, và `napSchema()` còn một cổng 410 nữa.
 * ========================================================================= */
(function () {
  'use strict';

  /* Ba màn xen đứng sau câu thứ 3, 9 và 15 — `ref/1-SO-SANH` §851. Bundle chèn màn
     xen mỗi khi ĐỔI VÙNG; với thứ tự v7.9 (Q16 `mind` đứng đầu, rồi Q1 `ground`) vùng
     đổi ngay sau câu 1 nên chép nguyên là sai chỗ. Ở đây dùng vị trí cố định. */
  var MOC_XEN = [3, 9, 15];

  var THANG_DAO = [0, 2.5, 5, 7.5, 10];

  /* Nhãn 5 mức tiếng Việt, một mảng cố định theo thứ tự Không đúng → Rất đúng, dùng
     chung cho cả 21 câu. Ba biến thể `negVi` / `posVi` / `loadVi` của bundle bỏ hẳn:
     v7.9 không đảo nhãn nữa. */
  var NHAN_VI = ["Không đúng", "Hơi đúng", "Đôi khi đúng", "Khá đúng", "Rất đúng"];

  /* ---------------------------------------------------------------------------
     BẢNG TRA TIẾNG VIỆT
     `quiz_questions` chỉ có MỘT cột `text` (`20260901_quiz_schema.sql:61`) và đợt này
     không thêm cột tiếng Việt: khách thật chỉ thấy tiếng Anh, `?lang=vi` là đường nội
     bộ cho người trong nhà. Chữ tiếng Việt vì vậy ở lại FE, chép nguyên văn từ bản VI
     đã chốt: 8 mảng `Q`, `LIK`, `MA`, `MC`, `MB`, `FEAR`, `AREAS`, `LABELS` trong `app.js`
     của gói nguồn 22/09 (dòng 3–34). `bin/so_chu_vi_quiz.py` so bảng này với `app.js`.
     CÁI GIÁ ĐÃ BIẾT: thêm hoặc sửa câu trong DB thì bảng này phải bổ sung TAY. Câu nào
     không có trong bảng sẽ hiện chữ tiếng Anh, không để trống.
     --------------------------------------------------------------------------- */
  var CAU_VI = {
    Q1: "Tôi thức dậy với cảm giác cơ thể đã lại sức đủ để bước vào ngày mới.",
    Q2: "Tiền bạc hoặc những điều chưa chắc chắn làm tôi lo, ngay cả khi mọi thứ vẫn tạm ổn.",
    Q3: "Tôi thường bồn chồn, như thể thêm một chuyện bất ngờ nữa là mình quá tải.",
    Q4: "Tôi cho phép mình tận hưởng niềm vui nhỏ mà không thấy có lỗi hay lãng phí.",
    Q5: "Gần đây tôi vẫn có lúc cười thật lòng và thoải mái.",
    Q6: "Tôi thấy mình chẳng còn mấy niềm vui, như thể phải sắp xếp trước thì mới có lúc được vui.",
    Q7: "Tôi thường đồng ý hoặc nhận thêm việc dù thật lòng muốn từ chối.",
    Q8: "Hầu hết các ngày tôi giữ được ít nhất mười lăm phút thật sự thuộc về mình.",
    Q9: "Tôi tự trách mình rất nhiều mỗi khi kết quả không như mong muốn.",
    Q10: "Đặt người khác lên trước thường khiến tôi còn rất ít sức cho mình.",
    Q11: "Có người hỏi tôi thế nào và thật sự chờ câu trả lời, không chỉ hỏi xã giao.",
    Q12: "Người khác nhìn thấy và trân trọng những việc tôi âm thầm gánh.",
    Q13: "Tôi không nói ra điều mình muốn nói hoặc điều mình nghĩ, chỉ để giữ hoà khí.",
    Q14: "Khi điều gì quan trọng với tôi, tôi có thể nói ra và cảm thấy thật sự được lắng nghe.",
    Q15: "Tôi phải dò tâm trạng người khác thật kỹ trước khi dám nói.",
    Q16: "Tôi cứ nghĩ mãi về những việc chưa xong dù cơ thể đã muốn nghỉ.",
    Q17: "Tôi tin vào trực giác của mình và phân biệt được đâu là nỗi sợ, đâu là trực giác thật.",
    Q18: "Tôi phân tích quá nhiều khả năng rồi khó đưa ra quyết định rõ ràng.",
    Q19: "Tôi vẫn thấy mình có giá trị, ngoài những vai trò và trách nhiệm mình đang đảm nhận.",
    Q20: "Phía trước có một dự định hoặc niềm hy vọng nhỏ dành riêng cho tôi.",
    Q21: "Đôi khi tôi thấy trống rỗng và tự hỏi mọi nỗ lực này thật sự để làm gì."
  };

  /* Bốn câu chọn nhiều, gồm màn 30 (`fear`). Lựa chọn lấy từ `MA`, `MC`, `MB`, `FEAR`; câu
     hỏi lấy từ lời gọi `multi(...)` của cùng `app.js` (khớp chữ từng màn 27–30). */
  var MULTI_VI = {
    "M-A": {
      title: "Lúc này, phần nào trong đời đang lấy sức của bạn nhiều nhất mà gần như không ai thấy?",
      opts: [
        "Tôi là người giữ cho nhà cửa, lịch hẹn, giấy tờ và việc nhỏ không bị sót",
        "Tôi đang chăm sóc hoặc lo cho người thân nhiều hơn người khác thấy",
        "Con cái đã lớn nhưng lòng tôi vẫn chưa thật sự được nghỉ",
        "Tôi ở cạnh một người nhưng vẫn thường phải tự xoay xở",
        "Công việc lấy của tôi nhiều hơn nó trả lại",
        "Tiền bạc hoặc tương lai khiến tôi khó thư giãn",
        "Tôi vẫn buồn vì một mất mát hoặc một giai đoạn trong đời đã kết thúc",
        "Cơ thể tôi đã thay đổi, và tôi không còn yên tâm về cơ thể mình như trước",
        "Không có một chuyện cụ thể, chỉ là tôi thấy mình đang cạn dần"
      ]
    },
    "M-C": {
      title: "Nếu trong 7 ngày tới có thể được trả lại một điều, bạn muốn điều gì nhất?",
      opts: [
        "Một khoảng nghỉ mà tôi không phải thấy có lỗi",
        "Một người hỏi tôi đang thế nào và thật sự chờ nghe",
        "Một lời cảm ơn cụ thể cho những việc tôi âm thầm làm",
        "Một chữ “không” nói ra được mà không biến thành chuyện lớn",
        "Một phần thời gian có tên tôi trên lịch",
        "Một niềm vui nhỏ, chỉ để mình vui chứ không cần mang lại lợi ích gì",
        "Bình an trong chính ngôi nhà của tôi",
        "Một dấu hiệu cho thấy những năm tới vẫn có điều đáng mong chờ",
        "Một cách chăm mình mà không thành thêm một việc phải làm"
      ]
    },
    "M-B": {
      title: "Gần đây có câu nào bạn muốn nói mà vẫn giữ mãi trong lòng không?",
      opts: [
        "Tôi ước có người nhận ra tôi mệt mà không bắt tôi giải thích.",
        "Tôi tủi vì những việc mình làm cứ bị xem là hiển nhiên.",
        "Tôi giận, rồi lại thấy có lỗi vì mình giận.",
        "Tôi sợ nếu mình dừng lại, mọi thứ sẽ rối lên.",
        "Tôi nhớ những ngày mình nhẹ lòng và vui hơn.",
        "Có những câu tôi đã tập nói nhiều lần mà vẫn chưa nói ra.",
        "Tôi sợ dù nói thật thì cũng chẳng có gì thay đổi.",
        "Tôi không muốn phải mạnh mẽ thêm một ngày nữa.",
        "Tôi không còn biết mình muốn gì nữa."
      ]
    },
    "fear": {
      title: "Nếu năm nay không có gì đổi, bạn sợ mất điều gì nhất?",
      opts: [
        "Giấc ngủ thật sự lại sức",
        "Tiếng nói của chính mình",
        "Những niềm vui nhỏ",
        "Cảm giác mình vẫn được là chính mình",
        "Có thể nhận giúp đỡ mà không thấy có lỗi"
      ]
    }
  };

  /* ---------------------------------------------------------------------------
     ĐUÔI MÀN v7.9 — `ref/1-SO-SANH` §1, tám màn sau phần câu hỏi, cộng màn video `vid`
     (32b) tách khỏi `social` theo C1 ngày 22/09

     Dựng theo TÊN chứ không lọc lại mảng cũ. Đo 21/09 bằng `orca eval`: cả mười lăm
     màn đuôi trong bundle đều là `{t:'…'}` trơn, không màn nào mang thuộc tính riêng
     (`src`, `mi`, `ii` chỉ có ở phần thân), nên dựng object mới không mất gì.

     TÁM MÀN BỎ biến mất chỉ vì KHÔNG có tên trong danh sách này — không `splice` ra
     sau, không đụng bundle:
       `expert`  · 4 chuyên gia không có thật        (ref §1, dòng "30 · expert")
       `name`    · ô tên gộp vào màn email           (ref §1, dòng "33 · name")
       `payment` `delivery` `mapFull` `reportFull` `signup` `done` CŨ · sáu màn sau
                   thanh toán, bản đang chạy không có đường nào tới.
     `goto(idxOf('payment'))` còn nằm trong bundle vẫn an toàn sau khi bỏ: `idxOf` trả
     `-1` và `goto()` thoát ngay ở dòng đầu (`quiz-inner-weather.js:6060` và `:6473`).

     `gd1off` là màn giá (màn 37 của v7.9). Trước đây `quiz-giai-doan-1.js` chèn nó
     sau `hub`; ở đây nó đứng sẵn trong danh sách vì A0 gom việc dựng màn về một chỗ.
     `done` là màn 39 MỚI ("PAYMENT COMPLETE") — chỉ giữ chỗ, chữ do phase 26 viết.
     Màn 38 `checkout` là trang Shopify, nằm NGOÀI `SCREENS`, nên không có phần tử.
     --------------------------------------------------------------------------- */
  /* 29/09/2026: bỏ màn 31 `credibility` ("HOW YOUR READING IS BUILT") theo yêu cầu chủ dự án
     — cùng cách tám màn trên: chỉ gỡ tên khỏi danh sách, `RENDER.credibility` để nguyên. */
  /* 29/09/2026: tách lại màn TÊN (`name`) ra riêng trước màn email, như bản trước — ô tên
     không còn gộp trong màn email. `RENDER.name` bản v7.9 dựng ở khối A5 bên dưới. */
  var MAN_DUOI = ['social', 'vid', 'bdate', 'name', 'email', 'calc', 'hub', 'gd1off', 'done'];

  function laChuoi(x) { return typeof x === 'string' && x.length > 0; }
  function laSo(x) { return typeof x === 'number' && isFinite(x); }

  /* Nhãn theo `ord` 0→4, không theo thứ tự mảng trả về. */
  function nhanTheoOrd(options) {
    var sap = options.slice().sort(function (a, b) { return a.ord - b.ord; });
    var out = [], i;
    for (i = 0; i < sap.length; i++) { out.push(sap[i].label); }
    return out;
  }

  function cauHopLe(c) {
    if (!c || !laChuoi(c.id) || !laChuoi(c.text) || !laChuoi(c.tier)) { return false; }
    if (typeof c.positive !== 'boolean') { return false; }
    if (!c.options || c.options.length !== 5) { return false; }
    for (var i = 0; i < c.options.length; i++) {
      if (!laChuoi(c.options[i].label) || !laSo(c.options[i].ord)) { return false; }
    }
    return true;
  }

  function multiHopLe(m) {
    if (!m || !laChuoi(m.id) || !laChuoi(m.text)) { return false; }
    /* `max_select` chở giới hạn "Choose up to N" mà nghiệm thu đòi thấy trên màn. */
    if (!laSo(m.max_select) || m.max_select < 1) { return false; }
    if (!laSo(m.min_select) || m.min_select < 0) { return false; }
    if (!m.options || m.options.length < 2) { return false; }
    for (var i = 0; i < m.options.length; i++) {
      if (!laChuoi(m.options[i].label) || !laSo(m.options[i].ord)) { return false; }
    }
    return true;
  }

  function snapshotHopLe(s) {
    var i;
    if (!s || typeof s !== 'object' || !laChuoi(s.version)) { return false; }
    if (!s.questions || !s.questions.length || !s.multi || !s.multi.length) { return false; }
    for (i = 0; i < s.questions.length; i++) { if (!cauHopLe(s.questions[i])) { return false; } }
    for (i = 0; i < s.multi.length; i++) { if (!multiHopLe(s.multi[i])) { return false; } }
    return true;
  }

  var snap = window.__msBoDeSnapshot;
  if (!snapshotHopLe(snap)) { return; }
  if (typeof QUIZ7 === 'undefined' || typeof RAMPS7 === 'undefined' ||
      typeof SCREENS === 'undefined' || typeof idxOf !== 'function') { return; }

  /* ---- 21 câu chấm điểm, THỨ TỰ LÀ THỨ TỰ MẢNG trong snapshot (API đã xếp theo `ord`) --- */
  var cauHoi = [], i;
  for (i = 0; i < snap.questions.length; i++) {
    var c = snap.questions[i];
    var nhanEn = nhanTheoOrd(c.options);
    var chuVi = CAU_VI[c.id];
    var q = {
      id: c.id,
      tier: c.tier,
      ramp: c.positive ? 'linearRev' : 'linear',
      en: { q: c.text, opts: nhanEn },
      vi: { q: chuVi || c.text, opts: NHAN_VI }
    };
    if (c.dir) { q.dir = c.dir; }
    cauHoi.push(q);
  }

  /* ---- câu chọn nhiều, gồm cả màn 30: nó vào DB như một câu multi nên nó tự nằm
     trong mảng này và ra màn kiểu `multi7`, không phải kiểu màn mới. Kiểu mới là mất
     tracking: `quiz-do-duong.js:265` chỉ bắn `answered` cho 8 kiểu trong `MAN_NHAP`. --- */
  var chonNhieu = [];
  for (i = 0; i < snap.multi.length; i++) {
    var m = snap.multi[i];
    var optEn = nhanTheoOrd(m.options);
    var viM = MULTI_VI[m.id];
    var coVi = viM && viM.opts.length === optEn.length;
    chonNhieu.push({
      id: m.id,
      multi: true,
      /* `min` = 0 với cả bốn câu vì cả bốn đều có Skip. Bộ vẽ nút hiện đọc
         `(M.min || 1)` (:21449) nên 0 vẫn bị hiểu là 1; nút Skip là việc của phase sau,
         giá trị ở đây giữ đúng dữ liệu để phase đó không phải sửa lại chỗ này. */
      min: m.min_select,
      max: m.max_select,
      exclusiveOpt: laSo(m.exclusive_opt) ? m.exclusive_opt : -1,
      en: { title: m.text, sub: 'Choose up to ' + m.max_select + '.', opts: optEn },
      vi: { title: coVi ? viM.title : m.text,
            sub: 'Chọn tối đa ' + m.max_select + '.',
            opts: coVi ? viM.opts : optEn }
    });
  }

  RAMPS7.linearRev = THANG_DAO;
  QUIZ7.questions = cauHoi;
  QUIZ7.multi = chonNhieu;

  /* Câu multi mới chưa có nhãn riêng trên thanh tầng. Để trống thì bộ vẽ in thẳng `id`
     nội bộ ra màn (:21455 `tag ? L(tag) : M.id`), nên dùng đúng nhãn mặc định sẵn có của
     thanh đó. Chữ riêng cho màn 30 là việc của đợt sau. */
  if (typeof MULTI_TAG !== 'undefined') {
    for (i = 0; i < QUIZ7.multi.length; i++) {
      if (!MULTI_TAG[QUIZ7.multi[i].id]) {
        MULTI_TAG[QUIZ7.multi[i].id] = { en: 'A few last details', vi: 'Vài chi tiết cuối' };
      }
    }
  }

  /* ---------------------------------------------------------------------------
     DỰNG `SCREENS` — 39 phần tử, và đây là CHỖ DUY NHẤT dựng nó

     `ref/` §6A đếm 39 màn của LUỒNG, trong đó màn 38 `checkout` là trang Shopify nằm ngoài
     mảng; màn video 32b (C1, 22/09) được đánh số "b" nên không đẩy số màn sau nó. 1 intro
     + 1 reframe + 21 câu + 3 xen + 4 chọn nhiều (gồm màn 30 `fear`) + 9 màn đuôi = 39.
     --------------------------------------------------------------------------- */
  var out = [{ t: 'intro' }, { t: 'reframe' }], xen = 0;
  for (i = 0; i < QUIZ7.questions.length; i++) {
    out.push({ t: 'q7duo', tier: QUIZ7.questions[i].tier, items: [{ q: i }] });
    if (xen < MOC_XEN.length && (i + 1) === MOC_XEN[xen]) {
      out.push({ t: 'inter', ii: xen });
      xen++;
    }
  }
  for (i = 0; i < QUIZ7.multi.length; i++) { out.push({ t: 'multi7', mi: i }); }
  for (i = 0; i < MAN_DUOI.length; i++) { out.push({ t: MAN_DUOI[i] }); }
  SCREENS = out;
  IDX_RESULT = idxOf('hub');

  /* Cờ cho `quiz-giai-doan-1.js` (thẻ #6) biết `SCREENS` đã dựng xong và ĐỦ: đoạn
     `dungLaiManHinh` của file đó là lớp dựng thứ hai, chạy tiếp là xoá mất `reframe`.
     Cắm cờ ở ĐÂY, sau khi mảng đã đứng, chứ không cắm ở đầu file: overlay thoát sớm khi
     snapshot vắng hoặc sai dạng, và khi đó lớp lọc cũ vẫn phải chạy. */
  window.__msManA0 = true;

  /* =========================================================================
     A1 + A2 (phase 19, 20) — BỐN MÀN ĐẦU PHỄU VẼ LẠI THEO v7.9

     Chữ chép NGUYÊN VĂN từ `ref/3-NGUYEN-LIEU/3-chu-tung-man/CHU-TUNG-MAN-tieng-{Anh,Viet}.md`.
     Không diễn đạt lại: khách là phụ nữ Mỹ 45–65+, chữ đã chốt với đối tác.

     BỐN `RENDER` ĐÈ Ở ĐÂY, KHÔNG PHẢI CHỖ KHÁC
       `intro` màn 1 · `reframe` màn 2 · `q7duo` 21 màn câu hỏi · `inter` 3 màn xen.
     Cả bốn đè lớp CUỐI của bundle (`v10Intro` :21273, `RENDER.q7duo` :10487 rồi `v7Solo`
     :16964, `RENDER.inter` :9227). Bundle là một chồng lớp đè, lớp sau thắng — file này nạp
     sau bundle nên nó là lớp sau.

     CHỮ CÂU HỎI KHÔNG NẰM Ở ĐÂY. 21 câu và 5 nhãn trả lời đến từ `QUIZ7.questions` mà khối
     trên vừa dựng từ snapshot (`contracts.md` C6). Phần dưới chỉ là KHUNG hiển thị. Gõ chữ
     câu hỏi vào đây là tạo nguồn thứ hai, và `bin/q3_sinh_bo_de.py --kiem` không bắt được.

     CSS CHÈN TỪ JS, KHÔNG SỬA FILE .css
       Các class của v7.9 (`.kick` `.peek` `.cols` `.chips` `.proof` `.forme` `.rvok` `.prog`
       `.inter` `.hint`…) không có trong `quiz-inner-weather.css` lẫn `quiz-giai-doan-1.css` —
       đã đếm 21/09. Chèn `<style>` từ JS là đúng lối bundle vốn tự làm (:16930), và giữ cả
       đợt này trong MỘT file. Tiền tố `a1` cho mọi class mới, để không đụng class trùng tên
       của bundle. Cỡ chữ theo thang của theme (thân 17–18px, nút 20px — `quiz-giai-doan-1.css`
       đã nâng lên cho mắt 45–65+), KHÔNG theo thang 13–15px của prototype: prototype dựng cho
       khung demo, theme dựng cho khách thật.
     ========================================================================= */

  /* Hai nhãn `data-cho-kiem` dưới đây là HỢP ĐỒNG với phase 38b (cơ chế chặn đóng gói):
       K34 · bốn thẻ nhận xét màn 1, màn 13 và màn 32 — chủ dự án chốt 21/09 dùng đúng nội
             dung trong `ref/3-NGUYEN-LIEU`; khuôn và luật nhãn ở `a1TheNhanXet`.
       (K33 · câu số liệu màn 1 đã có bảng nguồn ở phase 36 và bỏ mẫu số theo chủ dự án 21/09, nên không còn cờ.)
     Tìm hết bằng `grep -c 'data-cho-kiem' assets/quiz-bo-de-dung-man.js`. */

  function A1(en, vi) { return isVI() ? vi : en; }

  /* Ảnh đi qua `__qzAsset` của bundle (:5): kho `assets/` của Shopify PHẲNG và đường dẫn mang
     mã theme, nên tên file phải được ghép với gốc CDN đọc từ `data-goc-anh`. Ghép tay là 404. */
  function a1Anh(ten) {
    return (typeof __qzAsset === 'function') ? __qzAsset(ten) : ten;
  }

  /* ---------------------------------------------------------------------------
     C2 (22/09) · MỘT HÀM GIÁ VÀ MỐC GIỮ GIÁ

     Quyết định A2: màn 37 giữ giá $4.90 trong 10 phút kể từ lần đầu vào màn; hết giờ thì
     MỌI chỗ nhắc giá khách phải trả đổi sang $19 và checkout thu $19. E12: chỉ đổi con số,
     giữ nguyên chữ. Ngoại lệ A4: "$4.90" trong thẻ nhận xét và lời Debbie là giá người đó
     đã trả, không đi qua đây.

     Mọi chuỗi giá gọi `giaHienTai()`. Không viết cứng "$4.90" ở chỗ nào khác của màn.

     MỐC SỐNG THEO LƯỢT (`minespirit_luot`), cất ở `sessionStorage`: tải lại cùng tab thì giữ
     (lượt được giữ nhờ phần "nhớ chỗ dở" bên dưới), tab mới hoặc Start over là lượt mới nên
     đồng hồ mới (đề xuất ở câu A-6). Máy chủ (`POST /api/quiz/price-hold`, `contracts.md`
     C13) là nguồn chính; bản cất ở trình duyệt là mốc tạm lúc chờ máy chủ và là chỗ rơi về
     khi máy chủ lỗi. Mốc lưu theo đồng hồ MÁY KHÁCH, đã bù lệch bằng `now` của máy chủ.
     --------------------------------------------------------------------------- */
  var GOI_GIU = { chu: '$4.90', so: '4.90', ma: 'map_report_490' };
  /* `ma` trùng `GOI_CAO.ma` của `quiz-giai-doan-1.js`: cùng variant `window.__msVariantCao`,
     nên số doanh thu theo gói không tách đôi một variant thành hai tên. */
  var GOI_SAU = { chu: '$19', so: '19.00', ma: 'map_report_5sol_19' };
  var GIU_GIA_MS = 10 * 60 * 1000;
  var KHOA_GIU_GIA = 'minespirit_giu_gia';
  var mocBoNho = null;   /* { luot, het } — khi `sessionStorage` không dùng được */

  function a1Luot() {
    try { return sessionStorage.getItem('minespirit_luot') || ''; } catch (e) { return ''; }
  }

  /* Mốc hết giờ (ms, đồng hồ máy khách) của ĐÚNG lượt đang chạy; `null` khi lượt này chưa
     vào màn 37. */
  function mocGiuGia() {
    var luot = a1Luot(), o = null;
    try { o = JSON.parse(sessionStorage.getItem(KHOA_GIU_GIA) || 'null'); } catch (e) {}
    if (!o) { o = mocBoNho; }
    return (o && o.luot === luot && typeof o.het === 'number') ? o.het : null;
  }

  function ghiMocGiuGia(het) {
    mocBoNho = { luot: a1Luot(), het: het };
    try { sessionStorage.setItem(KHOA_GIU_GIA, JSON.stringify(mocBoNho)); } catch (e) {}
  }

  function hetGiuGia() {
    var m = mocGiuGia();
    return m !== null && Date.now() >= m;
  }

  function goiHienTai() { return hetGiuGia() ? GOI_SAU : GOI_GIU; }
  function giaHienTai() { return goiHienTai().chu; }

  /* Chuỗi chép nguyên văn có chỗ giá thì ghi `{gia}` ở chỗ đó. */
  function a1Gia(chuoi) { return String(chuoi).split('{gia}').join(giaHienTai()); }

  /* Nhãn nút có giá (29/09/2026): chữ và giá là hai khúc không gãy, bỏ dấu "·" ngăn cách.
     Chữ luôn nằm một dòng (`gonNut()` hạ cỡ cho vừa); chỉ riêng khúc giá được xuống dòng 2
     khi không đủ chỗ. Nút dùng nhãn này phải mang lớp `cogia` (quiz-giai-doan-1.css). */
  function a1NutGia(en, vi) {
    return '<span class="nutchu">' + esc(A1(en, vi)) + '</span> ' +
           '<span class="nutgia">' + esc(giaHienTai()) + '</span>';
  }

  /* Cho `quiz-do-duong.js` gửi giá thật kèm `price_seen`. */
  window.__msGoiHienTai = function () { return goiHienTai(); };

  /* Ba ảnh của v7.9, đặt theo đúng dãy `qz-inline-NN.jpg` mà bundle đã dùng cho 17 ảnh trước
     (`quiz-inner-weather.js:16854`). Tên gốc ghi ngay đây vì tên `qz-inline-NN` không nói
     được ảnh nào là ảnh nào, mà nguồn thì nằm ngoài repo:
       18 ← `ref/3-NGUYEN-LIEU/1-anh/man01-anh-dau-trang.jpg`     · ảnh AI đầu màn 1
       19 ← `ref/3-NGUYEN-LIEU/1-anh/nhan-xet-Carol-M-man01.jpg`  · chân dung thẻ Carol M.
       20 ← `ref/3-NGUYEN-LIEU/1-anh/nhan-xet-Rosa-G-man13.jpg`   · chân dung thẻ Rosa G.
     Ảnh 18 KHÔNG mang nhãn "Illustration": chủ dự án chốt 20/09 sau khi nghe rủi ro. Đây là
     quyết định của chủ dự án, không phải chỗ để sửa lại. 19 và 20 (cùng 21, 22 ở màn 32) là
     chân dung bốn thẻ nhận xét. Chủ dự án chốt 21/09: dùng đúng bốn nhận xét, ảnh và video
     Debbie của `ref/3-NGUYEN-LIEU` ("đây là quyết định cuối cùng"), dù `ref/` K32 và K34 ghi
     chúng là mẫu do AI tạo. */
  var A1_ANH_DAU_TRANG = 'qz-inline-18.jpg';

  /* SÀN CHỮ CỦA THEME THẮNG MỌI LUẬT `p` Ở ĐÂY. `quiz-inner-weather.css` khai
     `.screen p{font-size:18px!important;line-height:1.62!important;color:#1E1733!important}`
     — một quyết định của cả dự án cho mắt 45–65+, không phải tai nạn. Mọi `<p>` bên dưới vì
     vậy chỉ khai `margin` / `font-weight` / `text-align`; khai `font-size` hay `color` cho
     chúng là viết luật chết, đọc lại tưởng có tác dụng. Chỗ duy nhất đi ngược là `.a1inter`,
     và nó đi LÊN 23px chứ không xuống — to hơn thì không hại ai. */
  var A1_STYLE = [
    /* màn 1 */
    '.a1kick{font-family:var(--sans);font-size:15px;font-weight:700;letter-spacing:.14em;',
      'text-transform:uppercase;color:var(--ink3);margin:0 0 6px}',
    '.a1hero{position:relative;margin:14px 0 0;border-radius:14px;overflow:hidden;height:210px}',
    '.a1hero img{width:100%;height:100%;object-fit:cover;object-position:center 36%;display:block}',
    '.a1peek{position:relative;margin:-26px 10px 0;background:#fff;border:1px solid var(--line);',
      'border-radius:14px;padding:12px 15px 13px;box-shadow:0 6px 20px rgba(30,23,51,.10)}',
    '.a1peek .a1pk{display:block;font-family:var(--sans);font-size:14px;letter-spacing:.11em;',
      'font-weight:700;color:var(--gold);margin-bottom:9px}',
    '.a1cols{display:flex;align-items:flex-end;gap:7px;height:64px;padding:0 2px;',
      'border-bottom:1px solid var(--line)}',
    '.a1cols i{flex:1;background:#D9D1EC;border-radius:5px 5px 0 0;position:relative}',
    '.a1cols i.lo{background:#C43D2E}',
    '.a1cols i b{position:absolute;top:-24px;left:50%;transform:translateX(-50%);font-size:19px;',
      'color:#C43D2E;font-style:normal;font-weight:700}',
    '.a1peek p{margin:10px 0 0;font-weight:600}',
    '.a1chips{display:flex;flex-wrap:wrap;gap:7px;margin:14px 0 4px}',
    '.a1chips span{font-family:var(--sans);font-size:14px;background:#fff;',
      'border:1px solid var(--line);border-radius:999px;padding:6px 12px;color:var(--ink2)}',
    '.a1proof{margin:14px 0 4px;padding:12px 14px;background:#F4EFFC;',
      'border-left:3px solid var(--gold);border-radius:10px}',
    '.a1proof p{margin:0}',
    '.a1proof b{color:var(--ink)}',
    '.a1proof small{display:block;margin-top:6px;font-size:14px;color:var(--ink3)}',
    '.a1forme{background:#fff;border:1px solid var(--line);border-radius:12px;padding:12px 15px;',
      'margin:14px 0}',
    '.a1forme b{display:block;font-size:17px;margin-bottom:6px}',
    '.a1forme div{font-size:17px;line-height:1.45;padding:5px 0 5px 18px;position:relative;',
      'color:var(--ink2)}',
    '.a1forme div::before{content:"\\00B7";position:absolute;left:5px;font-weight:700;',
      'color:var(--gold)}',
    '.a1price{text-align:center;margin:10px 0 0}',
    /* thẻ nhận xét — dùng chung bốn thẻ: màn 1, màn xen thứ hai, hai thẻ màn 32 */
    '.a1rv{background:#fff;border:1px solid var(--line);border-radius:12px;padding:12px 15px;',
      'margin:14px 0;text-align:left}',
    /* Màn xen dựng trong `.mid.center`, mà theme khai `.mid.center *{text-align:center
       !important}` (0,2,0) — thẻ nhận xét ở đó phải thắng bằng (0,3,0). */
    '.mid.center .a1rv,.mid.center .a1rv *{text-align:left!important}',
    '.a1rvhd{display:flex;gap:10px;align-items:center;margin-bottom:7px}',
    '.a1rvhd img{width:48px;height:48px;border-radius:50%;object-fit:cover;flex:0 0 48px}',
    '.a1rvhd b{display:block;font-size:17px}',
    '.a1rvhd span{font-size:14px;color:var(--ink3)}',
    '.a1stars{display:flex;gap:3px}',
    '.a1stars svg{width:18px;height:18px;fill:#E8A33D;display:block;flex:none}',
    '.a1stars svg.off{fill:#D9D4CC}',
    '.a1rvmeta{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:3px 0}',
    '.a1rvago{font-size:14px;color:var(--ink3)}',
    '.a1rvok{font-size:14px;font-weight:700;color:#2E7D4F;margin:3px 0 7px}',
    '.a1rvt{display:block;font-size:17px;color:var(--ink);margin:3px 0 0}',
    '.a1rv p{margin:7px 0}',
    '.a1rvhelp{display:flex;justify-content:space-between;font-size:14px;color:var(--ink3);',
      'border-top:1px solid var(--line);padding-top:8px;margin-top:9px}',
    /* khung chờ nhận xét: phải NHÌN RA
       là chỗ chừa, không phải thẻ vỡ */
    '.a1rv.a1rvcho{border:2px dashed var(--line);background:#F7F4EE;padding:26px 18px;',
      'text-align:center}',
    '.a1rvcho span{display:block;font-family:var(--sans);font-size:15px;letter-spacing:.1em;',
      'text-transform:uppercase;font-weight:700;color:var(--ink3);margin-bottom:7px}',
    '.a1rvcho em{display:block;font-style:normal;font-size:17px;line-height:1.45;',
      'color:var(--ink2)}',
    /* màn 2 */
    '.a1body{margin:10px 0}',
    '.a1bars{display:flex;align-items:flex-end;gap:8px;height:120px;margin:18px 0 6px;padding:0 10px}',
    '.a1bars i{flex:1;background:#D9D2EA;border-radius:6px 6px 0 0}',
    '.a1bars i.low{background:#C43D2E;outline:3px solid #F5C6BF;outline-offset:2px}',
    /* màn câu hỏi */
    '.a1prog{height:7px;background:#E6E0F2;border-radius:4px;margin:8px 0 14px}',
    '.a1prog i{display:block;height:100%;background:var(--gold);border-radius:4px;',
      'transition:width .2s ease}',
    '.a1hint{margin:0 0 12px}',
    '.a1back{display:block;margin:8px auto 0;background:none;border:0;color:var(--ink3);',
      'font-size:16px;text-decoration:underline;cursor:pointer;min-height:44px}',
    /* màn xen — ba khoá phải `!important`: `.screen p` của bundle
       (`quiz-inner-weather.css`) khai `font-size:18px!important;color:#1E1733!important` và
       `.gd1-*` khai lại `font-family`, nên không có `!important` thì màn xen tụt về chữ thân
       bài. Màn xen là nhịp NGHỈ giữa các câu: nó phải khác chữ câu hỏi thì mới làm được việc
       của nó. Đo 21/09: `.a1inter` một mình (0,1,0) THUA `.screen p` (0,1,1) dù có
       `!important` — phải viết `.screen p.a1inter` (0,2,1) mới thắng. */
    '.screen p.a1inter{font-family:var(--serif)!important;font-size:23px!important;',
      'line-height:1.35!important;color:var(--gold)!important;margin:0 auto;max-width:22em}'
  ].join('');

  (function a1NapStyle() {
    var el = document.createElement('style');
    el.id = 'ms-a1a2-style';
    el.textContent = A1_STYLE;
    document.head.appendChild(el);
  })();

  /* Thanh trên KHÔNG có nút loa: v7.9 bỏ âm thanh, mà `langbar()` của bundle gói cả `#sndb`
     nên phải tự dựng phần này. Nút EN/VI cũng BỎ (A3, 22/09): khách Mỹ chỉ thấy `‹` và
     MineSpirit. Bản VI để đội nhà duyệt chữ mở bằng `?lang=vi` trên URL. Bên phải đặt một ô
     rỗng rộng bằng nút `‹` để logo vẫn nằm giữa. `bindShell()` không thấy `#lgen`/`#lgvi`
     thì bỏ qua, không lỗi.

     `#back` chỉ được xuất hiện MỘT lần trên màn: `bindShell()` gọi `getElementById('back')`
     nên hai thẻ cùng id là thẻ thứ hai không bao giờ bấm được. Màn câu hỏi có liên kết Back
     dưới nút Continue, nên ở đó gọi `a1Topbar(false)`. */
  function a1Topbar(coBack) {
    return '<div class="topbar">' +
        (coBack
          ? '<button class="back" id="back" aria-label="' + esc(A1('Go back', 'Quay lại')) + '">‹</button>'
          : '<div style="width:38px"></div>') +
        '<div class="spacer"></div><div class="brandmark">MineSpirit</div><div class="spacer"></div>' +
        '<div style="width:38px"></div>' +
      '</div>';
  }

  /* `n` là số sao người đó THẬT SỰ chấm — không có số mặc định. */
  function a1Sao(n) {
    var sao = '', i;
    for (i = 1; i <= 5; i++) {
      sao += '<svg viewBox="0 0 24 24" aria-hidden="true"' + (i > n ? ' class="off"' : '') +
        '><path d="M12 2.2l2.95 6.2 6.55.9-4.75 4.6 1.15 6.6L12 17.4l-5.9 3.1 1.15-6.6L2.5' +
        ' 9.3l6.55-.9z"/></svg>';
    }
    return '<div class="a1stars" role="img" aria-label="' +
      esc(A1('Rated ' + n + ' out of 5', 'Đánh giá ' + n + ' trên 5')) + '">' + sao + '</div>';
  }

  /* BỐN THẺ NHẬN XÉT, MỘT KHUÔN — màn 1, màn xen thứ hai, hai thẻ màn 32.

     Mỗi nhãn là một lời khẳng định: sao nói "người này đã chấm", "Verified purchase" nói
     "người này đã mua", "Helpful (n)" nói "n người đã bấm", ngày nói "đăng lúc đó". FTC
     16 CFR Part 465 cấm lời chứng thực của người không có thật hoặc chưa dùng sản phẩm, nên
     phần nào cũng chỉ vào DOM khi có trường dữ liệu thật đứng sau (`ref/` K34). Thiếu trường
     là KHÔNG in — không in rồi giấu bằng CSS: chữ còn trong HTML là vẫn phát hành.

     Chủ dự án chốt 21/09: bốn thẻ mang đúng chữ, nhãn và ảnh của
     `ref/3-NGUYEN-LIEU/3-chu-tung-man` — quyết định của chủ dự án, không phải chỗ để sửa lại.
     Khung chờ `cho` vẫn giữ cho thẻ nào sau này chưa có dữ liệu; CHUỖI CHỜ NẰM Ở CHỖ KHAI DỮ
     LIỆU, không nằm trong hàm này, để cổng chặn đóng gói đỏ đúng chỗ.

     Object của một nhận xét thật — trường nào vắng thì phần đó không in:
       ten, noi, anh      tên, nơi ở, ảnh — chỉ khi người đó đồng ý cho dùng
       daMua              nhãn "Verified purchase · Reading $4.90"
       daLam              nhãn "Verified · took the quiz"
       sao                số sao người đó thật sự chấm, 1–5
       ngayEn, ngayVi     ngày đăng từ hệ thống thật, ghi tuyệt đối ("Sep 12, 2026") — chuỗi
                          tương đối viết cứng ("2 days ago") sai sau hai ngày
       giupIch            số "Helpful" từ hệ thống thật
       tieuDeEn, tieuDeVi, chuEn, chuVi    nguyên văn người đó viết */
  function a1TheNhanXet(p) {
    if (p.cho) {
      return '<div class="a1rv a1rvcho" ' + p.cho + '>' +
          '<span>' + esc(A1('REVIEW TO COME', 'CHỖ CHỜ NHẬN XÉT')) + '</span>' +
          '<em>' + esc(A1(
            'A reader’s review will go here once a real customer has agreed to share it.',
            'Nhận xét của một người đọc sẽ nằm ở đây khi có khách thật đồng ý chia sẻ.')) + '</em>' +
        '</div>';
    }
    var meta = (p.sao ? a1Sao(p.sao) : '') +
      (p.ngayEn ? '<span class="a1rvago">' + esc(A1(p.ngayEn, p.ngayVi)) + '</span>' : '');
    return '<div class="a1rv">' +
        (p.ten ? '<div class="a1rvhd">' +
          (p.anh ? '<img src="' + a1Anh(p.anh) + '" alt="" loading="lazy" decoding="async">' : '') +
          '<div><b>' + esc(p.ten) + '</b>' + (p.noi ? '<span>' + esc(p.noi) + '</span>' : '') +
          '</div></div>' : '') +
        (meta ? '<div class="a1rvmeta">' + meta + '</div>' : '') +
        (p.daMua ? '<div class="a1rvok">✓ ' +
          esc(A1('Verified purchase · Reading $4.90', 'Đã mua · Bản đọc $4.90')) + '</div>' :
          p.daLam ? '<div class="a1rvok">✓ ' +
          esc(A1('Verified · took the quiz', 'Đã xác minh · đã làm quiz')) + '</div>' : '') +
        (p.tieuDeEn ? '<b class="a1rvt">' + esc(A1(p.tieuDeEn, p.tieuDeVi)) + '</b>' : '') +
        '<p>' + esc(A1(p.chuEn, p.chuVi)) + '</p>' +
        (typeof p.giupIch === 'number' ? '<div class="a1rvhelp"><span>👍 ' +
          esc(A1('Helpful', 'Hữu ích')) + ' (' + p.giupIch + ')</span>' +
          '<span>' + esc(A1('Report', 'Báo cáo')) + '</span></div>' : '') +
      '</div>';
  }

  var A1_NX_MAN01 = {
    anh: 'qz-inline-19.jpg',
    ten: 'Carol M.', noi: 'Knoxville, Tennessee',
    sao: 5, ngayEn: '2 days ago', ngayVi: '2 ngày trước', daLam: true,
    tieuDeEn: 'Didn’t expect questions this specific',
    tieuDeVi: 'Không ngờ câu hỏi sát đến vậy',
    chuEn: '“The questions asked about the everyday things I do for others and whether I have time left for myself.”',
    chuVi: '“Các câu hỏi hỏi về những việc hằng ngày tôi làm cho người khác và liệu tôi còn thời gian cho mình không.”',
    giupIch: 14
  };
  var A1_NX_MAN13 = {
    anh: 'qz-inline-20.jpg',
    ten: 'Rosa G.', noi: 'San Antonio, Texas',
    sao: 5, ngayEn: '5 days ago', ngayVi: '5 ngày trước', daLam: true,
    tieuDeEn: 'That one question stopped me',
    tieuDeVi: 'Câu hỏi đó làm tôi khựng lại',
    chuEn: '“The question about agreeing to more than I wanted to do made me stop and think.”',
    chuVi: '“Câu hỏi về việc nhận thêm việc dù không muốn khiến tôi dừng lại suy nghĩ.”',
    giupIch: 9
  };

  /* ---------------------------------------------------------------------------
     MÀN 1 · intro

     Bỏ so với bản đang chạy: "THE 7-DAY RESET", "7-day plan", "first step tonight",
     "7 areas checked", quả cầu `.moonart`, nút loa. Giữ nút EN/VI.
     Cột thứ 4 của thẻ xem trước là cột ĐỎ mang dấu "?" — đó chính là lời hứa của màn 1: một
     trong bảy vùng đang rút cạn khách TRƯỚC, và cuối quiz khách biết vùng nào. Bảy chiều cao
     là hình trang trí cố định, không phải điểm của ai.
     --------------------------------------------------------------------------- */
  var A1_COT_XEM_TRUOC = [62, 48, 71, 25, 55, 80, 40];
  var A1_COT_DO = 3;

  RENDER.intro = function () {
    var cot = '', i;
    for (i = 0; i < A1_COT_XEM_TRUOC.length; i++) {
      cot += '<i class="' + (i === A1_COT_DO ? 'lo' : '') + '" style="height:' +
        A1_COT_XEM_TRUOC[i] + '%">' + (i === A1_COT_DO ? '<b>?</b>' : '') + '</i>';
    }
    var chip = [
      A1('7-min quiz', 'Quiz 7 phút'),
      A1('A reading of 7 areas of your life', 'Bản đọc 7 vùng trong đời bạn'),
      A1('Private, no account', 'Riêng tư, không cần tài khoản')
    ];
    var choBan = [
      A1('You sleep and still wake up tired, and you do not know why.',
         'Bạn ngủ rồi vẫn thấy mệt, mà không rõ vì sao.'),
      A1('You are looking after other people more than anyone notices.',
         'Bạn đang lo cho người khác nhiều hơn những gì người ta nhìn thấy.'),
      A1('You have tried several things and everything stayed the same.',
         'Bạn đã thử vài cách rồi mà mọi thứ vẫn như cũ.')
    ];
    return {
      html: a1Topbar(false) +
        '<div class="mid">' +
          '<div class="a1kick">' +
            esc(A1('7 AREAS · ONE READING', '7 VÙNG · MỘT BẢN ĐỌC')) + '</div>' +
          '<h1 class="big">' + esc(A1(
            'Understand what is really draining your energy, and get yourself back.',
            'Hiểu điều gì thật sự đang rút cạn năng lượng của bạn, và tìm lại chính mình.')) + '</h1>' +
          '<p class="sub">' + esc(A1(
            'Understand yourself better, and know what to expect next.',
            'Hiểu rõ hơn về bản thân, và biết điều gì đang chờ phía trước.')) + '</p>' +
          '<div class="a1hero"><img src="' + a1Anh(A1_ANH_DAU_TRANG) +
            '" alt="" loading="lazy" decoding="async"></div>' +
          '<div class="a1peek">' +
            /* 29/09/2026: bỏ hai chữ "FREE"/"Free:" trong thẻ này — chuyện miễn phí và trả phí
               nay nói gọn ở MỘT chỗ, dòng dưới nút Start (mục 2 yêu cầu của chủ dự án). */
            '<span class="a1pk">' + esc(A1('WHAT YOU SEE AT THE END',
              'CUỐI QUIZ BẠN THẤY')) + '</span>' +
            '<div class="a1cols">' + cot + '</div>' +
            '<p>' + esc(A1(
              'One of these 7 areas is draining you first. Which one? Your summary shows your lowest area and its score.',
              'Một trong 7 vùng này đang rút cạn bạn trước. Vùng nào? Bản tóm tắt cho bạn thấy vùng thấp nhất và điểm của nó.')) + '</p>' +
          '</div>' +
          '<div class="a1chips"><span>' + chip.map(esc).join('</span><span>') + '</span></div>' +
          '<div class="a1proof">' +
            '<p>' + esc(A1(
              '6 in 10 people who finished this quiz told us the same thing:',
              '6 trong 10 người làm xong quiz này nói cùng một điều:')) + ' <b>' + esc(A1(
              '“My head keeps running through unfinished things even when my body wants to rest.”',
              '“Tôi cứ nghĩ mãi về những việc chưa xong dù cơ thể đã muốn nghỉ.”')) + '</b></p>' +
            '<small>' + esc(A1('People in the U.S. who took this quiz, September 2026.',
              'Người ở Mỹ đã làm quiz này, tháng 9/2026.')) + '</small>' +
          '</div>' +
          '<div class="a1forme"><b>' +
            esc(A1('This quiz is for you if…', 'Quiz này dành cho bạn, nếu…')) + '</b>' +
            '<div>' + choBan.map(esc).join('</div><div>') + '</div></div>' +
          a1TheNhanXet(A1_NX_MAN01) +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Start the quiz', 'Bắt đầu quiz')) + '</button>' +
          /* 29/09/2026: miễn phí là chính, bản đọc trả phí là TUỲ CHỌN — tách hai ý để khách
             không đọc nhầm thành "quiz mất {gia}". Trùng chữ với `introTiny`
             (quiz-giai-doan-1.js) và bản chờ trong sections/quiz-inner-weather.liquid. */
          '<p class="a1price">' + esc(A1('Free: your type and what drains you most.',
            'Miễn phí: kiểu người của bạn và điều rút cạn bạn nhất.')) + '<br>' +
            esc(a1Gia(A1('Full reading optional ({gia}).',
            'Bản đọc đầy đủ tuỳ chọn ({gia}).'))) + '</p></div>',
      bind: function () { $('go').onclick = function () { sfx('tap'); next(); }; }
    };
  };

  /* Cờ cho `quiz-giai-doan-1.js` (thẻ #6) biết màn 1 đã có bản v7.9 và ĐỪNG gán đè.
     File đó nạp SAU file này và vẫn khai `RENDER.intro` của bản 7-DAY RESET; đo 21/09 trên
     theme development: không có cờ thì `RENDER.intro.toString()` trả về bản của nó và màn 1
     in lại đúng ba chuỗi phase 19 phải bỏ. Cắm ở ĐÂY, ngay sau khi hàm đã gán, không cắm ở
     đầu file: overlay thoát sớm khi snapshot vắng, và khi đó bản dự phòng bên kia phải chạy.
     Cờ riêng, không dùng chung `__msManA0`: A0 gác `SCREENS`, A1 gác `RENDER.intro`. */
  window.__msMan19 = true;

  /* ---------------------------------------------------------------------------
     MÀN 2 · reframe — màn thấu hiểu, đứng TRƯỚC câu 1

     Màn này KHÔNG nhận dữ liệu của khách, nên nó chỉ có `screen_viewed` chứ không có
     `answered`. Đó là ĐÚNG, không phải thiếu: `quiz-do-duong.js:265` chỉ bắn `answered` cho
     8 kiểu màn nhập, và `reframe` không nằm trong đó vì nó không có gì để nhập.
     --------------------------------------------------------------------------- */
  var A1_COT_REFRAME = [70, 62, 58, 30, 66, 74, 60];

  RENDER.reframe = function () {
    var cot = '', i;
    for (i = 0; i < A1_COT_REFRAME.length; i++) {
      cot += '<i class="' + (i === A1_COT_DO ? 'low' : '') + '" style="height:' +
        A1_COT_REFRAME[i] + '%"></i>';
    }
    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          '<h1 class="big">' +
            esc(A1('You are not short on effort.', 'Bạn không thiếu cố gắng.')) + '</h1>' +
          '<p class="a1body">' + esc(A1(
            'You need someone to see how much you are carrying, and a chance to rest from it. Most of us try the familiar fixes: push harder, plan better, try again. But one area of your life may be draining far more of your energy than the others. Until you know which one, even a month of trying changes very little. The next 7 minutes show you where to start.',
            'Bạn cần một người nhận ra mình đang gánh vác bao nhiêu, và một lúc được nghỉ khỏi những việc đó. Phần lớn chúng ta thử những cách quen thuộc: cố hơn, sắp xếp tốt hơn, thử lại. Nhưng có thể một vùng trong cuộc sống đang rút cạn sức của bạn nhiều hơn hẳn những vùng khác. Chưa biết đó là vùng nào thì cố cả tháng cũng đổi được rất ít. 7 phút tới cho bạn biết nên bắt đầu từ đâu.')) + '</p>' +
          '<div class="a1bars">' + cot + '</div>' +
          '<p class="tiny">' + esc(A1(
            'The quiz looks at 7 areas of everyday life and finds the one taking the most energy from you.',
            'Quiz xem 7 vùng trong đời sống hằng ngày và tìm ra vùng đang lấy nhiều năng lượng của bạn nhất.')) + '</p>' +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Show me what is draining me', 'Xem điều gì đang rút cạn tôi')) + '</button></div>',
      bind: function () { $('go').onclick = function () { sfx('tap'); next(); }; }
    };
  };

  /* ---------------------------------------------------------------------------
     21 MÀN CÂU HỎI · q7duo

     `n` đếm theo VỊ TRÍ CÂU TRONG LUỒNG, không theo mã câu: câu đầu là Q16 nhưng nhãn phải là
     "QUESTION 1 OF 21". Đếm bằng cách duyệt `SCREENS` tới màn đang hiện — mảng đó là nguồn duy
     nhất của thứ tự (khối trên vừa dựng nó), nên nhãn không thể lệch khỏi luồng thật. Tổng
     cũng đếm từ `SCREENS`, không viết cứng 21: thêm hay bớt câu trong DB là nhãn tự đúng.

     KHÔNG hiện tên vùng nữa. `v6dTierBar` cũ in "1 / 7 · GROUND & REST" cộng bảy dấu tầng có
     `title` là tên vùng; v7.9 bỏ cả hai. Dữ liệu `tier` vẫn nằm trong `QUIZ7.questions` — bộ
     chấm điểm cần nó — chỉ là không vẽ ra màn.

     Giữ nguyên hành vi tự sang câu sau sau 0,22 giây khi khách chạm một lựa chọn; nút Continue
     là đường thứ hai cho khách muốn đọc lại trước khi đi. `timers` là mảng của bundle,
     `clearTimers()` trong `goto` dọn nó — nên bấm Back giữa lúc chờ không nhảy hai màn.
     --------------------------------------------------------------------------- */
  var A1_CHO_SANG_MAN = 220;

  /* Nút Continue phải NHÌN RA là đang mờ, không chỉ mang thuộc tính `disabled`.

     Đo 21/09 trên theme dev: `button[disabled]{opacity:1!important}`
     (`quiz-inner-weather.css:2011`) đã đè luật `.btn[disabled]{opacity:.34}` (:195) của chính
     nó, RỒI `markCTA` (`quiz-lop-hanh-vi-v3.js:119`) tô nút cuối trong `.foot` thành xanh CTA
     bằng style ĐẶT THẲNG TRÊN PHẦN TỬ kèm `!important` — mà không xét `disabled`. Kết quả:
     nút chết trông y hệt nút sống, ngay ở câu 1 của phễu trả tiền.

     Style đặt thẳng trên phần tử là bậc cao nhất của cascade, nên chỉ có cách đặt thẳng mới
     thắng được. Dùng `opacity` chứ không dùng `background`: `markCTA` gỡ đúng ba khoá
     `background` / `background-image` / `color` mỗi lần chạy lại, `opacity` thì không, nên vá
     này sống qua mọi lần nó quét — không phụ thuộc thứ tự hai lớp chạy. */
  var A1_MO_NUT = '.42';

  function a1TrangThaiNut(go, coChon) {
    if (!go) { return; }
    go.disabled = !coChon;
    if (coChon) { go.style.removeProperty('opacity'); }
    else { go.style.setProperty('opacity', A1_MO_NUT, 'important'); }
  }

  /* Vị trí câu hỏi trong luồng, 1-based, tính tới và gồm cả màn `iMan`. */
  function a1SoCau(iMan) {
    var n = 0, i;
    for (i = 0; i <= iMan && i < SCREENS.length; i++) {
      if (SCREENS[i].t === 'q7duo') { n++; }
    }
    return n;
  }

  function a1TongCau() {
    var n = 0, i;
    for (i = 0; i < SCREENS.length; i++) { if (SCREENS[i].t === 'q7duo') { n++; } }
    return n;
  }

  RENDER.q7duo = function (s) {
    var it = s.items && s.items[0];
    var D = (it && it.q !== undefined) ? QUIZ7.questions[it.q] : (it ? QUIZ7[it.p] : null);
    if (!D) { return { html: a1Topbar(cur > 0) + '<div class="mid"></div>' }; }
    var leaf = isVI() ? D.vi : D.en;
    var n = a1SoCau(cur), tong = a1TongCau();
    var daChon = state.q7[D.id];
    var coChon = (daChon !== undefined && daChon !== null);
    var nut = leaf.opts.map(function (o, i) {
      return '<button class="pill' + (daChon === i ? ' sel' : '') + '" data-i="' + i + '">' +
        esc(fill(o)) + '</button>';
    }).join('');

    return {
      html: a1Topbar(false) +
        '<div class="mid duo solo">' +
          '<div class="a1kick" data-qlabel>' +
            esc(A1('QUESTION ' + n + ' OF ' + tong, 'CÂU ' + n + ' / ' + tong)) + '</div>' +
          '<div class="a1prog"><i style="width:' + (tong ? n / tong * 100 : 0) + '%"></i></div>' +
          '<div class="askblk" data-qid="' + esc(D.id) + '">' +
            '<h2 class="q-title askq">' + esc(fill(leaf.q || leaf.title)) + '</h2>' +
            '<p class="a1hint">' + esc(A1('How true is this for you?',
              'Điều này đúng với bạn đến mức nào?')) + '</p>' +
            '<div class="opts">' + nut + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="foot"><button class="btn" id="go"' + (coChon ? '' : ' disabled') + '>' +
          esc(A1('Continue', 'Tiếp tục')) + '</button>' +
          '<button class="a1back" id="back">' + esc(A1('Back', 'Quay lại')) + '</button></div>',
      bind: function () {
        var els = document.querySelectorAll('.askblk .pill'), go = $('go');
        a1TrangThaiNut(go, coChon);
        Array.prototype.forEach.call(els, function (el) {
          el.onclick = function () {
            if (busy) { return; }
            sfx('tap');
            Array.prototype.forEach.call(els, function (e) { e.classList.remove('sel'); });
            el.classList.add('sel');
            state.q7[D.id] = +el.getAttribute('data-i');
            a1TrangThaiNut(go, true);
            timers.push(setTimeout(next, A1_CHO_SANG_MAN));
          };
        });
        if (go) { go.onclick = function () { if (!go.disabled) { sfx('tap'); next(); } }; }
      }
    };
  };

  /* ---------------------------------------------------------------------------
     BA MÀN XEN · inter

     Màn xen thứ hai ĐỔI CHỮ theo câu trả lời: nếu khách chọn mức nặng ở ÍT HƠN 3 trong 9 câu
     đầu thì lời hứa "câu trả lời đang cho thấy vùng nào" là nói quá, chưa đủ dữ liệu để hứa.
     Mức "nặng" đọc theo CHIỀU câu: câu tiêu cực nặng khi khách chọn vị trí ≥ 3, câu tích cực
     nặng khi chọn vị trí ≤ 1. Chiều lấy từ `ramp` mà khối trên đặt từ `positive` của snapshot,
     không viết cứng danh sách mã câu vào đây.

     Màn xen thứ ba ghi "6 of the 21" — đúng số câu còn lại sau câu 15. Bản đang chạy ghi
     "Four more" khi còn 12 câu, đó là lỗi đang sống và đây là chỗ sửa nó.
     --------------------------------------------------------------------------- */
  var A1_NGUONG_NANG = 3;
  var A1_SO_CAU_XET = 9;

  function a1DemCauNang() {
    var dem = 0, i, q, v;
    for (i = 0; i < A1_SO_CAU_XET && i < QUIZ7.questions.length; i++) {
      q = QUIZ7.questions[i];
      v = state.q7[q.id];
      if (v === undefined || v === null) { continue; }
      if (q.ramp === 'linearRev' ? (v <= 1) : (v >= 3)) { dem++; }
    }
    return dem;
  }

  function a1ChuManXen(ii) {
    if (ii === 0) {
      return A1(
        'There are no right or wrong answers here. Every answer is taken into account. We use the same scoring rules for everyone’s answers.',
        'Không có câu trả lời đúng hay sai ở đây. Mọi câu trả lời đều được ghi nhận. Chúng tôi dùng cùng quy tắc chấm điểm cho câu trả lời của mọi người.');
    }
    if (ii === 1) {
      if (a1DemCauNang() < A1_NGUONG_NANG) {
        return A1(
          'Your answers are building the picture. Keep choosing what feels true for you.',
          'Câu trả lời đang dựng nên bức tranh về bạn. Cứ chọn điều bạn thấy đúng với mình.');
      }
      return A1(
        'You can be worn out and no one notices. Your answers are showing which area of your life needs attention first. You will see it in a few minutes.',
        'Bạn có thể rất mệt mà không ai nhận ra. Câu trả lời của bạn đang cho thấy vùng nào trong đời cần được quan tâm trước. Vài phút nữa bạn sẽ thấy.');
    }
    return A1(
      'You have 6 of the 21 questions left. After that, a few short questions help make your reading more personal. The full reading cites research on everyday life, including sleep and loneliness.',
      'Bạn còn 6 trong 21 câu. Sau đó là vài câu ngắn giúp bản đọc sát với hoàn cảnh của bạn hơn. Bản đọc đầy đủ dẫn nghiên cứu về đời sống hằng ngày, gồm giấc ngủ và sự cô đơn.');
  }

  RENDER.inter = function (s) {
    var ii = s.ii || 0;
    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid center">' +
          '<p class="a1inter">' + esc(a1ChuManXen(ii)) + '</p>' +
          (ii === 1 ? a1TheNhanXet(A1_NX_MAN13) : '') +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Continue', 'Tiếp tục')) + '</button></div>',
      bind: function () { $('go').onclick = function () { sfx('tap'); next(); }; }
    };
  };

  /* ---------------------------------------------------------------------------
     A3 (phase 21) · BỐN MÀN CHỌN NHIỀU · màn 27 → 30

     `RENDER.multi7` vẽ CẢ BỐN màn: ba màn "A LITTLE MORE ABOUT YOU" mang nhãn tiến độ và
     màn 30 "ONE OPTIONAL QUESTION". Một kiểu màn cho cả bốn là RÀNG BUỘC, không phải lựa
     chọn: `quiz-do-duong.js:265` chỉ bắn `answered` cho 8 kiểu trong `MAN_NHAP`, nên một
     kiểu màn riêng cho màn 30 là màn đó chỉ còn `screen_viewed` và mất `answered` vĩnh viễn
     (`contracts.md` C5).

     GIỚI HẠN VÀ SỐ LỰA CHỌN ĐẾN TỪ SNAPSHOT, không viết cứng ở đây. Khối A0 bên trên đã
     đổ `max_select` → `M.max` và `min_select` → `M.min`; chữ "Choose up to N." cũng do khối
     đó ghép từ `max_select`. Viết cứng 3/2/3/2 ở đây là dựng nguồn thứ hai mà
     `bin/q3_sinh_bo_de.py --kiem` không bắt được.

     BỐN MÀN ĐỀU CÓ SKIP. `min_select = 0` ở cả bốn (`ref/` §284, §335, §754, §871). Nút
     Continue mờ khi chưa chọn; Skip là đường đi tiếp mà không chọn gì. Ca "chọn 2 ô, bỏ
     chọn cả 2, rồi bấm Skip" phải đi tiếp sạch — vì vậy Skip GHI `[]` chứ không để
     `undefined`: mảng rỗng qua được `Array.isArray(v) && v.every(laSo)` của
     `quiz-goi-api.js:186` nên nó vẫn lên máy chủ, và `giaTriRong([])` là `false` nên
     `answered` vẫn bắn. Để `undefined` là màn này lẫn với màn khách chưa bao giờ tới.

     CHỮ CÂU HỎI VÀ CHỮ LỰA CHỌN KHÔNG NẰM Ở ĐÂY — chúng đến từ snapshot. Màn 27 còn hiện
     "nobody counts it" nghĩa là lỗi ở SEED, không phải ở khung này.
     --------------------------------------------------------------------------- */

  /* Màn tuỳ chọn là màn multi CUỐI trong snapshot (`fear`, `ord` 24); ba màn trước nó mang
     nhãn tiến độ "n / 3". Đếm từ `QUIZ7.multi.length` chứ không viết cứng số 3: thêm hay
     bớt một câu multi trong DB là nhãn tự đúng. */
  function a3SoManDanhSo() { return Math.max(0, QUIZ7.multi.length - 1); }

  /* Ô đã đủ giới hạn thì các ô CHƯA chọn mờ đi. Hai điều KHÔNG dùng được ở đây:

     `disabled` — `quiz-inner-weather.css:2011` khai `button[disabled]{opacity:1!important}`
     nên nút chết trông y hệt nút sống. Đúng cái bẫy phase 19 đã vấp ở nút Continue.

     `opacity` — `quiz-lop-hanh-vi-v3.js:216` là lưới an toàn tương phản: nó quét MỌI phần
     tử có chữ riêng trong `#scr`, và với phần tử nền SÁNG nó leo ngược lên cây gỡ hết độ mờ
     kế thừa bằng `setProperty('opacity','1','important')`. `.chk` nền trắng và mang chữ, nên
     `opacity` của nó bị xoá sạch — đo 21/09 trên theme dev: class `a3mo` có mặt, mà
     `getComputedStyle(...).opacity` trả `1` và `style.opacity` trả `1`. Nút Continue thoát
     được vì nền nó XANH ĐẬM, lớp kia thấy `_lum(bg) < 0.4` thì bỏ qua từ đầu.

     `filter:opacity()` cho đúng cái nhìn thấy mà lớp kia không đụng tới: nó chỉ trả lại
     thuộc tính `opacity` và đặt `color`, không sờ `filter`. Và vì `filter` không làm đổi
     `color` tính toán, phép đo tương phản của nó vẫn đạt nên nó cũng không tô lại chữ. */
  var A3_STYLE = [
    '.opts .chk.a3mo{filter:opacity(.45)}',
    '.a3sub{margin:0 0 16px}',
    '.screen p.a3k25{font-family:var(--serif)!important;font-size:19px!important;',
      'line-height:1.4!important;color:var(--gold)!important;margin:14px 0 0;',
      'padding:11px 14px;background:#F4EFFC;border-left:3px solid var(--gold);border-radius:10px}',
    '.a3skip{display:block;margin:8px auto 0;background:none;border:0;color:var(--ink3);',
      'font-size:16px;text-decoration:underline;cursor:pointer;min-height:44px}'
  ].join('');

  (function a3NapStyle() {
    var el = document.createElement('style');
    el.id = 'ms-a3-style';
    el.textContent = A3_STYLE;
    document.head.appendChild(el);
  })();

  RENDER.multi7 = function (s) {
    var M = QUIZ7.multi[s.mi], leaf = isVI() ? M.vi : M.en;
    var danhSo = a3SoManDanhSo();
    var tuyChon = (s.mi >= danhSo);
    /* Dòng "word for word" đứng ở màn chọn nhiều CUỐI CÙNG trong nhóm đánh số (màn 29,
       `M-B` — câu "unsaid sentence"), theo `ref/` §"Màn 29". */
    var coK25 = (!tuyChon && s.mi === danhSo - 1);

    var kick = tuyChon
      ? A1('ONE OPTIONAL QUESTION', 'MỘT CÂU TUỲ CHỌN')
      : A1('A LITTLE MORE ABOUT YOU · ' + (s.mi + 1) + ' / ' + danhSo,
           'THÊM MỘT CHÚT VỀ BẠN · ' + (s.mi + 1) + ' / ' + danhSo);

    var daChon = state.q7[M.id];
    if (!Array.isArray(daChon)) { daChon = []; }
    var coChon = function (i) { return daChon.indexOf(i) > -1; };

    var list = leaf.opts.map(function (o, i) {
      var rieng = (i === M.exclusiveOpt);
      return '<button class="chk' + (coChon(i) ? ' on' : '') + '" data-i="' + i + '"' +
        (rieng ? ' data-none="1"' : '') + ' aria-pressed="' + (coChon(i) ? 'true' : 'false') + '">' +
        /* Bỏ ô `.ico` (dấu "·" / "—" chép từ khe emoji của bundle) theo yêu cầu 29/09/2026:
           khách đọc nó thành dấu chấm lạc ở đầu mỗi lựa chọn. */
        '<span class="txt">' + esc(fill(o)) + '</span>' +
        '<span class="box">✓</span></button>';
    }).join('');

    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          '<div class="a1kick">' + esc(kick) + '</div>' +
          '<h1 class="q-title">' + esc(fill(leaf.title)) + '</h1>' +
          '<p class="a3sub">' + esc(fill(leaf.sub)) + '</p>' +
          '<div class="opts" id="opts">' + list + '</div>' +
          /* Lời hứa NGUYÊN VĂN sang bản đọc. `ref/` K25 ghi phía sản phẩm chưa có chỗ chèn
             câu khách chọn vào bản đọc, nên khối mang `data-cho-kiem="K25"`: cơ chế chặn
             đóng gói của phase 38b nắm được nó. Ẩn hay không là quyết định của đợt sau. */
          (coK25 ? '<p class="a3k25" id="k25" data-cho-kiem="K25" hidden>' + esc(A1(
            'We have written down the sentences you chose. Your reading will include them word for word.',
            'Chúng tôi đã ghi lại những câu bạn chọn. Bản đọc sẽ giữ nguyên văn những câu đó.')) +
            '</p>' : '') +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Continue', 'Tiếp tục')) + '</button>' +
          '<button class="a3skip" id="skip">' + esc(A1('Skip', 'Bỏ qua')) + '</button></div>',
      bind: function () {
        var els = $('opts').querySelectorAll('.chk'), go = $('go'), k25 = $('k25');

        function dangChon() {
          var sel = [];
          Array.prototype.forEach.call(els, function (e) {
            if (e.classList.contains('on')) { sel.push(+e.getAttribute('data-i')); }
          });
          return sel;
        }

        function dong() {
          var sel = dangChon(), dayGioiHan = (M.max && sel.length >= M.max);
          state.q7[M.id] = sel;
          Array.prototype.forEach.call(els, function (e) {
            var on = e.classList.contains('on');
            e.setAttribute('aria-pressed', on ? 'true' : 'false');
            /* Chỉ ô CHƯA chọn mới mờ: ô đã chọn vẫn phải bấm được để bỏ chọn. */
            if (!on && dayGioiHan) { e.classList.add('a3mo'); }
            else { e.classList.remove('a3mo'); }
          });
          if (k25) { k25.hidden = (sel.length === 0); }
          a1TrangThaiNut(go, sel.length > 0);
        }

        Array.prototype.forEach.call(els, function (el) {
          el.onclick = function () {
            sfx('tap');
            if (el.getAttribute('data-none') === '1') {
              /* Ô loại trừ: bật nó là tắt hết ô khác. Không câu nào của v7.9 khai
                 `exclusive_opt`, nhưng trường đó có thật trong schema nên giữ nhánh này
                 để một lần seed sau không làm màn chạy sai trong im lặng. */
              var bat = !el.classList.contains('on');
              Array.prototype.forEach.call(els, function (e) { e.classList.remove('on'); });
              if (bat) { el.classList.add('on'); }
            } else if (el.classList.contains('on')) {
              el.classList.remove('on');
            } else if (!(M.max && dangChon().length >= M.max)) {
              el.classList.add('on');
              Array.prototype.forEach.call(els, function (e) {
                if (e.getAttribute('data-none') === '1') { e.classList.remove('on'); }
              });
            }
            dong();
          };
        });

        dong();
        go.onclick = function () { if (!go.disabled) { sfx('tap'); next(); } };
        /* Skip XOÁ hẳn lựa chọn cũ chứ không giữ nguyên: khách bấm Back rồi bấm Skip mà
           vẫn còn lựa chọn cũ thì bản đọc đi nhánh "có trả lời" trong khi khách tin là
           mình đã bỏ qua. Cùng lý do với nút Skip của màn ngày sinh. */
        $('skip').onclick = function () {
          state.q7[M.id] = [];
          sfx('tap'); next();
        };
      }
    };
  };

  /* ---------------------------------------------------------------------------
     A4 (phase 22) · HAI MÀN UY TÍN · màn 31 và 32

     ĐÂY LÀ HAI MÀN RỦI RO PHÁP LÝ CAO NHẤT CỦA QUIZ. Bản đang chạy mượn danh ba trường
     đại học, dựng bốn "chuyên gia" không có thật, và đếm một tường nhận xét năm chữ số.
     `ref/` §781 xếp cả ba vào cờ đỏ.

     CHÍN CHUỖI PHẢI BIẾN MẤT khỏi cả mã lẫn màn — danh sách nguyên văn ở `ref/1-SO-SANH`
     §6A. KHÔNG chép chín chuỗi đó vào đây, kể cả trong chú thích: cổng ra của phase 22 là
     một lệnh `grep` trên chính file này, và một dòng chú thích "để tham khảo" cũng đủ làm
     cái cổng đó mất nghĩa.

     Màn 31 thay chúng bằng thứ kiểm được: CƠ CHẾ CHẤM (mỗi vùng từ đúng 3 câu, cùng quy
     tắc cho mọi người), một ví dụ lấy từ CHÍNH câu trả lời của khách, và hai nguồn đã kiểm
     ngày 18/09. Số liệu BLS bỏ khỏi màn này (chủ dự án chốt 18/09, `ref/` §8 mục 4) — nó
     chỉ còn ở bản đọc.

     Màn `expert` (4 chuyên gia) không cần xoá ở đây: phase 18 đã bỏ tên đó khỏi `MAN_DUOI`
     nên nó không có phần tử nào trong `SCREENS`, và `goto(idxOf('expert'))` an toàn vì
     `idxOf` trả `-1` rồi `goto()` thoát ngay ở dòng đầu.
     --------------------------------------------------------------------------- */

  /* Hai mức nặng nhất của cả hai thang đều cho ≤ 2,5 điểm: `linear` là [10,7.5,5,2.5,0]
     và `linearRev` là [0,2.5,5,7.5,10] (`quiz-inner-weather.js:106`). So bằng ĐIỂM chứ
     không so vị trí nút, vì vị trí nút mang nghĩa ngược nhau giữa hai thang. */
  var A4_NGUONG_VI_DU = 2.5;

  /* Câu kéo điểm xuống nhiều nhất trong 21 câu khách đã trả lời, để dựng dòng ví dụ.
     `ref/` §"Màn 31" ghi: nhiều câu nặng ngang nhau thì lấy câu có `QSTAT` cao hơn. Bảng
     `QSTAT` nằm ở `ref/3-NGUYEN-LIEU/4-du-lieu-so-lieu/`, không nằm trong `assets/` và cũng
     không đến từ API (`qc` của `/api/quiz/schema?v=v4` trả `null`) — phase 24 chép nó vào
     `A6_QSTAT` bên dưới, và hàm này dùng chung bảng đó. Một bảng cho cả hai màn, không
     dựng nguồn thứ hai. */
  function a4ViDu() {
    var tot = null, i, q, v, d, s;
    for (i = 0; i < QUIZ7.questions.length; i++) {
      q = QUIZ7.questions[i];
      v = state.q7[q.id];
      if (typeof v !== 'number') { continue; }
      d = QUIZ7.pointsOf(q.id, v);
      if (d > A4_NGUONG_VI_DU) { continue; }
      s = A6_QSTAT[q.id] || 0;
      if (!tot || d < tot.diem || (d === tot.diem && s > tot.qstat)) {
        tot = { q: q, idx: v, diem: d, qstat: s };
      }
    }
    return tot;
  }

  var A4_STYLE = [
    '.a4card{background:#fff;border:1px solid var(--line);border-radius:14px;',
      'padding:14px 16px;margin:14px 0}',
    '.a4card b{display:block;font-size:19px;line-height:1.35;margin:0 0 8px}',
    '.a4card p{margin:8px 0}',
    /* Dòng ví dụ phải khác thân bài thì khách mới thấy nó nói về CHÍNH MÌNH. `.a4mex` một
       mình (0,1,0) thua `.screen p` (0,1,1) của theme, nên phải viết `.screen p.a4mex`. */
    '.screen p.a4mex{background:#F4EFFC;border-left:3px solid var(--gold);border-radius:10px;',
      'padding:11px 13px;margin:12px 0}',
    '.a4src{list-style:none;margin:8px 0 0;padding:0}',
    '.a4src li{position:relative;padding:6px 0 6px 18px;font-size:17px;line-height:1.45;',
      'color:var(--ink2)}',
    '.a4src li::before{content:"\\00B7";position:absolute;left:5px;font-weight:700;',
      'color:var(--gold)}',
    '.a4vid{margin:18px 0 0}',
    '.a4vid h4{font-family:var(--serif);font-size:20px;line-height:1.3;margin:0 0 9px}',
    '.a4vid video{display:block;width:100%;max-width:360px;aspect-ratio:9/16;margin:0 auto;',
      'border-radius:14px;background:#000}',
    '.a4vidke{margin:10px 0 0}',
    '.a4vidke summary{cursor:pointer;font-family:var(--sans);font-size:17px;font-weight:700;',
      'color:var(--ink2);padding:8px 0}',
    '.a4vidke p{margin:6px 0 0}',
    '.screen p.a4vhint{text-align:center;font-family:var(--sans);font-size:14px;color:var(--ink3);',
      'margin:8px 0 0}'
  ].join('');

  (function a4NapStyle() {
    var el = document.createElement('style');
    el.id = 'ms-a4-style';
    el.textContent = A4_STYLE;
    document.head.appendChild(el);
  })();

  /* ---------------------------------------------------------------------------
     MÀN 31 · credibility — "HOW YOUR READING IS BUILT"
     --------------------------------------------------------------------------- */
  RENDER.credibility = function () {
    var vd = a4ViDu(), mex = '';
    if (vd) {
      var leaf = isVI() ? vd.q.vi : vd.q.en;
      /* Nhãn trả lời và chữ câu hỏi lấy từ `QUIZ7.questions` — tức từ snapshot, không gõ
         lại ở đây. Tên vùng qua `tierName()` của bundle, cùng bảng mà bản đọc dùng. */
      mex = '<p class="a4mex">' + esc(isVI()
        ? 'Ví dụ từ chính bạn: bạn chọn “' + leaf.opts[vd.idx] + '” cho câu “' + leaf.q +
          '” → câu này tính vào vùng ' + tierName(vd.q.tier) + '.'
        : 'An example from your own answers: you chose “' + leaf.opts[vd.idx] + '” for “' +
          leaf.q + '” → this answer counts toward ' + tierName(vd.q.tier) + '.') + '</p>';
    }

    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          '<div class="a1kick">' + esc(A1('HOW YOUR READING IS BUILT',
            'BẢN ĐỌC CỦA BẠN ĐƯỢC DỰNG THẾ NÀO')) + '</div>' +
          '<div class="a4card">' +
            /* Lời hứa K24: đúng sau đợt 1 — công thức mới lấy trung bình 3 câu cho cả 7
               vùng, kể cả vùng tim. Giữ nguyên câu này. */
            '<b>' + esc(A1('Each area is scored from exactly 3 of the answers you just gave.',
              'Mỗi vùng được chấm từ đúng 3 câu bạn vừa trả lời.')) + '</b>' +
            '<p>' + esc(A1('The same answers always give the same scores.',
              'Cùng câu trả lời luôn cho cùng điểm.')) + '</p>' +
            mex +
            '<p>' + esc(A1(
              'Your birth date does not change your 7 area scores. It is used only for the optional astrology part.',
              'Ngày sinh không làm thay đổi điểm 7 vùng. Nó chỉ dùng cho phần chiêm tinh tuỳ chọn.')) + '</p>' +
          '</div>' +
          '<div class="a4card">' +
            '<b>' + esc(A1('Where the numbers in this quiz come from',
              'Các con số trong quiz lấy từ đâu')) + '</b>' +
            '<ul class="a4src">' +
              '<li>' + esc(A1('Sleep in women around and after menopause · Frontiers in Sleep, 2024',
                'Giấc ngủ của phụ nữ trong và sau tuổi mãn kinh · Frontiers in Sleep, 2024')) + '</li>' +
              '<li>' + esc(A1('Loneliness in adults 45 and older · AARP, 2025',
                'Sự cô đơn ở người từ 45 tuổi trở lên · AARP, 2025')) + '</li>' +
            '</ul>' +
          '</div>' +
          '<p class="tiny">' + esc(A1(
            'Mine Spirit is not connected to any school or hospital. For reflection, not medical advice.',
            'Mine Spirit không liên kết với trường học hay bệnh viện nào. Để suy ngẫm về bản thân, không phải lời khuyên y tế.')) + '</p>' +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Continue', 'Tiếp tục')) + '</button></div>',
      bind: function () { $('go').onclick = function () { sfx('tap'); next(); }; }
    };
  };

  /* ---------------------------------------------------------------------------
     MÀN 32 · social — "WHAT READERS SAY"

     HAI THẺ, KHÔNG PHẢI TƯỜNG. Bản đang chạy in 80 dòng nhận xét (40 người lặp hai lần)
     cộng một con số người dùng năm chữ số kèm tên thương hiệu cũ (`ref/` §6A). Cả hai
     biến mất.

     NHÃN, TÊN, ẢNH VÀ CHỮ MẪU ĐỀU ĐÃ GỠ. Hai thẻ dùng chung khuôn `a1TheNhanXet` với
     màn 1 — luật nhãn nằm ở đó. Cả ba khối là chỗ chờ, mang cờ — hợp đồng với phase 38b:
       hai thẻ Denise W. và Janet K., video Debbie kèm lời kể — chủ dự án chốt 21/09 dùng
       đúng bản trong `ref/3-NGUYEN-LIEU` (video `2-video/Debbie-2m39-ban-web-540x960.mp4`,
       ảnh bìa `1-anh/video-Debbie-anh-bia-man32.jpg`, lời kể `3-chu-tung-man`)
     --------------------------------------------------------------------------- */
  var A4_NX_MAN32A = {
    anh: 'qz-inline-21.jpg',
    ten: 'Denise W.', noi: 'Macon, Georgia',
    sao: 5, ngayEn: '1 week ago', ngayVi: '1 tuần trước', daMua: true,
    tieuDeEn: 'For the one who remembers for everyone',
    tieuDeVi: 'Cho người luôn nhớ hộ mọi người',
    chuEn: '“I’m usually the one who remembers what everyone needs, and I hadn’t given that much thought. I looked at the scores beside the explanation of each area. The part about giving more than I receive gave me something specific to think about.”',
    chuVi: '“Tôi thường là người nhớ mọi người cần gì, mà trước đây tôi ít nghĩ về chuyện đó. Tôi xem các điểm số cùng phần giải thích cho từng vùng. Phần nói về việc tôi cho đi nhiều hơn nhận lại giúp tôi có một điều cụ thể để suy nghĩ.”',
    giupIch: 23
  };
  var A4_NX_MAN32B = {
    anh: 'qz-inline-22.jpg',
    ten: 'Janet K.', noi: 'Boise, Idaho',
    sao: 5, ngayEn: '3 days ago', ngayVi: '3 ngày trước', daMua: true,
    tieuDeEn: 'A place to start, not another list',
    tieuDeVi: 'Có chỗ để bắt đầu, không phải thêm một danh sách',
    chuEn: '“I didn’t want another long list of things I ought to be doing. I opened the action plan and read the first suggestion before looking through the other sections. I liked having a place to start. It took me two evenings to read it all, but that’s fine.”',
    chuVi: '“Tôi không muốn có thêm một danh sách dài những việc mình nên làm. Tôi mở kế hoạch hành động và đọc gợi ý đầu tiên trước khi xem các phần khác. Tôi thích việc có một chỗ để bắt đầu. Tôi đọc hết mất hai buổi tối, nhưng không sao.”',
    giupIch: 6
  };
  var A4_DEBBIE_KE_EN = "“This summer I was the one everybody called. My mom’s appointments, my daughter’s kids after school, the church bake sale. I’d get in bed at eleven and my mind would just keep going. One night I was sitting in my car in the Walgreens parking lot, and I just started crying. Nothing had happened. I couldn’t tell you why. I was running on empty, and nobody saw it. Then I took this little quiz on Facebook, just to kill ten minutes. It said rest was my lowest area. I thought, well, there’s the parking lot. So I paid the four ninety. It came by email in a few minutes. I figured, more fluff. But it was written from my answers. One line said I’m not weak, I’ve just been holding too much. I sat there a minute. Truth is, I’ve waited a long time for somebody to say that to me. I figured maybe my kids would, someday. And here it was, from my own answers, not just somebody being nice. Every January I’d spread myself thin over everything. Walk more, sleep more. Nothing stuck. It showed me why. No rest, so I give on empty, so I quit speaking up, so my mind won’t shut off. Now, I don’t usually go for this stuff. But the part from my birth date said this is the first chapter where I get to build something for me. I read that line three times. The plan said start small, tonight. So I asked my sister to take Mom on Tuesday. She said sure, just like that. That Tuesday I sat on the porch with a book. Twenty whole minutes. My reading had November marked: don’t take on extra. When my daughter asked about Thanksgiving, I said, not at my house this year. First time in twenty-six years. She said, Mom, who are you? It didn’t fix my life. Last week Mom had a fall, and I was right back to running everything. But this time I caught myself. I know where I’m leaking, and which months to go easy. Four ninety, one time, no subscription, and they give it back if it’s not for you. For me? It gave me back a little piece of me. That’s the only way I can say it.”";
  var A4_DEBBIE_KE_VI = "“Mùa hè này tôi là người ai cũng gọi. Lịch khám của mẹ, đón cháu cho con gái, buổi bán bánh ở nhà thờ. Mười một giờ đêm lên giường mà đầu óc cứ chạy mãi. Có tối tôi ngồi trong xe ở bãi đỗ Walgreens rồi bật khóc. Chẳng có chuyện gì cả. Tôi không biết tại sao. Tôi đã cạn sạch mà không ai thấy. Rồi tôi làm thử bài quiz nhỏ trên Facebook cho qua mười phút. Nó nói \"nghỉ ngơi\" là vùng thấp nhất của tôi. Tôi nghĩ: à, ra chuyện bãi đỗ xe. Thế là tôi trả 4,90 đô. Vài phút sau nó tới email. Tôi nghĩ lại sáo rỗng thôi. Nhưng nó viết từ chính câu trả lời của tôi. Có dòng nói tôi không yếu, chỉ là đã ôm quá nhiều. Tôi ngồi lặng một lúc. Thật ra tôi đã chờ rất lâu để có ai nói với tôi câu ấy. Tôi nghĩ có khi sau này con tôi sẽ nói. Vậy mà nó ở đây, từ chính câu trả lời của tôi, không phải lời nói cho dễ nghe. Tháng Giêng nào tôi cũng dàn mỏng sức cho mọi thứ. Đi bộ nhiều hơn, ngủ nhiều hơn. Chẳng cái nào trụ được. Nó chỉ cho tôi vì sao. Không nghỉ, nên cho đi khi đã cạn, nên thôi lên tiếng, nên đầu không tắt được. Nói thật, tôi vốn không mê mấy thứ này. Nhưng phần theo ngày sinh nói đây là chương đầu tiên tôi được xây điều gì đó cho mình. Tôi đọc câu đó ba lần. Kế hoạch bảo: bắt đầu nhỏ, ngay tối nay. Tôi nhờ em gái đưa mẹ đi hôm thứ Ba. Nó bảo \"được chứ\", nhẹ tênh. Thứ Ba đó tôi ngồi ngoài hiên với cuốn sách. Trọn hai mươi phút. Bản đọc đánh dấu tháng Mười Một: đừng ôm thêm việc. Con gái hỏi chuyện Lễ Tạ ơn, tôi nói năm nay không làm ở nhà mẹ. Lần đầu sau 26 năm. Con bé bảo: \"Mẹ ơi, mẹ là ai vậy?\" Nó không sửa được đời tôi. Tuần trước mẹ ngã, tôi lại ôm hết việc. Nhưng lần này tôi tự nhận ra. Tôi biết mình rò sức ở đâu, và tháng nào nên nhẹ tay. Bốn đô chín mươi, trả một lần, không đăng ký định kỳ, không hợp thì họ trả lại tiền. Còn với tôi? Nó trả lại cho tôi một phần nhỏ của chính mình. Tôi chỉ biết nói vậy.”";

  RENDER.social = function () {
    return {
      html: a1Topbar(cur > 0) +
        /* `a4social`: móc CSS riêng cho màn này (quiz-giai-doan-1.css, khối 29/09/2026) để
           thẻ thứ hai ló lên trên nút Continue — khách thấy còn nhận xét bên dưới. */
        '<div class="mid a4social">' +
          '<div class="a1kick">' + esc(A1('WHAT READERS SAY', 'NGƯỜI ĐỌC NÓI GÌ')) + '</div>' +
          a1TheNhanXet(A4_NX_MAN32A) +
          a1TheNhanXet(A4_NX_MAN32B) +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Continue', 'Tiếp tục')) + '</button></div>',
      bind: function () { $('go').onclick = function () { sfx('tap'); next(); }; }
    };
  };

  /* ---------------------------------------------------------------------------
     MÀN 32b · vid — video Debbie tách khỏi màn 32 (C1, ref `6-SUA-LOI` 22/09)

     Theo `bindVid()` của prototype (`5-ma-nguon-prototype/app.js:144`):
       · Continue mờ và không bấm được tới khi video phát hết (`ended`).
       · Tua vượt quá mốc xa nhất đã xem thì kéo về mốc đó.
       · Dòng "Watch to the end to continue · m:ss" đếm lùi theo thời gian còn lại.
       · Video không tải được (`error`) thì nút tự mở.
       · `state.vidDone` theo LƯỢT (`freshState()` dựng object mới khi làm lại): đã xem hết
         thì quay lại màn này nút mở sẵn.

     Video để `preload="none"` nên trình duyệt chưa tải gì tới khi khách bấm play, và `error`
     của `<video>` chỉ bắn SAU cú bấm đó. Khách không bấm play mà URL hỏng thì nút sẽ khoá
     mãi. Nên lúc vào màn hỏi thử URL một lần bằng `HEAD`: lỗi mạng hoặc trả mã lỗi thì mở
     nút. `no-cors` để asset nằm ở tên miền CDN khác vẫn hỏi được; khi đó phản hồi `opaque`
     không đọc được mã, chỉ bắt được lỗi mạng.
     --------------------------------------------------------------------------- */
  RENDER.vid = function () {
    var daXem = !!state.vidDone;
    var src = a1Anh('qz-debbie-2m39.mp4');
    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          '<div class="a1kick">' + esc(A1('WHAT READERS SAY', 'NGƯỜI ĐỌC NÓI GÌ')) + '</div>' +
          '<div class="a4vid">' +
            '<h4>' + esc(A1('One reader’s story, in her own words',
              'Câu chuyện của một người đọc, bằng lời của chính bà')) + '</h4>' +
            '<video id="a4vmain" controls preload="none" playsinline poster="' +
              a1Anh('qz-debbie-bia.jpg') + '" src="' + src + '"></video>' +
            '<details class="a4vidke"><summary>' + esc(A1('Read what she says', 'Đọc lời kể')) +
              '</summary><p><b>' + esc(A1('Debbie · 61 · retired teacher, the Midwest',
                'Debbie · 61 tuổi · giáo viên nghỉ hưu, miền Trung Tây')) + '</b><br>' +
              esc(A1(A4_DEBBIE_KE_EN, A4_DEBBIE_KE_VI)) + '</p></details>' +
          '</div>' +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Continue', 'Tiếp tục')) + '</button>' +
          '<p class="a4vhint" id="a4vhint"' + (daXem ? ' hidden' : '') + '>' +
            esc(A1('Watch to the end to continue · 2:39', 'Xem hết video để tiếp tục · 2:39')) +
          '</p></div>',
      bind: function () {
        var go = $('go'), v = $('a4vmain'), goi = $('a4vhint');
        var xa = 0;

        function mo() {
          state.vidDone = true;
          a1TrangThaiNut(go, true);
          if (goi) { goi.hidden = true; }
        }

        a1TrangThaiNut(go, !!state.vidDone);
        go.onclick = function () { if (!go.disabled) { sfx('tap'); next(); } };
        if (state.vidDone || !v) { return; }

        v.addEventListener('timeupdate', function () {
          if (!v.seeking && v.currentTime > xa) { xa = v.currentTime; }
          if (!state.vidDone && goi && isFinite(v.duration)) {
            var con = Math.max(0, Math.ceil(v.duration - v.currentTime));
            goi.textContent = A1('Watch to the end to continue · ', 'Xem hết video để tiếp tục · ') +
              Math.floor(con / 60) + ':' + (con % 60 < 10 ? '0' : '') + (con % 60);
          }
        });
        v.addEventListener('seeking', function () {
          if (!state.vidDone && v.currentTime > xa + 1) { v.currentTime = xa; }
        });
        v.addEventListener('ended', mo);
        v.addEventListener('error', mo);

        if (typeof fetch === 'function') {
          fetch(src, { method: 'HEAD', mode: 'no-cors', cache: 'no-store' }).then(function (r) {
            if (r.type !== 'opaque' && !r.ok) { mo(); }
          }, mo);
        }
      }
    };
  };

  /* ---------------------------------------------------------------------------
     A5 (phase 23) · MÀN THU THẬP · màn 33 và 34

     CỔNG THỨ BA. `quiz-giai-doan-1.js` (thẻ #6) nạp SAU file này và vẫn khai
     `RENDER.bdate` (:467), `RENDER.name` (:550) và `RENDER.email` (:573) của bản cũ. Không
     có cờ thì bản của nó thắng và hai màn dưới đây không bao giờ hiện. Khuôn giống hệt
     `__msManA0` (phase 18) và `__msMan19` (phase 19): cắm cờ NGAY SAU khi đã gán, không
     cắm ở đầu file — overlay thoát sớm khi snapshot vắng, và khi đó bản cũ phải chạy.
     Cổng ôm luôn `RENDER.name` nằm giữa hai hàm kia. Không sao và cũng không phải việc
     thừa: phase 18 đã bỏ tên `name` khỏi `MAN_DUOI` nên không màn nào mang kiểu đó nữa,
     hàm kia còn sống cũng không ai gọi tới. Tách cổng làm hai để chừa nó ra chỉ đẻ thêm
     một chỗ phải nhớ.

     BA DANH SÁCH CHỌN THAY BA Ô GÕ. Tuổi trung vị của khách là 66; gõ bốn tới sáu chữ số
     trên điện thoại là chỗ rớt nhiều nhất của phễu. Năm xếp từ 2000 xuống 1935 (`ref/` §6C).

     KHÔNG HỎI GIỜ SINH, KHÔNG HỎI NƠI SINH. `ref/` K22 mục 5: muốn thêm phải báo trước.
     --------------------------------------------------------------------------- */

  var A5_NAM_TU = 1935, A5_NAM_DEN = 2000;

  var A5_THANG_EN = ['January', 'February', 'March', 'April', 'May', 'June',
                     'July', 'August', 'September', 'October', 'November', 'December'];
  var A5_THANG_VI = ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
                     'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'];

  var A5_STYLE = [
    '.a5grid{display:grid;grid-template-columns:1.25fr .85fr 1fr;gap:9px;margin:16px 0 0}',
    '.a5grid label{display:block;font-family:var(--sans);font-size:14px;font-weight:700;',
      'letter-spacing:.08em;text-transform:uppercase;color:var(--ink3);margin:0 0 5px}',
    /* Ô chọn phải cao ít nhất 52px: ngón tay của khách 45–65+, và `appearance:none` để
       mũi tên không bị hệ điều hành vẽ đè lên chữ ở khổ hẹp. */
    '.a5sel{width:100%;min-height:52px;padding:12px 30px 12px 12px;border-radius:12px;',
      'border:1px solid var(--line);background:#fff;color:var(--ink);font-family:var(--sans);',
      'font-size:18px;line-height:1.3;appearance:none;-webkit-appearance:none;',
      'background-image:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' ',
      'viewBox=\'0 0 12 8\'><path d=\'M1 1l5 5 5-5\' fill=\'none\' stroke=\'%236B627F\' ',
      'stroke-width=\'2\' stroke-linecap=\'round\'/></svg>");',
      'background-repeat:no-repeat;background-position:right 11px center;background-size:12px 8px}',
    '.a5sel.bad{border-color:#C43D2E;background-color:#FDF3F1}',
    /* Dòng lỗi phải ĐỎ và căn trái. Hai thứ đó đều bị `.screen p` của theme
       (`quiz-inner-weather.css:2011` và :2175) giành mất: nó khai `color:#1E1733!important`
       và `text-align:justify`, mà `.a5err` một mình (0,1,0) thua `.screen p` (0,1,1) kể cả
       có `!important`. Phải viết `.screen p.a5err` (0,2,1) mới thắng — đo 21/09: không có
       nó thì dòng lỗi ra đúng màu chữ thân bài, đọc như một câu bình thường.
       KHÔNG đặt `font-size` ở đây: sàn 18px của theme là quyết định của cả dự án cho mắt
       45–65+, và dòng lỗi thì càng phải đọc được. */
    '.screen p.a5err{min-height:22px;margin:9px 0 0;color:#C43D2E!important;',
      'text-align:left!important;line-height:1.35}',
    '.a5field{margin:14px 0 0}',
    '.a5field label{display:block;font-family:var(--sans);font-size:14px;font-weight:700;',
      'letter-spacing:.08em;text-transform:uppercase;color:var(--ink3);margin:0 0 5px}',
    '.a5inp{width:100%;min-height:52px;padding:12px 14px;border-radius:12px;',
      'border:1px solid var(--line);background:#fff;color:var(--ink);font-family:var(--sans);',
      'font-size:18px;line-height:1.3}',
    '.a5inp.bad{border-color:#C43D2E;background:#FDF3F1}',
    '.a5skip{display:block;margin:8px auto 0;background:none;border:0;color:var(--ink3);',
      'font-size:16px;text-decoration:underline;cursor:pointer;min-height:44px}',
    /* Cùng một luật: `.screen p` khai `text-align:justify`, và một dòng ngắn bị justify
       thì hiện ra y như căn trái. `.a1price` của phase 19 đang vướng đúng lỗi này. */
    '.screen p.a5price{text-align:center!important;margin:10px 0 0}'
  ].join('');

  (function a5NapStyle() {
    var el = document.createElement('style');
    el.id = 'ms-a5-style';
    el.textContent = A5_STYLE;
    document.head.appendChild(el);
  })();

  function a5Chon(id, nhan, giuCho, muc, daChon) {
    var o = '<option value="">' + esc(giuCho) + '</option>', i;
    for (i = 0; i < muc.length; i++) {
      o += '<option value="' + esc(String(muc[i].v)) + '"' +
        (String(muc[i].v) === String(daChon) ? ' selected' : '') + '>' +
        esc(muc[i].t) + '</option>';
    }
    return '<div><label for="' + id + '">' + esc(nhan) + '</label>' +
      '<select class="a5sel" id="' + id + '">' + o + '</select></div>';
  }

  /* ---------------------------------------------------------------------------
     MÀN 33 · bdate — ba danh sách chọn, "Skip for now"
     --------------------------------------------------------------------------- */
  RENDER.bdate = function () {
    var b = state.bdate || {};
    var thang = [], ngay = [], nam = [], i;
    for (i = 1; i <= 12; i++) { thang.push({ v: i, t: isVI() ? A5_THANG_VI[i - 1] : A5_THANG_EN[i - 1] }); }
    for (i = 1; i <= 31; i++) { ngay.push({ v: i, t: String(i) }); }
    for (i = A5_NAM_DEN; i >= A5_NAM_TU; i--) { nam.push({ v: i, t: String(i) }); }

    var oThang = a5Chon('bm', A1('Month', 'Tháng'), A1('Month', 'Tháng'), thang, b.m);
    var oNgay = a5Chon('bd', A1('Day', 'Ngày'), A1('Day', 'Ngày'), ngay, b.d);
    var oNam = a5Chon('by', A1('Year', 'Năm'), A1('Year', 'Năm'), nam, b.y);
    /* Mỹ đọc Tháng/Ngày/Năm, Việt đọc Ngày/Tháng/Năm — giữ đúng thói quen của bản cũ. */
    var luoi = isVI() ? (oNgay + oThang + oNam) : (oThang + oNgay + oNam);

    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          '<h1 class="big">' + esc(A1('When were you born?', 'Bạn sinh ngày nào?')) + '</h1>' +
          '<p class="a1body">' + esc(A1(
            'Your birth date is used for the optional astrology part of your reading: who you are beneath your roles, the chapter of life you are in, and the years ahead. You can skip this and still get the rest of your reading, or add it after you pay at no extra cost.',
            'Ngày sinh của bạn được dùng cho phần chiêm tinh tuỳ chọn trong bản đọc: bạn là ai bên dưới những vai đang gánh, bạn đang ở chương nào của đời, và những năm phía trước. Bạn có thể bỏ qua và vẫn nhận đủ phần còn lại, hoặc bổ sung sau khi mua mà không mất thêm phí.')) + '</p>' +
          '<div class="a5grid">' + luoi + '</div>' +
          '<p class="a5err" id="berr" role="alert" aria-live="polite"></p>' +
          '<p class="tiny">' + esc(A1(
            'Your birth date is used only for this part of your reading.',
            'Ngày sinh chỉ được dùng cho phần này của bản đọc.')) + '</p>' +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Continue', 'Tiếp tục')) + '</button>' +
          '<button class="a5skip" id="skip">' +
          esc(A1('Skip for now', 'Tạm bỏ qua')) + '</button></div>',
      bind: function () {
        var mm = $('bm'), dd = $('bd'), yy = $('by'), go = $('go'), err = $('berr');

        /* NGÀY PHẢI CÓ THẬT, không chỉ nằm trong khoảng. `31/02` lọt qua mọi phép kiểm
           khoảng. Cho `Date` tự dựng rồi soi lại cả ba số: tháng tràn sẽ cuộn sang tháng
           sau và lộ ra ngay. Đúng cách `assets/pheu-107-luan-giai.js:845-850` đã dùng cho
           form bổ sung ngày sinh, giữ một lối kiểm cho cả hai chỗ. */
        function coThat(y, m, d) {
          var t = new Date(y, m - 1, d);
          return t.getFullYear() === y && t.getMonth() === m - 1 && t.getDate() === d;
        }

        function chk() {
          var m = +mm.value, d = +dd.value, y = +yy.value;
          [mm, dd, yy].forEach(function (e) { e.classList.remove('bad'); });
          /* Chưa chọn đủ ba thì im lặng: mắng người ta giữa chừng là làm họ mất bình tĩnh. */
          if (!mm.value || !dd.value || !yy.value) {
            err.textContent = ''; a1TrangThaiNut(go, false); return false;
          }
          if (!coThat(y, m, d)) {
            dd.classList.add('bad');
            err.textContent = A1('That day does not exist in the month you picked. Please check it.',
                                 'Ngày đó không có trong tháng bạn chọn. Bạn kiểm lại giúp nhé.');
            a1TrangThaiNut(go, false); return false;
          }
          err.textContent = ''; a1TrangThaiNut(go, true); return true;
        }

        [mm, dd, yy].forEach(function (e) { e.onchange = chk; });
        chk();

        go.onclick = function () {
          if (go.disabled || !chk()) { return; }
          var m = +mm.value, d = +dd.value, y = +yy.value;
          var hai = function (n) { return (n < 10 ? '0' : '') + n; };
          /* `raw` cho `quiz-do-duong.js` (nó phân biệt bỏ qua bằng `state.bdate.raw`), còn
             `y`/`m`/`d` cho `dungNgaySinh()` của `quiz-goi-api.js:170`. Thiếu một trong hai
             là hỏng một đường, im lặng. */
          state.bdate = { y: y, m: m, d: d, raw: y + '-' + hai(m) + '-' + hai(d) };
          sfx('tap'); next();
        };

        /* Bỏ qua XOÁ hẳn ngày sinh chứ không giữ giá trị cũ: khách bấm Back rồi bấm bỏ qua
           mà vẫn còn ngày cũ thì bản đọc đi nhánh "có ngày sinh" trong khi khách tin là
           mình đã bỏ qua. Xoá cũng là thứ làm `quiz-do-duong.js:326` bắn `bdate_skip`. */
        $('skip').onclick = function () {
          state.bdate = null;
          sfx('tap'); next();
        };
      }
    };
  };

  /* ---------------------------------------------------------------------------
     MÀN 34 · email — ô tên KHÔNG bắt buộc, gộp từ màn `name` đã bỏ

     `state.name` được phép rỗng. `chotTen()` (`quiz-giai-doan-1.js:393`) thay tên rỗng
     bằng "Friend" / "Bạn" TRƯỚC mọi màn có chữ `{Name}`, nên không màn nào sau đây ra
     `"…, ."`. Màn này KHÔNG gọi `chotTen()`: gọi là ô tên hiện sẵn chữ "Friend" trong khi
     đang hỏi khách tên gì.

     Vì `chotTen()` ghi đè `state.name`, ô tên chỉ điền lại khi khách THẬT SỰ đã gõ —
     `state.a5DaGoTen`. Không có cờ đó thì khách bấm Back từ màn giá về đây sẽ thấy ô tên
     có sẵn chữ "Friend" mà họ chưa từng gõ.
     --------------------------------------------------------------------------- */
  /* MÀN TÊN riêng (29/09/2026, chủ dự án yêu cầu tách lại như bản trước). Chữ lấy đúng bản
     trước (`quiz-giai-doan-1.js` RENDER.name: "What should we call you?", "Your first name",
     "Continue", nút mở khi gõ từ 2 ký tự), khuôn và kiểu ô lấy của màn email A5 bên dưới.
     Không dùng thẳng hàm bên kia: nó nằm sau cổng `__msMan23` nên không chạy, và nếu không có
     bản này thì `RENDER.name` rơi về bản của bundle, khác kiểu hẳn các màn quanh nó. */
  RENDER.name = function () {
    var tenCu = state.a5DaGoTen ? (state.fullName || state.name || '') : '';
    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          /* `font:inherit` vì `.screen *{font-family:var(--ui)}` kéo chữ nhấn sang font khác. */
          '<h1 class="big">' + A1(
            'What should we <span style="color:var(--gold);font:inherit">call you</span>?',
            'Chúng tôi nên <span style="color:var(--gold);font:inherit">gọi bạn</span> là gì?') + '</h1>' +
          '<form id="af" novalidate>' +
            '<div class="a5field"><label for="n">' +
              esc(A1('Your first name', 'Tên của bạn')) + '</label>' +
              '<input class="a5inp" type="text" id="n" name="name" autocomplete="given-name" ' +
                'value="' + esc(tenCu) + '"></div>' +
          '</form>' +
        '</div>' +
        '<div class="foot"><button class="btn" id="go" disabled>' +
          esc(A1('Continue', 'Tiếp tục')) + '</button></div>',
      bind: function () {
        var n = $('n'), go = $('go'), f = $('af');
        /* `a1TrangThaiNut` chứ không chỉ `disabled`: `markCTA()` tô xanh thẳng lên nút nên
           nút tắt trông vẫn như nút sống — cùng vá với màn câu hỏi. */
        function chk() { a1TrangThaiNut(go, (n.value || '').trim().length >= 2); }
        n.oninput = chk; chk();
        function di() {
          if (go.disabled) { return; }
          var t = n.value.trim();
          state.a5DaGoTen = true;
          state.fullName = t;
          state.name = t.split(/\s+/)[0];
          sfx('tap'); next();
        }
        /* Enter trong form một ô sẽ nạp lại trang — chặn, đổi thành bấm Continue. */
        if (f) { f.onsubmit = function (evt) { evt.preventDefault(); di(); }; }
        go.onclick = di;
      }
    };
  };

  RENDER.email = function () {
    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          '<h1 class="big">' + esc(A1(
            'Your answers have been scored. Enter your email to see your summary.',
            'Câu trả lời của bạn đã được tính điểm. Nhập email để xem bản tóm tắt.')) + '</h1>' +
          /* Ô tên đã tách ra màn `name` riêng (29/09/2026). */
          '<form id="af" novalidate>' +
            '<div class="a5field"><label for="e">' +
              esc(A1('Email address', 'Địa chỉ email')) + '</label>' +
              '<input class="a5inp" type="email" id="e" name="email" autocomplete="email" ' +
                'inputmode="email" placeholder="you@email.com" ' +
                'value="' + esc(state.email || '') + '"></div>' +
            /* `role="alert"` để trình đọc màn hình đọc lên ngay khi dòng lỗi xuất hiện —
               tuổi trung vị của khách là 66. */
            '<p class="a5err" id="eerr" role="alert" aria-live="polite"></p>' +
          '</form>' +
          '<p class="tiny">' + esc(A1(
            'We use your email to send your full reading if you buy it. No spam.',
            'Chúng tôi dùng email của bạn để gửi bản đọc đầy đủ nếu bạn mua. Không spam.')) + '</p>' +
        '</div>' +
        '<div class="foot"><button class="btn" id="go">' +
          esc(A1('Show the area draining me most',
                 'Xem vùng đang rút cạn tôi nhiều nhất')) + '</button></div>',
      /* Dòng giá "Full reading: {gia}, paid once." dưới nút đã bỏ theo yêu cầu 29/09/2026
         (thay quyết định 15/09 "nhắc giá trước khi xem kết quả"). */
      bind: function () {
        var e = $('e'), go = $('go'), err = $('eerr'), f = $('af');

        /* Rỗng và sai định dạng đi CHUNG một dòng lỗi: `ref/` §6C chỉ đòi một câu, và
           `EMAIL_RE` (`quiz-inner-weather.js:6923`) chối cả `''`, `abc` lẫn `a@b`. */
        function okEmail() { return EMAIL_RE.test((e.value || '').trim()); }

        function bao() {
          err.textContent = A1('Please enter a valid email address so we can send your reading.',
                               'Bạn nhập giúp một địa chỉ email hợp lệ để chúng tôi gửi bản đọc nhé.');
          e.classList.add('bad');
          e.focus();
        }

        /* Nút KHÔNG mờ ở màn này. Email rỗng mà nút chết thì khách gõ sai định dạng sẽ
           không hiểu vì sao không đi tiếp được — `ref/` §6C đòi thấy DÒNG LỖI. Nút sống,
           bấm vào thì hiện lỗi và chặn. */
        e.oninput = function () {
          if (err.textContent && okEmail()) { err.textContent = ''; e.classList.remove('bad'); }
        };

        function di() {
          if (!okEmail()) { bao(); return; }
          err.textContent = ''; e.classList.remove('bad');
          state.email = e.value.trim();
          sfx('tap'); next();
        }

        /* Form một ô sẽ submit khi bấm Enter và nạp lại trang, mất sạch câu trả lời. Chặn
           đúng chỗ đó và đổi Enter thành bấm Continue. */
        if (f) { f.onsubmit = function (evt) { evt.preventDefault(); di(); }; }
        go.onclick = di;
      }
    };
  };

  /* Cờ cho `quiz-giai-doan-1.js` (thẻ #6) biết hai màn thu thập đã có bản v7.9. Xem khối
     chú thích đầu A5. Cờ riêng, không dùng chung `__msManA0` hay `__msMan19`: ba lớp gác
     ba thứ khác nhau, và mỗi lớp phải tắt được riêng khi bản của nó chưa chạy. */
  window.__msMan23 = true;

  /* ---------------------------------------------------------------------------
     A6 (phase 24) · MÀN CHỜ VÀ MÀN KẾT QUẢ · màn 35 và 36

     MÀN KẾT QUẢ LÀ CHỖ BÁN HÀNG, và cũng là chỗ dùng `QUIZ7.score` nhiều nhất.

     BA BẢNG SỐ LIỆU dưới đây chép từ `ref/3-NGUYEN-LIEU/4-du-lieu-so-lieu/
     SO-LIEU-dang-dung-trong-quiz.md` — bảng đó xuất thẳng từ `app.js` ngày 18/09/2026 nên
     khớp đúng con số khách thấy trên bản mẫu.

     `QSTAT` tính lại 21/09 bằng `mine_chapter/scripts/tinh-lai-qstat.mjs` (phase 36): 130 phiên
     khách 09–14/09/2026 trên thang giá trị 0–4, làm tròn phần trăm. Chủ dự án chốt 21/09 không
     nêu mẫu số: câu chỉ nói tỉ lệ, nên không lệch khi số khách tăng. Bảng nguồn:
     `mine_chapter/docs/quiz-number-sources.md`, nên khối dùng bảng này không còn mang cờ
     chờ kiểm K33. `RSTAT` thì đã kiểm nguồn ngày 18/09 và không mang cờ.
     --------------------------------------------------------------------------- */
  /* "X trên 100 người làm quiz này cũng chọn một trong hai mức nặng nhất ở câu này". */
  var A6_QSTAT = {
    Q16: 60, Q13: 54, Q12: 51, Q21: 47, Q14: 46, Q2: 43, Q11: 43, Q3: 42, Q19: 42,
    Q9: 41, Q15: 41, Q5: 37, Q6: 37, Q20: 37, Q18: 36, Q7: 35, Q8: 33, Q1: 32,
    Q4: 31, Q17: 29, Q10: 19
  };

  /* Dòng nghiên cứu chỉ gắn cho ba câu. Câu khác thì ẩn hẳn, KHÔNG thay bằng nguồn khác.
     Số liệu chăm sóc BLS đã bỏ khỏi quiz từ 18/09 (`ref/` §3): mức nặng của Q10 theo cách
     chấm hiện tại là "cho ít", không khớp nghĩa số liệu đó. */
  var A6_RSTAT = { Q1: 'ngu', Q16: 'ngu', Q11: 'codon' };
  var A6_RCHU = {
    ngu: {
      en: 'About half of women, 40 to 56 percent, have trouble sleeping around and after menopause.',
      vi: 'Khoảng một nửa phụ nữ, từ 40 đến 56%, khó ngủ trong và sau giai đoạn mãn kinh.',
      nguon: 'Frontiers in Sleep, 2024'
    },
    codon: {
      en: '4 in 10 U.S. adults age 45 and older say they are lonely.',
      vi: '4 trong 10 người Mỹ từ 45 tuổi trở lên nói mình cô đơn.',
      nguon: 'AARP, 2025'
    }
  };

  /* Ngưỡng "dưới 35 điểm" của `ref/` nói theo thang 0–100; biến trong mã là 0–10. */
  var A6_NGUONG_THAP = 3.5;
  var A6_SO_VUNG_THAP = 4;

  /* ---------------------------------------------------------------------------
     MÀN 35 · calc — 7 thanh, 3 dòng chữ, 14,4 giây

     MỐC THỜI GIAN LÀ HỢP ĐỒNG, không phải con số cho đẹp: phase 16b gọi API tháng ở đúng
     màn này, và 14,4 giây là cửa sổ chờ mạng. Rút ngắn là màn kết quả hiện ra trước khi có
     tháng. Thanh thứ i bật ở `720 + i×1320` ms; chữ 2 ở 4.600 ms, chữ 3 ở 12.400 ms; sang
     màn kết quả ở 14.400 ms (`ref/` §"Màn 35").

     HẸN GIỜ KHỞI TẠO LẠI MỖI LẦN MÀN ĐƯỢC DỰNG, không chỉ lần đầu. Bẫy đã gặp: đặt hẹn giờ
     ở nút của màn email thì vào màn này bằng nút Back sẽ thấy thanh đứng im và màn không
     bao giờ tự chuyển. Ở đây mọi hẹn giờ nằm trong `bind()`, tức chạy lại mỗi lần render.

     `timers` là mảng của bundle và `clearTimers()` trong `goto()` dọn nó, nên rời màn giữa
     chừng không để lại hẹn giờ mồ côi. Cộng thêm một lớp gác `cur === manCuaToi` cho chắc:
     `goto()` có thể bị chuyển hướng và màn đích không phải màn này.

     29/09/2026 — KẾT QUẢ HIỆN TRONG 3–4 GIÂY (yêu cầu của chủ dự án; thay mốc 14,4 giây ở
     trên): 7 thanh chạy xong ở ~3 giây, màn tự sang kết quả sớm nhất ở `A6_TONG_CHO`
     (3,2 giây). Nếu lượt hỏi tháng (`window.__msThangXong`, quiz-giai-doan-1.js
     `napThang`) chưa xong thì chờ thêm, nhưng CHẬM NHẤT tới `A6_TRAN_CHO` (4 giây) là sang.
     CÁI GIÁ ĐÃ BIẾT: mạng chậm hơn 4 giây thì màn kết quả không có ô "Month to get ready
     for" mà rơi về ô "Second area being pulled down" — đường dự phòng có sẵn của `theHan()`.
     `A6_DO_DAY` phải bằng thời lượng `transition` của `.a6cfill` bên dưới.
     --------------------------------------------------------------------------- */
  var A6_TRE_DAU = 200, A6_NHIP_THANH = 400, A6_TONG_CHO = 3200, A6_TRAN_CHO = 4000;
  var A6_DO_DAY = 400;
  var A6_MOC_CHU = [0, 1200, 2600];

  var A6_STYLE = [
    /* màn chờ */
    '.a6cbox{margin:26px 0 0}',
    '.screen p.a6cmsg{font-family:var(--serif)!important;font-size:23px!important;',
      'line-height:1.35!important;color:var(--gold)!important;text-align:center!important;',
      'margin:0 auto 22px;max-width:20em;min-height:2.7em}',
    '.a6crow{margin:0 0 13px}',
    '.a6clab{display:flex;justify-content:space-between;align-items:baseline;',
      'font-family:var(--sans);font-size:16px;color:var(--ink2);margin:0 0 5px}',
    '.a6ctick{color:#2E7D4F;font-weight:700}',
    '.a6ctrack{height:9px;border-radius:5px;background:#E6E0F2;overflow:hidden}',
    '.a6cfill{display:block;height:100%;width:0;border-radius:5px;background:var(--gold);',
      'transition:width ' + (A6_DO_DAY / 1000) + 's cubic-bezier(.3,.7,.3,1)}'
  ].join('');

  (function a6NapStyle() {
    var el = document.createElement('style');
    el.id = 'ms-a6-style';
    el.textContent = A6_STYLE;
    document.head.appendChild(el);
  })();

  function a6ChuCho(i) {
    if (i === 0) { return A1('Reading your 21 answers…', 'Đang đọc 21 câu trả lời của bạn…'); }
    if (i === 1) {
      return A1('Finding which area needs the most attention…',
                'Đang tìm vùng bạn cần quan tâm nhất…');
    }
    return A1('Naming the area draining you most…',
              'Đang gọi tên vùng đang rút cạn bạn nhiều nhất…');
  }

  RENDER.calc = function () {
    var hang = '', i;
    for (i = 0; i < QUIZ7.order.length; i++) {
      hang += '<div class="a6crow">' +
          '<div class="a6clab"><span>' + esc(tierName(QUIZ7.order[i])) + '</span>' +
            '<span class="a6ctick" id="a6t' + i + '"></span></div>' +
          '<div class="a6ctrack"><i class="a6cfill" id="a6f' + i + '"></i></div>' +
        '</div>';
    }
    return {
      html: a1Topbar(false) +
        '<div class="mid">' +
          '<div class="a6cbox">' +
            '<p class="a6cmsg" id="a6msg">' + esc(a6ChuCho(0)) + '</p>' +
            hang +
          '</div>' +
        '</div>',
      bind: function () {
        var manCuaToi = cur, n = QUIZ7.order.length, i;

        function con() { return cur === manCuaToi && !!$('a6msg'); }

        for (i = 0; i < n; i++) {
          (function (k) {
            timers.push(setTimeout(function () {
              if (!con()) { return; }
              var f = $('a6f' + k), t = $('a6t' + k);
              if (f) { f.style.width = '100%'; }
              if (t) { timers.push(setTimeout(function () { if (con() && t) { t.textContent = '✓'; } }, A6_DO_DAY)); }
            }, A6_TRE_DAU + k * A6_NHIP_THANH));
          })(i);
        }

        for (i = 1; i < A6_MOC_CHU.length; i++) {
          (function (k) {
            timers.push(setTimeout(function () {
              if (!con()) { return; }
              $('a6msg').textContent = a6ChuCho(k);
            }, A6_MOC_CHU[k]));
          })(i);
        }

        var daDi = false;
        function sangKetQua() {
          if (daDi || !con()) { return; }
          daDi = true;
          goto(idxOf('hub'));
        }
        timers.push(setTimeout(function () {
          if (!con()) { return; }
          var cho = window.__msThangXong;
          if (!cho) { sangKetQua(); return; }
          Promise.resolve(cho).then(sangKetQua, sangKetQua);
          timers.push(setTimeout(sangKetQua, A6_TRAN_CHO - A6_TONG_CHO));
        }, A6_TONG_CHO));
      }
    };
  };

  /* ---------------------------------------------------------------------------
     MÀN 36 · hub — MÀN KẾT QUẢ

     CỔNG THỨ TƯ. `quiz-giai-doan-1.js:855` cũng khai `RENDER.hub` và nạp SAU file này.
     Cờ `__msMan24` gác đúng hàm đó, khuôn giống `__msMan19` và `__msMan23`.

     🚩 BA CHỖ DỄ VỠ, ghi thẳng để không ai phải suy lại:

     1. HAI THANG ĐIỂM. Thước 4 nấc và ngưỡng "dưới 35 điểm" của `ref/` nói theo thang
        0–100. Biến trong mã là 0–10 (`RAMPS7`). Nhân 10 khi HIỂN THỊ, còn so ngưỡng thì so
        ở thang 0–10 (`A6_NGUONG_THAP = 3.5`). Đem 35 so thẳng với `axes.ground` là mọi hồ
        sơ đều lọt ngưỡng, im lặng.

     2. TÊN VÙNG THỨ HAI KHÔNG ĐƯỢC LỘ. `r.edge2` có sẵn trong `QUIZ7.score(...)` và rất dễ
        in nhầm. Bản miễn phí chỉ được nói "có một vùng thứ hai", không được gọi tên. Sáu
        vùng còn lại hiện đúng tên vùng + ổ khoá, và vùng thứ hai nằm lẫn trong sáu vùng đó
        — không đánh dấu gì thêm.

     3. THÁNG. `ref/` §6D: tháng hiển thị không ở quá khứ và cách hôm nay TỐI ĐA 2 THÁNG;
        không có tháng nào hợp thì đổi ô 1 sang "SECOND AREA BEING PULLED DOWN". Nguồn tháng
        là `/api/quiz/months` (phase 16b): `quiz-giai-doan-1.js` hỏi lúc qua màn `calc` và
        phơi kết quả qua `window.__msThangHan` (= `theHan()`). Trình duyệt KHÔNG tự tính
        tháng nữa (N1, 22/09). `a6Thang()` chỉ thêm trần 2 tháng và chặn tháng đã qua mà
        `theHan()` chưa có.
     --------------------------------------------------------------------------- */

  var A6_NHAN = [
    ['THE ONE WHO GIVES AND GETS LITTLE BACK', 'NGƯỜI CHO ĐI MÀ NHẬN LẠI ÍT'],
    ['THE ONE WHO NEVER FULLY RESTS', 'NGƯỜI CHƯA BAO GIỜ THẬT SỰ NGHỈ'],
    ['THE ONE WHO HOLDS BACK WHAT NEEDS SAYING', 'NGƯỜI GIỮ LẠI ĐIỀU CẦN NÓI'],
    ['THE ONE WHO KEEPS NOTHING FOR HERSELF', 'NGƯỜI KHÔNG GIỮ LẠI GÌ CHO MÌNH'],
    ['THE ONE WHO IS STEADY, WITH ONE AREA TO WATCH', 'NGƯỜI VẪN VỮNG, CÓ MỘT VÙNG CẦN ĐỂ Ý'],
    ['THE ONE WHO IS HOLDING ON BUT LOSING ENERGY', 'NGƯỜI ĐANG GẮNG GIỮ NHƯNG HAO SỨC'],
    ['THE ONE WHO IS RUNNING ON EMPTY', 'NGƯỜI ĐANG CẠN']
  ];

  /* Luật chọn nhãn của v7.9, chép từ `ref/` §"Màn 36" mục "Nhãn kết quả". Chữ bảy nhãn giữ
     nguyên (quyết định khoá 7); chỗ khác với `nhanKieuNguoi()` của `quiz-giai-doan-1.js`
     là ĐƯỜNG CHỌN, và đường trong `ref/` là đường của v7.9. */
  function a6Nhan(r) {
    var i;
    if (r.index < 4) { i = 6; }
    else if (r.index >= 7) { i = 4; }
    else if (r.edge === 'heart') { i = 0; }
    else if (r.edge === 'ground' || r.edge === 'mind') { i = 1; }
    else if (r.edge === 'voice') { i = 2; }
    else if (r.edge === 'line' || r.edge === 'joy') { i = 3; }
    else { i = 5; }
    return isVI() ? A6_NHAN[i][1] : A6_NHAN[i][0];
  }

  /* Câu kéo điểm vùng thấp nhất xuống nhiều nhất, TRONG ĐÚNG 3 CÂU của vùng đó. Hoà thì
     lấy câu có `QSTAT` cao hơn (`ref/` §"Câu bằng chứng `ev`"). */
  function a6CauBangChung(edge) {
    var tot = null, i, q, v, d, s;
    for (i = 0; i < QUIZ7.questions.length; i++) {
      q = QUIZ7.questions[i];
      if (q.tier !== edge) { continue; }
      v = state.q7[q.id];
      if (typeof v !== 'number') { continue; }
      d = QUIZ7.pointsOf(q.id, v);
      s = A6_QSTAT[q.id] || 0;
      if (!tot || d < tot.diem || (d === tot.diem && s > tot.qstat)) {
        tot = { q: q, idx: v, diem: d, qstat: s };
      }
    }
    return tot;
  }

  /* Tháng máy chủ chọn, không ở quá khứ và trong vòng 2 tháng. Trả `null` khi không có —
     gọi hàm phải đi nhánh "vùng thứ hai", đừng nới trần để lấy bằng được một con số.
     `null` cả khi API chưa kịp trả lời, lỗi, hay khách vào thẳng bằng `?screen=`/`?demo=`
     (không đi qua `calc`). */
  var A6_TRAN_THANG = 2;
  var A6_THANG_EN = ['', 'January', 'February', 'March', 'April', 'May', 'June',
                     'July', 'August', 'September', 'October', 'November', 'December'];

  function a6Thang() {
    try {
      if (!state.bdate || typeof window.__msThangHan !== 'function') { return null; }
      var t = window.__msThangHan();
      if (!t) { return null; }
      var now = new Date();
      var cach = (t.nam - now.getFullYear()) * 12 + (t.thang - (now.getMonth() + 1));
      return (cach < 0 || cach > A6_TRAN_THANG) ? null : t;
    } catch (e) {
      /* `quiz-giai-doan-1.js` chưa nạp hoặc đổi hợp đồng. Đi nhánh "vùng thứ hai" — nói ít
         hơn, không nói sai. */
      return null;
    }
  }

  function a6ChuThang(t) {
    return isVI() ? ('Tháng ' + t.thang + ' · ' + t.nam) : (A6_THANG_EN[t.thang] + ' ' + t.nam);
  }

  function a6DemVungThap(r) {
    var n = 0, i;
    for (i = 0; i < QUIZ7.order.length; i++) {
      if (r.axes[QUIZ7.order[i]] < A6_NGUONG_THAP) { n++; }
    }
    return n;
  }

  /* CSS màn kết quả. Mọi luật cho `<p>` phải viết `.screen p.<class>` mới thắng `.screen p`
     của theme (0,1,1) — xem chú thích ở `.a5err`. */
  var A6_STYLE_HUB = [
    '.a6lab{display:block;font-family:var(--sans);font-size:15px;font-weight:700;',
      'letter-spacing:.11em;text-transform:uppercase;color:var(--ink3);margin:26px 0 8px}',
    '.a6label{font-family:var(--serif);font-size:27px;line-height:1.2;margin:6px 0 10px}',
    '.a6card{background:#fff;border:1px solid var(--line);border-radius:14px;',
      'padding:15px 16px;margin:12px 0}',
    '.a6edge{font-family:var(--serif);font-size:25px;line-height:1.2;margin:2px 0 2px}',
    '.a6score{font-family:var(--sans);font-size:38px;font-weight:700;color:#C43D2E;',
      'line-height:1.05;margin:4px 0 12px}',
    '.a6score small{font-size:19px;color:var(--ink3);font-weight:700}',
    /* thước 4 nấc */
    '.a6gauge{margin:6px 0 10px}',
    '.a6gbar{display:flex;height:11px;border-radius:6px;overflow:hidden;gap:2px}',
    '.a6gbar i{flex:1;background:#E6E0F2}',
    '.a6gbar i.on{background:var(--gold)}',
    '.a6gneedle{position:relative;height:14px}',
    '.a6gneedle b{position:absolute;top:0;transform:translateX(-50%);font-size:15px;',
      'color:#C43D2E;font-style:normal}',
    '.a6gnotes{display:flex;gap:2px;margin:5px 0 0}',
    '.a6gnotes span{flex:1;font-family:var(--sans);font-size:13px;line-height:1.25;',
      'color:var(--ink3);text-align:center}',
    '.a6gnotes span.on{color:var(--ink);font-weight:700}',
    '.screen p.a6win{font-size:17px!important;color:var(--ink2)!important;margin:10px 0 0}',
    '.screen p.a6ev{background:#F4EFFC;border-left:3px solid var(--gold);border-radius:10px;',
      'padding:12px 13px;margin:12px 0 0}',
    '.a6alone{background:#F7F4EE;border:1px solid var(--line);border-radius:12px;',
      'padding:12px 14px;margin:12px 0 0}',
    '.a6alone b{display:block;font-family:var(--sans);font-size:14px;letter-spacing:.11em;',
      'text-transform:uppercase;color:var(--gold);margin:0 0 7px}',
    '.a6alone small{display:block;margin-top:7px;font-size:14px;color:var(--ink3)}',
    '.a6alone .a6rsrc{display:block;margin-top:9px;padding-top:9px;',
      'border-top:1px solid var(--line);font-size:15px;color:var(--ink2)}',
    '.a6boxes{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:14px 0}',
    '.a6box{background:#fff;border:1px solid var(--line);border-radius:12px;padding:11px 12px}',
    '.a6box span{display:block;font-family:var(--sans);font-size:13px;font-weight:700;',
      'letter-spacing:.08em;text-transform:uppercase;color:var(--ink3);margin:0 0 5px}',
    '.a6box b{display:block;font-family:var(--serif);font-size:19px;line-height:1.25}',
    '.a6rows{margin:4px 0 0}',
    '.a6row{display:flex;justify-content:space-between;align-items:center;gap:10px;',
      'background:#fff;border:1px solid var(--line);border-radius:11px;',
      'padding:11px 13px;margin:0 0 8px;font-family:var(--sans);font-size:17px}',
    '.a6row em{font-style:normal;color:var(--ink3);font-size:15px;white-space:nowrap}',
    '.screen p.a6bridge{background:#EFE9FB;border-radius:12px;padding:13px 15px;margin:18px 0 0}',
    '.a6lose{margin:12px 0 0}',
    '.a6lose b{display:block;font-size:18px;margin:0 0 5px}',
    '.a6gift{margin:4px 0 0}',
    '.a6gift h4{font-family:var(--serif);font-size:21px;line-height:1.3;margin:14px 0 8px}',
    '.a6gi{position:relative;background:#fff;border:1px solid var(--line);border-radius:11px;',
      'padding:11px 13px;margin:0 0 8px;font-family:var(--sans);font-size:17px;line-height:1.45}',
    /* khối USP hai phần */
    '.a6usp{background:#F4EFFC;border:1px solid var(--line);border-radius:14px;',
      'padding:14px 15px;margin:16px 0}',
    '.a6ub{display:grid;grid-template-columns:1fr auto 1fr;gap:8px;align-items:center}',
    '.a6ubc{background:#fff;border:1px solid var(--line);border-radius:11px;padding:10px 11px}',
    '.a6ubc span{display:block;font-family:var(--sans);font-size:12px;font-weight:700;',
      'letter-spacing:.07em;text-transform:uppercase;color:var(--gold);margin:0 0 5px}',
    '.a6ubc em{display:block;font-style:normal;font-size:16px;line-height:1.35;color:var(--ink)}',
    '.a6ubc i{display:block;font-style:normal;font-size:13px;color:var(--ink3);margin-top:5px}',
    '.a6uba{font-size:21px;color:var(--gold);text-align:center}',
    '.a6usp .a6ut{display:block;font-family:var(--serif);font-size:21px;line-height:1.3;',
      'margin:13px 0 7px}',
    '.a6rl{display:block;font-family:var(--sans);font-size:13px;font-weight:700;',
      'letter-spacing:.09em;text-transform:uppercase;color:var(--ink3);margin:12px 0 6px}',
    '.a6rs{background:#fff;border:1px solid var(--line);border-radius:10px;padding:9px 11px;',
      'margin:0 0 6px;font-family:var(--sans);font-size:16px}',
    '.screen p.a6usrc{font-size:15px!important;color:var(--ink3)!important;margin:10px 0 0}',
    '.screen p.a6ux{font-weight:700;margin:9px 0 0}',
    /* hai khối so sánh */
    '.a6cmp{background:#fff;border:1px solid var(--line);border-radius:13px;',
      'padding:13px 14px;margin:12px 0}',
    '.a6ch{display:block;font-family:var(--sans);font-size:13px;font-weight:700;',
      'letter-spacing:.09em;text-transform:uppercase;color:var(--ink3);margin:0 0 4px}',
    '.a6cmp > b{display:block;font-family:var(--serif);font-size:20px;margin:0 0 9px}',
    '.a6mr{display:flex;justify-content:space-between;gap:10px;padding:7px 0;',
      'border-bottom:1px solid var(--line);font-family:var(--sans);font-size:16px}',
    '.a6mr:last-of-type{border-bottom:0}',
    '.a6arrow{text-align:center;font-size:21px;color:var(--gold);margin:2px 0}',
    '.a6ci{position:relative;padding:7px 0 7px 22px;font-family:var(--sans);font-size:16px;',
      'line-height:1.45;color:var(--ink2)}',
    '.a6ci::before{content:"✓";position:absolute;left:2px;color:#2E7D4F;font-weight:700}',
    /* ảnh trang mẫu */
    '.a6shot{position:relative;border:1px solid var(--line);border-radius:12px;',
      'overflow:hidden;margin:10px 0 0;background:#fff}',
    '.a6shot img{display:block;width:100%;height:auto}',
    '.a6badge{position:absolute;top:9px;left:9px;font-family:var(--sans);font-size:12px;',
      'font-weight:700;letter-spacing:.09em;background:rgba(30,23,51,.86);color:#fff;',
      'padding:4px 9px;border-radius:999px}',
    '.screen p.a6cap{font-size:15px!important;color:var(--ink3)!important;margin:7px 0 0}',
    '.screen p.a6note{font-size:15px!important;color:var(--ink3)!important;margin:12px 0 0}',
    /* nút mua và ba dòng cam kết */
    '.a6promise{margin:9px 0 0}',
    '.a6promise div{position:relative;padding:5px 0 5px 18px;font-family:var(--sans);',
      'font-size:15px;line-height:1.4;color:var(--ink2)}',
    '.a6promise div::before{content:"\\00B7";position:absolute;left:5px;font-weight:700;',
      'color:var(--gold)}',
    /* 29/09/2026 · khối mời mua cố định trong thân báo cáo + thanh dính chỉ còn nút */
    '.a6offer{background:#fff;border:1px solid var(--line);border-radius:14px;',
      'padding:16px 14px 10px;margin:12px 0 18px}',
    /* Không dùng `.is-cta`: `markCTA()` của bundle gỡ lớp đó khỏi mọi nút trừ nút cuối của
       thanh dính. `gd1-mua` mang quầng sáng xanh (quiz-giai-doan-1.css), `a6mua` tô nền. */
    '.a6offer .btn{margin:0}',
    '.a6giua{margin:14px 0 18px}',
    '.screen .btn.a6mua{background:#157A4B!important;color:#fff!important}',
    '.a6offer .a6promise{margin:10px 0 0}'
  ].join('');

  (function a6NapStyleHub() {
    var el = document.createElement('style');
    el.id = 'ms-a6hub-style';
    el.textContent = A6_STYLE_HUB;
    document.head.appendChild(el);
  })();

  var A6_NAC = [
    ['Running low', 'Đang cạn'], ['Holding', 'Còn duy trì'],
    ['Steady', 'Ổn định'], ['Well supported', 'Được nâng đỡ tốt']
  ];

  /* Thước 4 nấc, thang 0–100. Kim đặt theo điểm, kẹp trong [0,100] để hồ sơ biên không
     đẩy kim ra ngoài khung và làm màn trượt ngang ở khổ 390. */
  function a6Thuoc(diem) {
    var nac = Math.min(3, Math.floor(diem / 25)), i;
    var thanh = '', ghi = '';
    for (i = 0; i < 4; i++) {
      thanh += '<i class="' + (i <= nac ? 'on' : '') + '"></i>';
      ghi += '<span class="' + (i === nac ? 'on' : '') + '">' + esc(A1(A6_NAC[i][0], A6_NAC[i][1])) + '</span>';
    }
    var x = Math.max(0, Math.min(100, diem));
    return '<div class="a6gauge">' +
        '<div class="a6gneedle"><b style="left:' + x + '%">▲</b></div>' +
        '<div class="a6gbar">' + thanh + '</div>' +
        '<div class="a6gnotes">' + ghi + '</div>' +
      '</div>';
  }

  /* Cỡ gốc từng ảnh trang mẫu. Ảnh `loading="lazy"` không khai `width`/`height` thì chiếm
     0px chiều cao tới lúc tải xong — đo 21/09: cả ba ảnh trả `getBoundingClientRect().height`
     bằng 0, và trang nhảy đúng chỗ bán hàng khi khách cuộn tới. Khai hai số này để trình
     duyệt tự suy `aspect-ratio` và chừa sẵn ô. */
  var A6_CO_ANH = {
    'qz-inline-47.jpg': [720, 3240], 'qz-inline-36.jpg': [720, 1658],
    'qz-inline-48.jpg': [720, 3116], 'qz-inline-38.jpg': [720, 1371],
    'qz-inline-49.jpg': [720, 3418], 'qz-inline-40.jpg': [720, 1935],
    /* Ba cặp của màn giá (phase 25) — cùng bảng, cùng `a6Anh()`, không dựng bản sao. */
    'qz-inline-50.jpg': [720, 2266], 'qz-inline-42.jpg': [720, 972],
    'qz-inline-51.jpg': [720, 3180], 'qz-inline-44.jpg': [720, 1284],
    'qz-inline-52.jpg': [720, 2532], 'qz-inline-46.jpg': [720, 1095]
  };

  function a6Anh(enFile, viFile, chuEn, chuVi, raLai) {
    var tep = isVI() ? viFile : enFile;
    var co = A6_CO_ANH[tep];
    var kichCo = co ? ' width="' + co[0] + '" height="' + co[1] + '"' : '';
    return '<div class="a6shot"' + (raLai ? ' data-ra-lai="' + raLai + '"' : '') + '>' +
        '<img src="' + a1Anh(tep) + '" alt=""' + kichCo + ' loading="lazy" decoding="async">' +
        '<span class="a6badge">' + esc(A1('ILLUSTRATION', 'ẢNH MINH HOẠ')) + '</span>' +
      '</div>' +
      '<p class="a6cap">' + esc(A1(chuEn, chuVi)) + '</p>';
  }

  /* Thanh dính "See inside the reading" của màn kết quả hiện sau 2 phút đọc (29/09/2026). */
  var A6_DINH_TRE = 120000;

  RENDER.hub = function () {
    var r = res7();
    var edge = r.edge;
    var diem = Math.round((r.axes[edge] || 0) * 10);
    var thap = a6DemVungThap(r);
    var thang = a6Thang();
    var coNgaySinh = !!state.bdate;
    var ev = a6CauBangChung(edge);
    var tenVung = tierName(edge);

    /* ---- khối 3 · dòng "seen" -------------------------------------------- */
    var seen = r.index < 8
      ? A1('You have been carrying a lot, and almost no one has noticed. We noticed, in the 21 answers you just gave.',
           'Bạn đã gánh vác rất nhiều, và gần như không ai nhận ra. Chúng tôi nhận ra, qua chính 21 câu bạn vừa chọn.')
      : A1('You are holding many areas of your life well. Your answers show one area that needs attention first.',
           'Bạn đang giữ được nhiều vùng trong đời mình. Câu trả lời cho thấy một vùng cần được quan tâm trước.');

    /* ---- khối 5 · câu bằng chứng ------------------------------------------ */
    var khoiEv = '';
    if (ev) {
      var leafEv = isVI() ? ev.q.vi : ev.q.en;
      khoiEv = '<p class="a6ev">' + esc(isVI()
        ? 'Bạn chọn “' + leafEv.opts[ev.idx] + '” cho câu: “' + leafEv.q +
          '” Đây là câu trả lời kéo điểm vùng này xuống nhiều nhất.'
        : 'You answered “' + leafEv.opts[ev.idx] + '” to: “' + leafEv.q +
          '” This is the answer that pulled this area’s score down the most.') + '</p>';
    }

    /* ---- khối 6 · "YOU ARE NOT ALONE" -------------------------------------
       Dòng số liệu quiz CHỈ hiện khi chính khách chọn mức nặng ở câu đó — `ev` chỉ được
       dựng từ câu khách đã trả lời, nên "mức nặng" ở đây là hai nấc cuối của thang
       (≤ 2,5 điểm), cùng định nghĩa mà bảng `QSTAT` dùng.
       Dòng nghiên cứu CHỈ hiện với Q1, Q16 và Q11; câu khác thì ẩn, không thay nguồn khác. */
    var khoiAlone = '';
    if (ev && ev.diem <= A4_NGUONG_VI_DU && A6_QSTAT[ev.q.id]) {
      var rk = A6_RSTAT[ev.q.id], rc = rk ? A6_RCHU[rk] : null;
      khoiAlone = '<div class="a6alone">' +
          '<b>' + esc(A1('YOU ARE NOT ALONE', 'BẠN KHÔNG MỘT MÌNH')) + '</b>' +
          '<p>' + esc(isVI()
            ? A6_QSTAT[ev.q.id] + ' trên 100 người đã làm quiz này cũng chọn một trong hai mức nặng nhất ở câu này.'
            : A6_QSTAT[ev.q.id] + ' in 100 people who took this quiz also chose one of the two heaviest answers to this question.') + '</p>' +
          '<small>' + esc(isVI()
            ? 'Tính từ những người ở Mỹ đã làm xong quiz này, tháng 9/2026.'
            : 'Based on people in the U.S. who finished this quiz, September 2026.') + '</small>' +
          (rc ? '<span class="a6rsrc">' + esc(A1(rc.en, rc.vi) + ' — ' + rc.nguon) + '</span>' : '') +
        '</div>';
    }

    /* ---- khối 7 · khung 4 mảnh -------------------------------------------- */
    var m = [];
    if (thap >= A6_SO_VUNG_THAP) {
      m.push(A1('Most of your 7 areas are already running low. This isn’t tiredness, it’s a leak, and it started earlier than you think.',
                'Phần lớn 7 vùng của bạn đã cạn. Đây không phải mệt, đây là rò, và nó bắt đầu sớm hơn bạn nghĩ.'));
    } else if (r.index < 8) {
      m.push(A1('Most of your 7 areas are still holding, but one is already leaking, and you can’t feel it yet.',
                'Phần lớn 7 vùng của bạn vẫn đang giữ được, nhưng một vùng đã rò, và bạn chưa cảm thấy.'));
    }
    m.push(A1('It’s ' + tenVung + '. And it isn’t leaking alone: there’s a second area already going with it. Your report names it.',
              'Đó là ' + tenVung + '. Và nó không rò một mình: có một vùng thứ hai đang đi theo. Báo cáo của bạn gọi tên nó.'));
    if (thang) {
      m.push(A1('The next month that hits it is ' + a6ChuThang(thang) + '. Your map already shows what that month brings, and the one thing to have ready before it.',
                'Tháng tiếp theo chạm vào nó là ' + a6ChuThang(thang) + '. Bản đồ của bạn đã cho thấy tháng đó mang gì tới, và một thứ cần chuẩn bị sẵn trước đó.'));
    } else {
      m.push(A1('Your report shows how long you have before the second area follows, and it’s shorter than you think.',
                'Báo cáo của bạn cho biết bạn còn bao lâu trước khi vùng thứ hai đi theo, và nó ngắn hơn bạn nghĩ.'));
    }
    m.push(A1('There is a plan of action you can start tonight, and it stops the leak from spreading. The plan is on the first page. Get the report and the plan to see it.',
              'Có một kế hoạch hành động để bắt đầu ngay tối nay, chặn chỗ rò không lan. Kế hoạch nằm ở trang đầu. Nhận báo cáo và kế hoạch để xem.'));

    /* ---- khối 8 · hai ô ---------------------------------------------------- */
    var o1 = thang
      ? { lab: A1('MONTH TO GET READY FOR', 'THÁNG CẦN CHUẨN BỊ'), val: a6ChuThang(thang) }
      : { lab: A1('SECOND AREA BEING PULLED DOWN', 'VÙNG THỨ HAI ĐANG BỊ KÉO THEO'),
          val: A1('Named in your reading', 'Gọi tên trong bản đọc') };

    /* ---- khối 9 · sáu vùng còn lại ----------------------------------------
       In ĐÚNG TÊN sáu vùng kia kèm ổ khoá, và KHÔNG đánh dấu gì cho `r.edge2`: vùng thứ
       hai nằm lẫn trong sáu dòng này, đúng như bản miễn phí phải thế. */
    var sauVung = '', i, k;
    for (i = 0; i < QUIZ7.order.length; i++) {
      k = QUIZ7.order[i];
      if (k === edge) { continue; }
      sauVung += '<div class="a6row"><span>' + esc(tierName(k)) + '</span>' +
        '<em>🔒 ' + esc(A1('in your reading', 'trong bản đọc')) + '</em></div>';
    }

    /* ---- khối 12 · khối USP hai phần -------------------------------------- */
    var uspP2 = coNgaySinh
      ? { lab: A1('PART 2 · THE ROAD AHEAD', 'PHẦN 2 · PHÍA TRƯỚC'),
          cuoi: a1Gia(A1('Both parts in one reading. One payment of {gia}.',
                   'Hai phần trong một bản đọc. Trả một lần {gia}.')) }
      : { lab: A1('PART 2 · NEEDS YOUR BIRTH DATE', 'PHẦN 2 · CẦN NGÀY SINH CỦA BẠN'),
          cuoi: A1('Add your birth date after you pay and this part appears in your reading at no extra cost.',
                   'Bổ sung ngày sinh sau khi mua là phần này xuất hiện trong bản đọc, không mất thêm phí.') };

    var moc = [
      A1('The chapter you are in now', 'Chương đời bạn đang đứng'),
      A1('Month by month for the next two years', 'Từng tháng trong hai năm tới'),
      A1('Year by year to 2035', 'Từng năm tới 2035')
    ];

    var nhom1 = [
      A1('Why ' + tenVung + ' ran low first, traced back to what you are carrying. Not because you are weak.',
         'Vì sao ' + tenVung + ' của bạn cạn trước, nối từ chính những việc bạn đang gánh. Không phải vì bạn yếu.'),
      A1('A plan of action written for you: which area to start with, which area gets pulled down next if you do not, and the first thing you can do tonight.',
         'Kế hoạch hành động cho riêng bạn: bắt đầu từ vùng nào, vùng nào sẽ bị kéo theo nếu chưa gỡ, và việc đầu tiên làm được ngay tối nay.'),
      A1('What you have been slowly losing, and how to keep it without adding another task to your day.',
         'Những gì bạn đang mất dần, và cách giữ lại mà không thêm một việc vào ngày của bạn.')
    ];

    var nhom2 = [
      A1('Who you are beneath the mother, the wife, the caregiver. What gives you energy, and which part of you needs care most right now.',
         'Bạn là ai bên dưới vai mẹ, vai vợ, vai người chăm. Điều gì tiếp sức cho bạn, phần nào của bạn đang cần được chăm nhất.'),
      A1('Which chapter of your life you are in, and why the last few years have felt so heavy.',
         'Bạn đang ở chương nào của đời mình, và vì sao vài năm qua nặng đến thế.'),
      A1('This year and next, month by month: which months are easier, which are hard, and what each one tends to bring. For each month, one thing to do and one thing not to do.',
         'Năm nay và năm sau, từng tháng: tháng nào thuận, tháng nào nặng, mỗi tháng thường mang gì tới. Mỗi tháng một việc nên làm, một việc đừng làm.'),
      A1('The next ten years, year by year to 2035: when an old matter returns, when you get your say back, when you can change direction without losing anything.',
         'Mười năm tới, từng năm đến 2035: năm nào chuyện cũ quay lại, năm nào bạn lấy lại quyền quyết, năm nào đổi hướng được mà không mất gì.'),
      A1('Six things you are already dealing with: the month each one comes back, and what to have ready so you are not carrying one more thing on top of everything else.',
         'Sáu chuyện bạn đang gặp rồi: tháng nào nó quay lại, và cần chuẩn bị gì trước để không phải gánh thêm một việc nữa.')
    ];

    function dong(ds) {
      return ds.map(function (t) { return '<div class="a6gi">🔒 ' + esc(t) + '</div>'; }).join('');
    }

    /* ---- khối 13 và 14 · hai khối so sánh ---------------------------------- */
    var mr1 = '';
    for (i = 0; i < QUIZ7.order.length; i++) {
      k = QUIZ7.order[i];
      mr1 += '<div class="a6mr"><span>' + esc(tierName(k)) + '</span><span>' +
        (k === edge ? esc(String(diem)) : '🔒') + '</span></div>';
    }
    var mr2 = [
      A1('Who you are beneath the roles you carry', 'Bạn là ai bên dưới những vai đang gánh'),
      A1('Which chapter of your life you are in', 'Bạn đang ở chương nào của đời mình'),
      A1('The months ahead marked for you', 'Những tháng tới được đánh dấu cho bạn'),
      A1('Every year to 2035, one by one', 'Từng năm tới 2035, từng năm một')
    ].map(function (t) { return '<div class="a6mr"><span>' + esc(t) + '</span><span>🔒</span></div>'; }).join('');

    function tick(ds) {
      return ds.map(function (t) { return '<div class="a6ci">' + esc(t) + '</div>'; }).join('');
    }

    /* Ba dòng cam kết, nguyên văn từ thanh dính cũ; nay nằm trong khối 12b. */
    var a6CamKet =
      '<div class="a6promise">' +
        '<div>' + esc(A1('The next page is free. Nothing is charged until you choose to pay.',
          'Trang tiếp theo miễn phí. Bạn chưa bị tính tiền.')) + '</div>' +
        '<div>' + esc(a1Gia(A1('One payment of {gia}. No subscription, no account.',
          'Trả một lần {gia}. Không thuê bao, không tài khoản.'))) + '</div>' +
        '<div>' + esc(A1('28 days to change your mind. Reply to the email and the money comes back.',
          '28 ngày để đổi ý. Trả lời email là tiền quay về.')) + '</div>' +
      '</div>';

    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          /* 1 · 2 · 3 */
          '<div class="a1kick">' + esc(A1('YOUR RESULT TODAY · FROM THE 21 ANSWERS YOU JUST GAVE',
            'KẾT QUẢ HÔM NAY CỦA BẠN · TỪ 21 CÂU BẠN VỪA CHỌN')) + '</div>' +
          '<h1 class="a6label">' + esc(a6Nhan(r)) + '</h1>' +
          '<p>' + esc(seen) + '</p>' +

          /* 4 · 5 · 6 */
          '<div class="a6card">' +
            '<span class="a6lab" style="margin-top:0">' + esc(A1('THE AREA DRAINING YOUR ENERGY THE MOST',
              'VÙNG ĐANG RÚT CẠN NĂNG LƯỢNG CỦA BẠN NHIỀU NHẤT')) + '</span>' +
            '<div class="a6edge">' + esc(tenVung) + '</div>' +
            '<div class="a6score">' + diem + '<small>/100</small></div>' +
            a6Thuoc(diem) +
            '<p class="a6win">' + esc(A1(
              'Of the 7 areas of your life, this one scored lowest. The score comes from your answers; the higher it is, the better supported that area is.',
              'Trong 7 vùng của đời bạn, đây là vùng có điểm thấp nhất. Điểm tính từ câu trả lời của bạn; càng cao, vùng đó càng được nâng đỡ tốt.')) + '</p>' +
            khoiEv + khoiAlone +
          '</div>' +

          /* 7 · 8 */
          '<span class="a6lab">' + esc(A1('WHAT YOUR ANSWERS SHOW',
            'CÂU TRẢ LỜI CỦA BẠN CHO THẤY GÌ')) + '</span>' +
          '<p>' + esc(m.join(' ')) + '</p>' +
          '<div class="a6boxes">' +
            '<div class="a6box"><span>' + esc(o1.lab) + '</span><b>' + esc(o1.val) + '</b></div>' +
            '<div class="a6box"><span>' + esc(A1('YOUR PLAN OF ACTION', 'KẾ HOẠCH HÀNH ĐỘNG')) +
              '</span><b>' + esc(A1('Start tonight', 'Bắt đầu ngay tối nay')) + '</b></div>' +
          '</div>' +

          /* 9 */
          '<span class="a6lab">' + esc(A1('THE OTHER SIX AREAS', 'SÁU VÙNG CÒN LẠI')) + '</span>' +
          '<div class="a6rows">' + sauVung + '</div>' +
          '<p class="a6win">' + esc(A1(
            'Your summary shows the one area draining you most. The scores for these six areas, and which one is being pulled down next, are in your full reading.',
            'Bản tóm tắt cho bạn thấy một vùng đang rút cạn bạn nhiều nhất. Điểm của sáu vùng này, và vùng nào đang bị kéo theo, nằm trong bản đọc đầy đủ.')) + '</p>' +

          /* 10 · 11 */
          '<p class="a6bridge">' + esc(A1(
            'You now know where your energy is running low. You do not yet know why, or where to start. That is why, when you tried before, spreading yourself across everything changed so little. Your full reading answers exactly these two questions, from the 21 answers you just gave.',
            'Bạn đã biết năng lượng của mình đang cạn ở đâu. Bạn chưa biết vì sao, và bắt đầu từ đâu. Đó là lý do những lần trước bạn dàn sức cho mọi thứ mà đổi được rất ít. Bản đọc đầy đủ trả lời đúng hai câu này, từ chính 21 câu bạn vừa chọn.')) + '</p>' +
          '<div class="a6lose"><b>' + esc(A1('If nothing changes, this is what slowly goes:',
            'Nếu cứ tiếp tục như hiện tại, bạn sẽ mất dần:')) + '</b>' +
            '<p>' + esc(A1(
              'Restful sleep. Your own voice. Small joys. The sense that you are still your own person.',
              'Giấc ngủ thật sự lại sức. Tiếng nói của chính mình. Những niềm vui nhỏ. Cảm giác mình vẫn được là chính mình.')) + '</p></div>' +

          /* 12 */
          '<span class="a6lab">' + esc(A1('WHAT YOUR FULL READING GIVES YOU',
            'BẢN ĐỌC ĐẦY ĐỦ CHO BẠN GÌ')) + '</span>' +
          '<div class="a6gift">' +
            '<h4>' + esc(A1('Understand why your energy is draining, and have a plan of action',
              'Hiểu vì sao năng lượng cạn, và có kế hoạch hành động')) + '</h4>' +
            dong(nhom1) +
            '<div class="a6usp">' +
              '<div class="a6ub">' +
                '<div class="a6ubc"><span>' + esc(A1('PART 1 · WHERE YOU ARE NOW',
                  'PHẦN 1 · HIỆN TẠI')) + '</span>' +
                  '<em>' + esc(A1('Where you are running low, and why.',
                    'Bạn đang cạn ở đâu, và vì sao.')) + '</em>' +
                  '<i>' + esc(A1('from your 21 answers', 'từ 21 câu trả lời')) + '</i></div>' +
                '<div class="a6uba">→</div>' +
                '<div class="a6ubc"><span>' + esc(uspP2.lab) + '</span>' +
                  '<em>' + esc(A1('The way back to yourself, one milestone at a time.',
                    'Con đường tìm lại chính mình, từng mốc.')) + '</em>' +
                  '<i>' + esc(A1('from your birth date', 'từ ngày sinh')) + '</i></div>' +
              '</div>' +
              '<b class="a6ut">' + esc(A1('Get yourself back, and know what the years ahead hold',
                'Tìm lại chính mình, và biết trước những năm tới')) + '</b>' +
              '<p>' + esc(A1(
                'Part one tells you which area is running low, and why. That is where you stand today. But knowing where you are low does not tell you how to move forward. Part two is calculated from your birth date, something your 21 answers cannot show, so it answers what part one cannot: who you are beneath the roles you carry, which chapter of your life you are in, and what to have ready at each milestone ahead. Part one shows the leak. Part two shows the road.',
                'Phần một cho bạn biết vùng nào đang cạn, và vì sao. Đó là chỗ bạn đang đứng. Nhưng biết chỗ cạn chưa cho bạn biết đi tiếp thế nào. Phần hai tính từ ngày sinh, thứ 21 câu hỏi không có, nên nó trả lời được điều phần một không trả lời được: bạn là ai bên dưới những vai đang gánh, bạn đang ở chương nào của đời mình, và từng mốc phía trước cần chuẩn bị gì. Phần một chỉ chỗ rò. Phần hai chỉ đường.')) + '</p>' +
              '<span class="a6rl">' + esc(A1('EACH MILESTONE AHEAD', 'TỪNG MỐC PHÍA TRƯỚC')) + '</span>' +
              moc.map(function (t) { return '<div class="a6rs">' + esc(t) + '</div>'; }).join('') +
              '<p class="a6usrc">' + esc(A1(
                'Part two is worked out from where the 10 planets actually were on the day you were born. It is a way to reflect, not a prediction.',
                'Phần hai tính từ vị trí thật của 10 hành tinh vào ngày bạn sinh. Là một cách suy ngẫm, không phải dự báo.')) + '</p>' +
              '<p class="a6ux">' + esc(uspP2.cuoi) + '</p>' +
            '</div>' +
            dong(nhom2) +
            '<p class="a6win">' + esc(A1(
              'You will know which months your reading marks out, what to have ready before them, and what there is to look forward to in the next chapter of your life.',
              'Bạn sẽ biết bản đọc đánh dấu những tháng nào, cần chuẩn bị gì trước, và chương đời tiếp theo của bạn có gì đáng chờ.')) + '</p>' +
          '</div>' +

          /* 12b · giữa báo cáo CHỈ MỘT NÚT (yêu cầu 29/09/2026), ngay sau phần "bản đọc cho
             bạn gì" và dòng giá của nó. Thông tin đầy đủ nằm ở khối 14b cuối báo cáo. */
          '<div class="a6giua" id="a6giua">' +
            '<button class="btn gd1-mua a6mua cogia" id="go2">' +
              a1NutGia('See inside the reading', 'Xem bên trong bản đọc') + '</button>' +
          '</div>' +

          /* 13 */
          '<span class="a6lab">' + esc(A1('WHAT CHANGES WHEN YOU READ IT',
            'ĐỌC XONG THÌ KHÁC GÌ BÂY GIỜ')) + '</span>' +
          '<div class="a6cmp"><span class="a6ch">' + esc(A1('WHAT YOU HAVE NOW', 'BẠN ĐANG CÓ')) + '</span>' +
            '<b>' + esc(A1('The free summary', 'Bản tóm tắt miễn phí')) + '</b>' + mr1 +
            '<p class="a6win">' + esc(A1(
              'One area has a score. Six are still locked. You do not know why it is that area, and you do not know where to start.',
              'Một vùng có điểm. Sáu vùng còn khoá. Bạn chưa biết vì sao lại là vùng đó, và chưa biết bắt đầu từ đâu.')) + '</p></div>' +
          '<div class="a6arrow">▼</div>' +
          '<div class="a6cmp"><span class="a6ch">' + esc(A1('AFTER YOU READ IT', 'SAU KHI BẠN ĐỌC')) + '</span>' +
            '<b>' + esc(A1('The full reading', 'Bản đọc đầy đủ')) + '</b>' +
            a6Anh('qz-inline-47.jpg', 'qz-inline-36.jpg',
              'An illustration: the 7-area map section of a sample reading. Your own scores open in your reading.',
              'Ảnh minh hoạ: mục Bản đồ 7 vùng của một bản đọc ví dụ. Điểm từng vùng của bạn mở trong bản đọc của bạn.') +
            tick([
              A1('All seven areas have a score, and each area has its own section',
                 'Cả bảy vùng đều có điểm, và mỗi vùng có một mục riêng'),
              A1('Why your lowest area ran low first, and which one is being pulled down with it',
                 'Vì sao vùng thấp nhất của bạn cạn trước, và vùng nào đang bị kéo theo'),
              A1('A plan of action: which area to start with, and the first thing to do tonight',
                 'Kế hoạch hành động: gỡ vùng nào trước, và việc đầu tiên làm tối nay')
            ]) + '</div>' +

          /* 14 */
          '<span class="a6lab">' + esc(A1('AND ABOUT YOU, AND THE YEARS AHEAD',
            'CÒN VỀ CHÍNH BẠN, VÀ NHỮNG NĂM TỚI')) + '</span>' +
          '<div class="a6cmp"><span class="a6ch">' + esc(A1('WHAT YOU HAVE NOW', 'BẠN ĐANG CÓ')) + '</span>' +
            '<b>' + esc(A1('The free summary', 'Bản tóm tắt miễn phí')) + '</b>' + mr2 +
            '<p class="a6win">' + esc(A1(
              'The summary says nothing about you beyond the seven areas. Not who you are beneath the roles you carry. Not what the next years hold.',
              'Bản tóm tắt không nói gì về bạn ngoài bảy vùng. Không nói bạn là ai bên dưới những vai đang gánh. Không nói những năm tới có gì.')) + '</p></div>' +
          '<div class="a6arrow">▼</div>' +
          '<div class="a6cmp"><span class="a6ch">' + esc(A1('AFTER YOU READ IT', 'SAU KHI BẠN ĐỌC')) + '</span>' +
            '<b>' + esc(A1('The full reading', 'Bản đọc đầy đủ')) + '</b>' +
            /* Ảnh 2 và 3 có mốc năm 2027 trên chính ảnh; `data-ra-lai` là hẹn rà lại trước
               khi mốc đó thành quá khứ (`ref/` §F: đặt lịch rà ảnh trước 01/01/2027). */
            a6Anh('qz-inline-48.jpg', 'qz-inline-38.jpg',
              'An illustration: the eight sections of the Spirit Map in a sample reading. Your reading opens with this list of 8 sections; tap any one to go straight to it.',
              'Ảnh minh hoạ: tám mục của bản đồ tâm linh trong một bản đọc ví dụ. Bản đọc mở đầu bằng danh sách 8 mục này, bấm vào mục nào thì tới mục đó.',
              '2027-01-01') +
            tick([
              A1('Who you are beneath the roles you carry, written in plain words',
                 'Bạn là ai bên dưới những vai đang gánh, viết bằng lời dễ hiểu'),
              A1('Which chapter of your life you are in, and when the next one starts',
                 'Bạn đang ở chương nào của đời mình, và chương sau bắt đầu khi nào'),
              A1('Every year to 2035, what each one asks of you and what to prepare first',
                 'Từng năm tới 2035, mỗi năm đòi hỏi gì ở bạn và cần chuẩn bị trước điều gì')
            ]) + '</div>' +
          a6Anh('qz-inline-49.jpg', 'qz-inline-40.jpg',
            'An illustration: the month-by-month section of a sample reading. Your months are worked out from where the planets actually were on your birth date.',
            'Ảnh minh hoạ: mục từng tháng của một bản đọc ví dụ. Các tháng của bạn tính riêng từ vị trí thật của các hành tinh vào ngày sinh của bạn.',
            '2027-01-01') +
          '<p class="a6note">' + esc(coNgaySinh
            ? A1('This part is calculated from the birth date you entered.',
                 'Phần này tính theo ngày sinh bạn đã nhập.')
            : A1('This part is calculated from a birth date. You can add yours after you pay, at no extra cost.',
                 'Phần này tính theo ngày sinh. Bạn có thể bổ sung sau khi mua, không mất thêm phí.')) + '</p>' +

          /* 14b · khối mời mua CỐ ĐỊNH cuối báo cáo (yêu cầu 29/09/2026): nút và ba dòng cam
             kết chuyển từ thanh dính cũ vào đây. Thanh dính (15) chỉ còn nút và hiện muộn. */
          '<span class="a6lab">' + esc(A1('OPEN YOUR FULL READING', 'MỞ BẢN ĐỌC ĐẦY ĐỦ')) + '</span>' +
          '<div class="a6offer" id="a6offer">' +
            '<button class="btn gd1-mua a6mua cogia" id="go3">' +
              a1NutGia('See inside the reading', 'Xem bên trong bản đọc') + '</button>' +
            a6CamKet +
          '</div>' +
        '</div>' +

        /* 15 · nút không phải nút mua: nó mở màn giá. Từ 29/09/2026 thanh dính CHỈ CÒN NÚT,
           ẩn lúc đầu và hiện sau `A6_DINH_TRE` ms khách ở lại màn này (ba dòng cam kết đã
           vào khối 12b). Vẫn giữ lớp `.foot`: bỏ nó là `dockLone()` của bundle tự bê nút
           cuối màn ra một thanh `.v3foot` khác. `.foot` không khai `display`, nên thuộc tính
           `hidden` ẩn được nó (cùng cách `#a7stk` của màn giá). */
        '<div class="foot" id="a6stk" hidden><button class="btn cogia" id="go">' +
          a1NutGia('See inside the reading', 'Xem bên trong bản đọc') + '</button>' +
        '</div>',
      bind: function () {
        /* Hai event mục 4.9 của màn kết quả, đúng tên và dạng của `quiz-giai-doan-1.js`
           `ganKetQua()` — hàm đó không còn chạy từ khi file này thay `RENDER.hub`. */
        if (lanXemMoi('hub')) {
          suKienA7('result_view', { screen: 'hub', edge: edge || '', edge_score: diem,
            band: (r.band && r.band.key) || '', has_birthdate: coNgaySinh });
        }
        /* Ba nút (12b giữa báo cáo, 14b cuối báo cáo, thanh dính) cùng một việc, cùng một
           event như trước. */
        function bamMo() { sfx('tap'); suKienA7('cta_click', { screen: 'hub' }); next(); }
        ['go', 'go2', 'go3'].forEach(function (id) { if ($(id)) { $(id).onclick = bamMo; } });

        /* Thanh dính: hiện sau `A6_DINH_TRE`, và tự ẩn lúc nút 12b hoặc khối 14b đang nằm
           trong khung — để khách không thấy hai nút giống hệt chồng lên nhau. */
        var manCuaToi = cur, stk = $('a6stk'), scr = $('scr');
        var khoi = [$('a6giua'), $('a6offer')].filter(Boolean);
        var duHan = false, dangThay = {};
        function veThanh() {
          if (cur !== manCuaToi || !stk) { return; }
          var thayKhoi = khoi.some(function (el) { return dangThay[el.id]; });
          var an = !(duHan && !thayKhoi);
          if (stk.hidden !== an) {
            stk.hidden = an;
            /* Lúc dựng thanh còn `hidden`, đo ra 0 nên `gonNut()` bỏ qua — đo lại khi hiện. */
            if (!an && typeof window.__msGonNut === 'function') { window.__msGonNut(stk); }
          }
        }
        if (khoi.length && scr && typeof IntersectionObserver === 'function') {
          var io = new IntersectionObserver(function (ds) {
            ds.forEach(function (d) { dangThay[d.target.id] = d.isIntersecting; });
            veThanh();
          }, { root: scr });
          khoi.forEach(function (el) { io.observe(el); });
        }
        timers.push(setTimeout(function () { duHan = true; veThanh(); }, A6_DINH_TRE));
        a7NhoChoDo();
      }
    };
  };

  /* Cờ cho `quiz-giai-doan-1.js:855`, cùng khuôn với `__msMan19` và `__msMan23`. */
  window.__msMan24 = true;

  /* ---------------------------------------------------------------------------
     A7 (phase 25) · MÀN GIÁ · màn 37 `gd1off`

     🚩 ĐÂY LÀ MÀN QUYẾT ĐỊNH DOANH THU, và khổ nghiệm thu là **390 × 680** — trình duyệt
     trong app Facebook, nơi phần lớn khách tới từ quảng cáo. Số đo cũ: "bấm mua 26/86,
     hoàn tất 0/26, trong đó 19/26 bấm trong 6 giây đầu" — tức bấm KHI CHƯA THẤY GIÁ, vì
     bản đang chạy để nút dính đáy hiện trước còn hai thẻ giá nằm dưới 12 dòng lợi ích.

     CỔNG THỨ NĂM. `quiz-giai-doan-1.js:917` cũng khai `RENDER.gd1off` và nạp SAU file này.
     Cờ `__msMan25` gác đúng hàm đó, cùng khuôn `__msMan19` · `__msMan23` · `__msMan24`.

     BỐN CHỖ DỄ VỠ, ghi thẳng để không ai phải suy lại:

     1. KIỂU MÀN GIỮ NGUYÊN `gd1off`. Đổi tên kiểu là mất cả chuỗi sự kiện phễu đang lọc
        theo tên đó. `checkout_start` mang `screen: 'gd1off'`, đúng màn khách bấm mua;
        `offer_view` · `plan_select` vẫn bắn với `screen: 'hub'` như bản cũ, một lần mỗi
        lần xem màn (`lanXemMoi()`).

     2. THỨ TỰ KHỐI ĐỔI SO VỚI `ref/`, CÓ CHỦ Ý. `ref/` xếp cầu nối ("Your score tells you
        which area needs attention first…") TRÊN thẻ giá. Ba khối chữ liền nhau đẩy đáy nút
        mua xuống quá 680px ở khổ 390. Task 25.2 cho phép sắp lại, nên cầu nối xuống ngay
        DƯỚI thẻ giá — chữ không đổi một từ, chỉ đổi chỗ.

     3. THANH DÍNH MANG CLASS `.foot`. `dockLone()` (`quiz-inner-weather.js:26048`) tự DỜI
        nút `.btn` cuối cùng trong `#scr` vào một thanh `.v3foot` khi màn cao hơn 1,5 màn
        hình VÀ trong `#scr` không có `.stickybar` / `.foot` / `.v3foot`. Màn này cao gấp
        nhiều lần; không có `.foot` thì nút của thẻ giá thứ hai bị lôi ra khỏi thẻ.
        `querySelector` thấy cả thẻ đang `hidden`, nên thanh vẫn gác được lúc còn ẩn.

     4. KHÔNG GỌI `chotTen()`. Hàm đó thay tên rỗng bằng "Friend" (`quiz-giai-doan-1.js:393`),
        mà `ref/` §6C đòi tên trống thì màn giá hiện "Your reading is ready." — không dấu
        phẩy mồ côi, cũng không tên bịa. Ba cổng `__msMan23` · `__msMan24` · `__msMan25` đã
        chặn cả ba chỗ gọi `chotTen()` còn lại.

     BỎ HẲN so với bản đang chạy: hai thẻ chọn gói, gói $19 chọn sẵn, danh sách "5 SOLUTIONS",
     và mọi chuỗi `$9.99` · `$100`. Đồng hồ giữ giá quay lại theo A2 (22/09) — dựng mới ở
     `a7DongHo()`, không dùng `bindCountdown()` của bundle (hết giờ nó xoá câu trả lời và đưa
     khách về màn 1). $19 chỉ hiện khi hết giờ, qua `giaHienTai()`.
     --------------------------------------------------------------------------- */

  /* Mốc của quiz. Tuổi in trên màn = `A7_MOC_NAM - năm sinh` (`ref/` §"Màn 37"). Quiz đổi
     mốc thì đổi đúng một chỗ này. */
  var A7_MOC_NAM = 2035;

  var A7_STYLE = [
    /* Tiêu đề màn giá nhỏ hơn `.big` (32px) của theme: ba dòng chữ trên thẻ giá phải gói
       trong 680px kể cả thanh trên. Vẫn là cỡ tiêu đề, không phải cỡ thân bài. */
    '.a7h1{font-family:var(--serif);font-size:27px;line-height:1.2;margin:2px 0 10px}',
    /* đồng hồ giữ giá — số đỏ đếm từng giây, theo `.cdbox` của prototype. Màu phải
       `!important`: `quiz-inner-weather.css` khai `b, strong{color:…!important}`, đo 23/09
       số ra màu mực, không đỏ. */
    '.a7cd{display:flex;align-items:baseline;gap:10px;margin:-4px 0 8px}',
    '.screen .a7cd b{font-family:var(--sans);font-size:26px;font-weight:800;line-height:1;',
      'color:#C43D2E!important;font-variant-numeric:tabular-nums;letter-spacing:.02em}',
    '.screen .a7cd span{font-family:var(--sans);font-size:15px;color:var(--ink2)}',
    '.screen p.a7lead{margin:0 0 12px}',
    '.screen p.a7bridge{background:#EFE9FB;border-radius:12px;padding:12px 14px;margin:14px 0 0}',
    /* thẻ giá */
    '.a7pc{background:#F4EFFC;border:2px solid var(--gold);border-radius:16px;',
      'padding:14px 15px 15px;margin:0}',
    '.a7pc .a7lab{display:block;font-family:var(--sans);font-size:13px;font-weight:700;',
      'letter-spacing:.07em;line-height:1.35;color:var(--ink3);margin:0 0 6px}',
    '.a7big{font-family:var(--serif);font-size:44px;line-height:1;color:var(--ink);margin:0 0 8px}',
    '.screen p.a7pcp{font-size:17px!important;margin:0 0 12px}',
    '.screen p.a7pay{font-size:15px!important;color:var(--ink3)!important;',
      'text-align:center!important;margin:8px 0 0}',
    /* Nút mua xanh như nút mua của bản đang chạy (`.gd1-mua`, `quiz-giai-doan-1.css:146`).
       `.btn` của theme ép tím bằng `!important` ở (0,1,0); `<style>` này nằm trong `<head>`
       tức TRƯỚC thẻ `<link>` của section, nên hoà độ đặc hiệu là thua. Phải leo lên (0,2,0)
       bằng `.screen .a7buy` mới thắng — cùng cái bẫy đã ghi ở `.a5err`. */
    /* CỠ CHỮ NÚT PHẢI TỰ LO, KHÔNG NHỜ `gonNut()`. `quiz-giai-doan-1.css:142` khai
       `.btn{white-space:nowrap}` và `:231` in hoa mọi nút, nên nhãn "Get my full reading ·
       $4.90" ở 20px cần 351px trong một nút rộng 312px — đo 21/09 ở khổ 390: chữ bị cắt
       đúng chỗ con số tiền. `gonNut()` (`quiz-giai-doan-1.js:370`) lẽ ra hạ cỡ chữ cho vừa
       nhưng nó chạy trong `bindShell()`, tức TRƯỚC `bind()` và trong lúc `goto()` còn đang
       mờ dần, nên nút nào `offsetWidth` bằng 0 lúc đó là nó bỏ qua. Hạ sẵn xuống 17px, và
       cho xuống dòng làm lưới cuối: nhãn dài hơn ở thứ tiếng khác thì tràn hai dòng, không
       bao giờ cụt mất giá. Đo lại ở 390 sau khi hạ: nhãn EN dài 295px trong 292px lòng nút
       ở 17px (tràn hai dòng), vừa một dòng ở 16px. */
    '.screen .a7buy{background:#157A4B!important;color:#FFFFFF!important;',
      'font-size:16px!important;letter-spacing:.02em;padding-left:10px;padding-right:10px;',
      'white-space:normal!important;line-height:1.2}',
    /* bảo đảm 28 ngày và dải bảo chứng */
    '.a7guar{background:#fff;border:1px solid var(--line);border-radius:12px;',
      'padding:12px 14px;margin:14px 0 0}',
    '.a7guar b{display:block;font-size:18px;margin:0 0 5px}',
    '.a7guar p{margin:0}',
    '.a7trust{margin:12px 0 0}',
    '.a7trust b{display:block;font-family:var(--sans);font-size:14px;font-weight:700;',
      'letter-spacing:.08em;text-transform:uppercase;color:var(--ink3);margin:0 0 6px}',
    '.a7trust div{position:relative;padding:5px 0 5px 18px;font-family:var(--sans);',
      'font-size:16px;line-height:1.45;color:var(--ink2)}',
    '.a7trust div::before{content:"\\00B7";position:absolute;left:5px;font-weight:700;',
      'color:var(--gold)}',
    /* trích lời khách */
    '.a7quote{background:#F4EFFC;border-left:3px solid var(--gold);border-radius:10px;',
      'padding:12px 14px;margin:16px 0 0}',
    '.a7quote span{display:block;font-family:var(--sans);font-size:13px;font-weight:700;',
      'letter-spacing:.1em;text-transform:uppercase;color:var(--gold);margin:0 0 7px}',
    '.a7quote p{margin:5px 0 0}',
    /* tiêu đề mục và danh sách lợi ích */
    '.a7h3{font-family:var(--serif);font-size:22px;line-height:1.3;margin:22px 0 8px}',
    '.a7ben{list-style:none;margin:0;padding:0}',
    '.a7ben li{position:relative;padding:7px 0 7px 19px;font-family:var(--sans);',
      'font-size:17px;line-height:1.45;color:var(--ink2)}',
    '.a7ben li::before{content:"\\00B7";position:absolute;left:5px;font-weight:700;',
      'color:var(--gold)}',
    /* khối Phần 2 */
    '.a7usp{background:#F4EFFC;border:1px solid var(--line);border-radius:14px;',
      'padding:14px 15px;margin:16px 0}',
    '.a7usp .a7ub{display:block;font-family:var(--sans);font-size:13px;font-weight:700;',
      'letter-spacing:.07em;text-transform:uppercase;color:var(--gold);margin:0 0 6px}',
    '.a7usp .a7ut{display:block;font-family:var(--serif);font-size:21px;line-height:1.3;',
      'margin:0 0 9px}',
    '.a7usp strong{display:block;font-size:18px;margin:0 0 7px}',
    '.screen p.a7usrc{font-size:15px!important;color:var(--ink3)!important;margin:10px 0 0}',
    '.screen p.a7ux{font-weight:700;margin:9px 0 0}',
    '.a7bd{display:block;margin:9px 0 0;background:none;border:0;color:var(--ink3);',
      'font-size:16px;text-align:left;text-decoration:underline;cursor:pointer;min-height:44px}',
    /* cách dùng phần 2 */
    '.a7use{background:#fff;border:1px solid var(--line);border-radius:12px;',
      'padding:12px 14px;margin:14px 0 0}',
    '.a7use b{display:block;font-size:18px;margin:0 0 5px}',
    '.a7use ol{margin:0;padding-left:20px}',
    '.a7use li{font-family:var(--sans);font-size:16px;line-height:1.45;color:var(--ink2);',
      'padding:5px 0}',
    '.screen p.a7payoff{font-weight:700;margin:14px 0 0}',
    /* mục lục */
    '.a7toc{background:#fff;border:1px solid var(--line);border-radius:12px;',
      'padding:12px 14px;margin:0}',
    '.a7toc b{display:block;font-family:var(--sans);font-size:15px;font-weight:700;',
      'line-height:1.4;margin:9px 0 4px}',
    '.a7toc b:first-child{margin-top:0}',
    '.a7toc div{font-family:var(--sans);font-size:16px;line-height:1.5;color:var(--ink2)}',
    /* trích đoạn bản đọc mẫu */
    '.a7bq{background:#F7F4EE;border-left:3px solid var(--gold);border-radius:10px;',
      'padding:13px 15px;margin:0}',
    '.a7bq p{margin:0}',
    '.a7bq small{display:block;margin-top:8px;font-size:14px;color:var(--ink3)}',
    '.a7src{margin:12px 0 0}',
    /* `display:flex` xoá mũi tên mở/đóng mặc định của WebKit, nên ô gấp trông y như một
       dòng chữ thường. Gạch chân là cách file này đã đánh dấu "bấm được" ở `.a5skip`,
       `.a1back` và `.a7lui` — dùng lại, đừng đẻ thêm một kiểu thứ hai. */
    '.a7src summary{font-family:var(--sans);font-size:17px;color:var(--ink2);',
      'cursor:pointer;min-height:44px;display:flex;align-items:center;',
      'text-decoration:underline}',
    /* hỏi đáp */
    '.a7faq > div{background:#fff;border:1px solid var(--line);border-radius:12px;',
      'padding:12px 14px;margin:0 0 9px}',
    '.a7faq b{display:block;font-size:18px;line-height:1.35;margin:0 0 5px}',
    '.a7faq p{margin:0}',
    '.a7today{background:#F4EFFC;border-radius:12px;padding:12px 14px;margin:14px 0 0}',
    '.a7today b{display:block;font-size:18px;margin:0 0 5px}',
    '.a7today div{position:relative;padding:5px 0 5px 18px;font-family:var(--sans);',
      'font-size:16px;line-height:1.45;color:var(--ink2)}',
    '.a7today div::before{content:"\\00B7";position:absolute;left:5px;font-weight:700;',
      'color:var(--gold)}',
    /* bảng trước / sau */
    '.a7ba{background:#fff;border:1px solid var(--line);border-radius:12px;',
      'padding:12px 14px;margin:0 0 9px}',
    '.a7ba .a7b4a{font-family:var(--serif);font-size:19px;line-height:1.3;margin:0 0 6px}',
    '.a7ba .a7b4b{position:relative;padding:0 0 0 19px;font-family:var(--sans);',
      'font-size:16px;line-height:1.45;color:var(--ink2)}',
    '.a7ba .a7b4b::before{content:"\\2713";position:absolute;left:2px;color:#2E7D4F;',
      'font-weight:700}',
    /* Căn TRÁI, không để `.screen p{text-align:justify}` của theme giành: đoạn chân trang
       có một dòng ngắn ở cuối, justify kéo chữ ra thành những khoảng trắng rộng giữa câu.
       Cùng lý do `.a5price` của phase 23 phải ghi đè. */
    '.screen p.a7legal{font-size:14px!important;color:var(--ink3)!important;',
      'text-align:left!important;margin:14px 0 0}',
    '.a7lui{display:block;margin:10px auto 0;background:none;border:0;color:var(--ink3);',
      'font-size:16px;text-decoration:underline;cursor:pointer;min-height:44px}',
    /* THANH DÍNH. `.foot` của theme đã lo dính đáy, nền đặc, viền trên và bóng đổ
       (`quiz-inner-weather.css:2024`); ở đây chỉ xếp con bên trong. Cỡ chữ nút hạ xuống
       17px vì `gonNut()` đo lúc `bindShell()` chạy, mà lúc đó thanh còn `hidden` nên
       `offsetWidth` bằng 0 và nó bỏ qua nút này. */
    '.a7stkin{display:flex;align-items:center;gap:12px}',
    '.a7stkin b{font-family:var(--serif);font-size:26px;line-height:1;flex:0 0 auto}',
    '.a7stkin .btn{flex:1 1 auto;min-width:0;font-size:17px!important}',
    /* LỚP HỎI. `position:fixed` là lối đã có trong repo (`.v3fx-gift`,
       `quiz-inner-weather.js:25150`); không ancestor nào khai `transform` nên nó neo vào
       khung nhìn thật. Hộp có `max-width` để trên desktop không kéo thành một dải ngang. */
    '.a7ask{position:fixed;inset:0;z-index:9998;display:flex;align-items:center;',
      'justify-content:center;padding:20px;background:rgba(30,23,51,.55)}',
    '.a7ask[hidden]{display:none}',
    '.a7askbox{width:100%;max-width:330px;background:#FBF8F3;border-radius:16px;',
      'padding:18px 18px 16px;box-shadow:0 20px 50px rgba(30,23,51,.3)}',
    '.a7askbox b{display:block;font-family:var(--serif);font-size:22px;line-height:1.25;',
      'margin:0 0 8px}',
    '.a7askbox p{margin:0 0 14px}',
    '.a7askbox .a7lui{margin-top:6px}'
  ].join('');

  (function a7NapStyle() {
    var el = document.createElement('style');
    el.id = 'ms-a7-style';
    el.textContent = A7_STYLE;
    document.head.appendChild(el);
  })();

  /* Lựa chọn ĐẦU của một câu chọn nhiều, tra theo `stable_key` chứ không theo vị trí ô.

     `state.q7['M-A']` lưu VỊ TRÍ trong danh sách đã sắp theo `ord` — đó là cách phase 21
     ghi, và `quiz-goi-api.js:125` cũng đổi vị trí đó sang `stable_key` bằng đúng bảng
     `ord → stable_key` của bộ đề trước khi gửi lên máy chủ. Ở đây đi cùng một đường: vị
     trí → `stable_key` → nhãn của CHÍNH option mang khoá đó. Đọc thẳng `leaf.opts[i]` thì
     chữ trên màn giá và chữ đã gửi lên máy chủ là hai nguồn khác nhau, và chúng lệch nhau
     im lặng ngay lần đầu thứ tự lựa chọn trong DB đổi.

     Bản tiếng Việt vẫn tra theo vị trí: `MULTI_VI` là bảng của FE, xếp theo `ord`, DB
     không có cột tiếng Việt (`contracts.md` C4). Vị trí lấy lại TỪ khoá, không phải vị trí
     khách bấm, nên hai thứ tiếng luôn trỏ vào cùng một lựa chọn. */
  function a7LuaChonDau(id) {
    var M = null, i;
    for (i = 0; i < snap.multi.length; i++) {
      if (snap.multi[i].id === id) { M = snap.multi[i]; break; }
    }
    if (!M) { return null; }
    var da = state.q7[id];
    if (!Array.isArray(da) || !da.length) { return null; }
    var sap = M.options.slice().sort(function (a, b) { return a.ord - b.ord; });
    var oViTri = sap[da[0]];
    if (!oViTri || !laChuoi(oViTri.stable_key)) { return null; }
    var khoa = oViTri.stable_key, j = -1;
    for (i = 0; i < sap.length; i++) { if (sap[i].stable_key === khoa) { j = i; break; } }
    if (j < 0) { return null; }
    var bangVi = MULTI_VI[id];
    return {
      key: khoa,
      chu: isVI() ? ((bangVi && bangVi.opts[j]) || sap[j].label) : sap[j].label
    };
  }

  /* Dấu câu của hai thứ tiếng khác nhau: tiếng Anh để dấu chấm TRONG ngoặc kép, tiếng Việt
     để ngoài. Cắt dấu chấm cuối của nhãn trước, nếu không sẽ ra hai dấu. */
  function a7NhayKep(chu) {
    var t = String(chu).replace(/[.。]$/, '');
    return isVI() ? ('“' + t + '”.') : ('“' + t + '.”');
  }

  /* Ngày sinh in theo thói quen từng thứ tiếng, khớp màn 33: Mỹ đọc Tháng D, Năm. */
  function a7NgaySinh(b) {
    return isVI()
      ? (b.d + '/' + b.m + '/' + b.y)
      : (A5_THANG_EN[b.m - 1] + ' ' + b.d + ', ' + b.y);
  }

  function a7TheGia(id, idNut) {
    return '<div class="a7pc" id="' + id + '">' +
        '<span class="a7lab">' + esc(A1(
          'YOUR FULL READING · 7-AREA REPORT · PLAN OF ACTION · BIRTH-DATE MAP',
          'BẢN ĐỌC ĐẦY ĐỦ · BÁO CÁO 7 VÙNG · KẾ HOẠCH HÀNH ĐỘNG · BẢN ĐỒ THEO NGÀY SINH')) + '</span>' +
        '<div class="a7big">' + giaHienTai() + '</div>' +
        '<p class="a7pcp">' + esc(A1(
          'You pay once, with no subscription. Your reading arrives by email in a few minutes, and it is yours to keep and read again.',
          'Bạn chỉ trả một lần, không đăng ký trả phí định kỳ. Bản đọc tới email trong vài phút, bạn giữ lại và đọc lại được.')) + '</p>' +
        '<button class="btn a7buy cogia" id="' + idNut + '">' +
          a1NutGia('Get my full reading', 'Nhận bản đọc đầy đủ') + '</button>' +
        '<p class="a7pay">' + esc(A1(
          'Pay with Apple Pay, Shop Pay, PayPal, Google Pay or a card.',
          'Trả bằng Apple Pay, Shop Pay, PayPal, Google Pay hoặc thẻ.')) + '</p>' +
      '</div>';
  }

  /* Sáu câu hỏi đáp, chép nguyên văn `ref/3-NGUYEN-LIEU/3-chu-tung-man/`. Câu thứ tư nói
     thẳng có dịch vụ riêng NGOÀI $4.90 (HANDOFF 1i) — đừng rút gọn nó. */
  var A7_FAQ = [
    ['“How and when do I get my reading?”',
     'By email, within a few minutes of paying. You open it on your phone and it is yours to keep and read again.',
     '“Tôi nhận bản đọc thế nào và khi nào?”',
     'Qua email, trong vài phút sau khi trả tiền. Bạn mở trên điện thoại, giữ lại và đọc lại được.'],
    ['“Is this going to tell me something is wrong with me?”',
     'No. Your reading looks at what you carry and the area of your life with the least support. It does not judge you. If a sentence does not describe you, skip it.',
     '“Bản đọc có khiến tôi thấy mình có vấn đề không?”',
     'Không. Bản đọc xem xét những gì bạn đang gánh vác và vùng trong cuộc sống mà bạn ít được hỗ trợ nhất. Bản đọc không phán xét bạn. Câu nào không đúng với bạn thì bỏ qua.'],
    ['“Am I signing up for something?”',
     'No. One payment of {gia}. No subscription, no account, nothing to cancel later.',
     '“Tôi có đang đăng ký gì không?”',
     'Không. Trả một lần {gia}. Không thuê bao, không tài khoản, không có gì phải huỷ.'],
    ['“Is any part locked after I pay?”',
     'Everything described on this page is in the reading you receive. Mine Spirit also offers separate services, such as one-to-one guidance. They are optional, they are not part of the {gia}, and your reading is complete without them.',
     '“Sau khi trả tiền còn phần nào bị khoá không?”',
     'Mọi phần mô tả trên trang này đều nằm trong bản đọc bạn nhận. Mine Spirit còn có các dịch vụ riêng, ví dụ hướng dẫn riêng một kèm một. Chúng là tuỳ chọn, không nằm trong {gia}, và bạn không cần chúng để đọc bản đọc của mình.'],
    ['“I skipped my birth date. Can I still get the years ahead?”',
     'Yes. Add your birth date after you pay and that part appears in your reading at no extra cost.',
     '“Tôi đã bỏ qua ngày sinh. Tôi còn nhận được phần những năm tới không?”',
     'Có. Bạn bổ sung ngày sinh sau khi trả tiền và phần đó sẽ hiện trong bản đọc, không mất thêm phí.'],
    ['“I have read things like this before and nothing changed.”',
     'Most quizzes stop at a label. This reading goes further: which area ran low first, which one is being pulled down next, and the first thing to do about it. If you read it and it does not fit you, reply to the email and your money comes back.',
     '“Tôi đọc mấy thứ kiểu này rồi, chẳng đổi gì.”',
     'Phần lớn bài trắc nghiệm dừng ở cái nhãn. Bản đọc này đi tiếp: vùng nào cạn trước, vùng nào đang bị kéo theo, và việc đầu tiên nên làm. Đọc xong thấy không đúng với mình thì trả lời email, tiền quay về.']
  ];

  var A7_BA4 = [
    ['“I am tired and I do not know why.”',
     'You have a score for all seven areas, and the explanation of why your lowest one ran low first.',
     '“Tôi mệt mà không biết vì sao.”',
     'Bạn có điểm cả bảy vùng, và phần giải thích vì sao vùng thấp nhất của bạn cạn trước.'],
    ['“I do not know where to start.”',
     'You have a plan of action: which area to start with, and the first thing to do tonight.',
     '“Tôi không biết nên bắt đầu từ đâu.”',
     'Bạn có kế hoạch hành động: gỡ vùng nào trước, và việc đầu tiên làm tối nay.'],
    ['“I do not know who I am outside everything I look after.”',
     'You learn who you are beneath those roles, and which chapter of your life you are in.',
     '“Tôi không biết mình là ai ngoài những việc đang lo.”',
     'Bạn đọc được bạn là ai bên dưới những vai đó, và bạn đang ở chương nào của đời mình.'],
    ['“I do not know what the next months hold.”',
     'You have the months marked for you, each with one thing to do and one thing not to do.',
     '“Tôi không biết những tháng tới có gì.”',
     'Bạn có những tháng được đánh dấu cho mình, mỗi tháng một việc nên làm và một việc đừng làm.']
  ];

  /* ---- đồng hồ giữ giá (C2a, C2b) --------------------------------------------- */

  function a7ConLai() {
    var m = mocGiuGia();
    return m === null ? GIU_GIA_MS : Math.max(0, m - Date.now());
  }

  function a7ChuDongHo() {
    var giay = Math.ceil(a7ConLai() / 1000);
    return Math.floor(giay / 60) + ':' + (giay % 60 < 10 ? '0' : '') + (giay % 60);
  }

  function a7NhanDongHo() {
    return hetGiuGia()
      ? A1('The time holding your price has ended', 'Hết thời gian giữ giá của bạn')
      : A1('Your price is held for you', 'Mức giá của bạn đang được giữ');
  }

  /* Variant cho đường mua: còn giờ là chuỗi rỗng (gói mặc định $4.90), hết giờ là variant
     $19 mà `quiz-sang-trang-ban.js` đọc từ `data-variant-goi-cao`. */
  function a7BienThe() { return hetGiuGia() ? (window.__msVariantCao || '') : ''; }

  function a7DungSanGio() {
    if (typeof window.__msDungSanGio !== 'function') { return; }
    try { window.__msDungSanGio(a7BienThe()); } catch (e) {}
  }

  /* Mã phiên của ĐÚNG lượt này — cùng luật với `phienCuaLuot()` của `quiz-giai-doan-1.js`:
     mã còn nằm lại từ lượt trước là mã sai, không phải mã thiếu. */
  var A7_DANG_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function a7Phien() {
    try {
      var v = (sessionStorage.getItem('minespirit_phien') ||
               localStorage.getItem('minespirit_phien') || '').trim();
      if (!A7_DANG_UUID.test(v)) { return ''; }
      return localStorage.getItem('minespirit_phien_luot') === a1Luot() ? v : '';
    } catch (e) { return ''; }
  }

  /* Chờ lượt gửi bài đang bay (nó mới sinh ra mã phiên) có giới hạn; quá hạn thì hỏi với
     cái đang có, không có mã thì dùng mốc ở trình duyệt. */
  var A7_CHO_PHIEN_MS = 4000;

  /* `POST /api/quiz/price-hold` (C13). Trả Promise của mốc theo đồng hồ máy khách, hoặc
     `null` khi không hỏi được — lỗi mạng, 4xx, 5xx, thân sai đều ra `null`, và người gọi
     giữ nguyên mốc ở trình duyệt. Bù lệch: `now` của máy chủ ứng với điểm giữa quãng
     gửi–nhận. */
  function a7HoiMayChu() {
    var goc = document.getElementById('phone');
    var api = goc ? (goc.getAttribute('data-goc-api') || '').replace(/\/+$/, '') : '';
    if (!api || typeof fetch !== 'function') { return Promise.resolve(null); }
    var bay = window.__msPhienDangBay || null;
    var cho = new Promise(function (xong) {
      setTimeout(xong, bay ? A7_CHO_PHIEN_MS : 0);
      if (bay && typeof bay.then === 'function') { bay.then(xong, xong); }
    });
    return cho.then(function () {
      var ma = a7Phien();
      if (!ma) { return null; }
      var gui = Date.now();
      return fetch(api + '/api/quiz/price-hold', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: ma })
      }).then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (d) {
        var het = d && Date.parse(d.hold_until), bayGio = d && Date.parse(d.now);
        if (!isFinite(het) || !isFinite(bayGio)) { return null; }
        var lech = bayGio - (gui + Date.now()) / 2;
        return d.expired === true ? Math.min(het - lech, Date.now()) : het - lech;
      });
    })['catch'](function () { return null; });
  }

  /* Hết giờ lúc khách ĐANG ở màn 37: đổi số tại chỗ, không vẽ lại màn (vẽ lại là mất chỗ
     đang cuộn). Chỉ đổi chữ trong `#scr` và bỏ qua thẻ nhận xét `.a1rv` (ngoại lệ A4). */
  function a7HetGio() {
    var nhan = $('a7cdl'), scr = document.getElementById('scr');
    if (nhan) { nhan.textContent = a7NhanDongHo(); }
    if (scr && document.createTreeWalker) {
      var w = document.createTreeWalker(scr, 4 /* NodeFilter.SHOW_TEXT */, null, false), n;
      var moi = giaHienTai();
      while ((n = w.nextNode())) {
        if (n.nodeValue.indexOf(GOI_GIU.chu) === -1) { continue; }
        if (n.parentNode && n.parentNode.closest && n.parentNode.closest('.a1rv')) { continue; }
        n.nodeValue = n.nodeValue.split(GOI_GIU.chu).join(moi);
      }
    }
    a7DungSanGio();
    a7NhoChoDo();
  }

  /* Chạy đồng hồ của màn đang hiện. Lần đầu của lượt thì đặt mốc tạm 10 phút ngay, để số
     chạy liền; máy chủ trả lời thì lấy mốc máy chủ. Nhịp đẩy vào `timers` của bundle nên
     `goto()`/`rerender()` tự dọn. */
  function a7DongHo() {
    var dh = $('a7cdt');
    if (!dh) { return; }
    if (mocGiuGia() === null) { ghiMocGiuGia(Date.now() + GIU_GIA_MS); }
    var daHet = hetGiuGia(), hen = null;

    function nhip() {
      if (!document.body.contains(dh)) { clearInterval(hen); return; }
      dh.textContent = a7ChuDongHo();
      if (!daHet && hetGiuGia()) { daHet = true; clearInterval(hen); a7HetGio(); }
    }

    if (!daHet) {
      hen = setInterval(nhip, 1000);
      if (typeof timers === 'object' && timers && timers.push) { timers.push(hen); }
    }

    a7HoiMayChu().then(function (het) {
      if (het === null || !document.body.contains(dh)) { if (het !== null) { ghiMocGiuGia(het); } return; }
      var truoc = hetGiuGia();
      ghiMocGiuGia(het);
      /* Máy chủ nói khác trạng thái trình duyệt đang hiện (mốc tạm đã qua mà mốc thật chưa,
         hay ngược lại): vẽ lại cho mọi chuỗi giá cùng một trạng thái. Hiếm — mốc tạm luôn
         đặt TRƯỚC lần hỏi máy chủ nên thường sớm hơn mốc thật vài trăm mili giây. */
      if (truoc !== hetGiuGia()) { rerender(); return; }
      nhip();
    });
  }

  /* ---- nhớ chỗ dở khi tải lại (03.4) -----------------------------------------
     Tới màn 36/37 thì cất `state` + tên màn vào `sessionStorage`, gắn với mã lượt. Lúc nạp
     trang, nếu mã lượt còn trong tab này (tải lại cùng tab) thì báo `quiz-do-duong.js` giữ
     lượt cũ (`window.__msTiepLuot`) và đưa khách về đúng màn đó. Tab mới không có
     `sessionStorage` của tab cũ nên là lượt mới — đề xuất ở câu A-6. */
  var KHOA_CHO_DO = 'minespirit_cho_do';
  var MAN_NHO = { hub: 1, gd1off: 1 };

  function a7NhoChoDo() {
    try {
      var s = SCREENS[cur];
      if (!s || !MAN_NHO[s.t]) { return; }
      sessionStorage.setItem(KHOA_CHO_DO,
        JSON.stringify({ luot: a1Luot(), man: s.t, state: state }));
    } catch (e) {}
  }

  /* Cờ đổi sau khi màn đã dựng (lớp hỏi khi quay lại, v.v.) cũng phải qua được lần tải lại. */
  addEventListener('pagehide', a7NhoChoDo);

  (function a7TiepChoDo() {
    var q = location.search;
    if (/[?&](screen|demo)=/.test(q)) { return; }
    var o = null;
    try { o = JSON.parse(sessionStorage.getItem(KHOA_CHO_DO) || 'null'); } catch (e) {}
    if (!o || !o.luot || o.luot !== a1Luot() || !MAN_NHO[o.man] || !o.state) { return; }
    window.__msTiepLuot = o.luot;
    /* Đợi mọi file `defer` nạp xong (đồng hồ đo đường, gửi bài, tháng) rồi mới đi, để lần
       `goto` này đi qua đủ các lớp bọc của chúng — cùng lối cầu nối màn chào. */
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () {
        try {
          var k;
          for (k in o.state) { if (o.state.hasOwnProperty(k)) { state[k] = o.state[k]; } }
          var i = idxOf(o.man);
          if (i > -1) { goto(i); }
        } catch (e) {}
      }, 0);
    });
  })();

  RENDER.gd1off = function () {
    var r = res7();
    var edge = r.edge;
    var diem = Math.round((r.axes[edge] || 0) * 10);
    var tenVung = tierName(edge);
    var ten = (state.name || '').trim();
    var b = state.bdate;
    var coNgaySinh = !!(b && b.y);
    var ma = a7LuaChonDau('M-A');
    var mb = a7LuaChonDau('M-B');

    /* ---- 1 · tiêu đề, có tên và không tên ---------------------------------- */
    var tieuDe = ten
      ? esc(ten) + ', ' + esc(A1('your reading is ready.',
          'bản đọc của bạn đã sẵn sàng.'))
      : esc(A1('Your reading is ready.',
          'Bản đọc của bạn đã sẵn sàng.'));

    /* ---- 2 · dòng dẫn, vùng và điểm in đậm --------------------------------- */
    var dong2 = isVI()
      ? (esc('Từ 21 câu bạn vừa chọn: ') + '<b>' + esc(tenVung) + '</b>' +
         esc(' là vùng đang rút cạn năng lượng của bạn nhiều nhất, ') +
         '<b>' + diem + '/100</b>.')
      : (esc('From the 21 answers you just gave: ') + '<b>' + esc(tenVung) + '</b>' +
         esc(' is the area draining your energy the most, ') + '<b>' + diem + '/100</b>.');

    /* ---- 7 · trích lời khách ----------------------------------------------
       Ẩn HẲN khối khi khách bỏ qua cả hai câu; bỏ một trong hai thì chỉ in phần có, không
       để lại "You said:" đứng một mình. */
    var khoiTrich = '';
    if (ma || mb) {
      khoiTrich = '<div class="a7quote">' +
        '<span>' + esc(A1('WRITTEN FROM WHAT YOU TOLD US',
          'VIẾT TỪ CHÍNH ĐIỀU BẠN ĐÃ NÓI')) + '</span>' +
        (ma ? '<p>' + esc(A1('You said: ', 'Bạn nói: ') + a7NhayKep(ma.chu)) + '</p>' : '') +
        (mb ? '<p>' + esc(A1('You also chose: ', 'Bạn cũng chọn: ') + a7NhayKep(mb.chu)) + '</p>' : '') +
      '</div>';
    }

    /* ---- 9 · khối Phần 2, hai nhánh theo ngày sinh -------------------------
       Tuổi = A7_MOC_NAM − năm sinh. Nhánh bỏ qua KHÔNG in ngày rỗng: đổi sang câu
       chung và một nút quay về màn ngày sinh (`ref/` §6C). */
    var uspChinh = coNgaySinh
      ? '<p>' + esc(isVI()
          ? 'Phần hai của bạn được tính từ ngày ' + a7NgaySinh(b) +
            '. Bắt đầu từ chính tháng này, đi từng tháng trong hai năm, rồi từng năm tới ' +
            A7_MOC_NAM + ', năm bạn ' + (A7_MOC_NAM - b.y) +
            ' tuổi. Người sinh khác ngày sẽ nhận những tháng khác.'
          : 'Your Part 2 is worked out from ' + a7NgaySinh(b) +
            '. It starts with this month and goes month by month for two years, then year by year to ' +
            A7_MOC_NAM + ', the year you turn ' + (A7_MOC_NAM - b.y) +
            '. A woman born on a different day gets different months.') + '</p>'
      : '<p>' + esc(A1(
          'Part two is worked out from your birth date: this month, then month by month for two years, then year by year to ' + A7_MOC_NAM + '.',
          'Phần hai được tính từ ngày sinh của bạn: từ tháng này, đi từng tháng trong hai năm, rồi từng năm tới ' + A7_MOC_NAM + '.')) + '</p>' +
        '<button class="a7bd" id="a7bd">' + esc(A1(
          'Enter my birth date to work out Part 2',
          'Nhập ngày sinh để tính phần hai')) + '</button>';

    var nhom1 = [
      A1('Why ' + tenVung + ' is the area draining you most, traced back to what you are carrying. Not because you are weak.',
         'Vì sao ' + tenVung + ' là vùng đang rút cạn bạn nhiều nhất, nối từ chính những việc bạn đang gánh. Không phải vì bạn yếu.'),
      A1('Scores for all 7 areas, and which area is pulling which one down, so you can see where to start.',
         'Điểm của cả 7 vùng, và vùng nào đang kéo vùng nào xuống, để bạn thấy nên bắt đầu từ đâu.'),
      A1('A plan of action written for you, that you can start tonight.',
         'Kế hoạch hành động viết riêng cho bạn, bắt đầu được ngay tối nay.')
    ];

    var nhom2 = [
      A1('Who you are beneath the mother, the wife, the caregiver. What gives you energy, and which part of you needs care most right now.',
         'Bạn là ai bên dưới vai mẹ, vai vợ, vai người chăm. Điều gì tiếp sức cho bạn, phần nào của bạn đang cần được chăm nhất.'),
      A1('Which chapter of your life you are in, and why the last few years have felt so heavy.',
         'Bạn đang ở chương nào của đời mình, và vì sao vài năm qua nặng đến thế.'),
      A1('The months highlighted for you across the next two years, each with one thing to do and one thing not to do.',
         'Những tháng được đánh dấu cho bạn trong hai năm tới, mỗi tháng một việc nên làm và một việc đừng làm.'),
      A1('A year-by-year reading from this year to ' + A7_MOC_NAM + '.',
         'Phần đọc theo từng năm, từ năm nay đến ' + A7_MOC_NAM + '.'),
      A1('Six things you are already dealing with, and the month each one comes back.',
         'Sáu chuyện bạn đang gặp rồi, và tháng mà mỗi chuyện quay lại.')
    ];

    var cachDung = [
      A1('Circle your marked months on the kitchen calendar. You will see which months to push the important things into, and which months to go slow.',
         'Khoanh những tháng được đánh dấu lên tờ lịch treo bếp. Bạn sẽ thấy tháng nào nên đẩy việc quan trọng vào, tháng nào nên đi chậm.'),
      A1('Before a hard month, set up what you can keep steady: your sleep, your meals, a little money set aside.',
         'Trước một tháng nặng, sắp sẵn những việc giữ được: giờ ngủ, bữa ăn, một khoản dự phòng.'),
      A1('When someone asks you to take on something big, open your months and look before you answer.',
         'Khi ai đó nhờ thêm một việc lớn, mở phần tháng ra xem trước khi trả lời.')
    ];

    var homNay = [
      A1('Your reading arrives by email in a few minutes, so you can read it while your answers are still fresh in your mind.',
         'Bản đọc tới email trong vài phút, nên bạn đọc được khi còn nhớ rõ những câu mình vừa chọn.'),
      A1('Your plan of action is open from the moment you receive it. Nothing to wait for.',
         'Kế hoạch hành động mở sẵn ngay khi bạn nhận. Không phải chờ gì.')
    ];

    function ds(mang) {
      return '<ul class="a7ben">' + mang.map(function (t) {
        return '<li>' + esc(t) + '</li>';
      }).join('') + '</ul>';
    }

    return {
      html: a1Topbar(cur > 0) +
        '<div class="mid">' +
          /* 1 · 2 · thẻ giá · cầu nối — bốn khối của khung nhìn đầu ở 390 × 680 */
          '<h1 class="a7h1">' + tieuDe + '</h1>' +
          '<div class="a7cd" id="a7cd"><b id="a7cdt">' + a7ChuDongHo() + '</b>' +
            '<span id="a7cdl">' + esc(a7NhanDongHo()) + '</span></div>' +
          '<p class="a7lead">' + dong2 + '</p>' +
          a7TheGia('a7pc1', 'a7buy') +
          /* Mốc 1px cho `IntersectionObserver`: nó trôi lên trên mép `#scr` đúng một lần,
             nên thanh dính bật/tắt ở một biên duy nhất, không rung. */
          '<i id="a7moc" aria-hidden="true" style="display:block;height:1px"></i>' +
          '<p class="a7bridge">' + esc(A1(
            'Your score tells you which area needs attention first. Your full reading explains why, and gives you a plan of action you can start tonight.',
            'Điểm cho bạn biết vùng nào cần quan tâm trước. Bản đọc đầy đủ giải thích vì sao, và cho bạn kế hoạch hành động để bắt đầu ngay tối nay.')) + '</p>' +

          /* 5 · bảo đảm 28 ngày */
          '<div class="a7guar"><b>' + esc(A1('28 days to change your mind',
            '28 ngày để đổi ý')) + '</b>' +
            '<p>' + esc(A1(
              'If the reading is not for you, reply to the email within 28 days and you get your money back. No form to fill out, no questions asked.',
              'Nếu bản đọc không hợp với bạn, hãy trả lời email trong vòng 28 ngày và bạn được hoàn tiền. Không phải điền biểu mẫu, không hỏi lý do.')) + '</p></div>' +

          /* 6 · dải bảo chứng ba dòng; dòng giữa đổi theo nhánh ngày sinh */
          '<div class="a7trust"><b>' + esc(A1('How your reading is prepared and how refunds work',
            'Cách chuẩn bị bản đọc và cách hoàn tiền')) + '</b>' +
            '<div>' + esc(A1('We calculate your scores from your 21 quiz answers.',
              'Chúng tôi tính điểm từ 21 câu trả lời quiz của bạn.')) + '</div>' +
            '<div>' + esc(coNgaySinh
              ? A1('Your reading has 2 parts and 15 sections, worked out from your own 21 answers and your birth date.',
                   'Bản đọc gồm 2 phần, 15 mục, tính riêng từ 21 câu trả lời và ngày sinh của bạn.')
              : A1('Your reading has 2 parts and 15 sections, worked out from your own 21 answers, with the birth-date part added once you give your birth date.',
                   'Bản đọc gồm 2 phần, 15 mục, tính riêng từ 21 câu trả lời của bạn, phần theo ngày sinh mở khi bạn bổ sung ngày sinh.')) + '</div>' +
            '<div>' + esc(A1('You can request a refund within 28 days by replying to your order email.',
              'Bạn có thể yêu cầu hoàn tiền trong 28 ngày bằng cách trả lời email đơn hàng.')) + '</div></div>' +

          /* 7 */
          khoiTrich +

          /* 8 */
          '<h3 class="a7h3">' + esc(A1('Understand why your energy is draining, and have a plan of action',
            'Hiểu vì sao năng lượng cạn, và có kế hoạch hành động')) + '</h3>' +
          ds(nhom1) +
          a6Anh('qz-inline-50.jpg', 'qz-inline-42.jpg',
            'An illustration: the overall reading section of a sample reading. Your own loop is written from your own answers.',
            'Ảnh minh hoạ: mục Luận giải tổng thể của một bản đọc ví dụ. Vòng lặp của bạn viết từ chính câu trả lời của bạn.') +

          /* 9 · khối Phần 2 */
          '<div class="a7usp">' +
            '<span class="a7ub">' + esc(coNgaySinh
              ? A1('PART 2 · FROM YOUR BIRTH DATE', 'PHẦN 2 · THEO NGÀY SINH')
              : A1('PART 2 · NEEDS YOUR BIRTH DATE', 'PHẦN 2 · CẦN NGÀY SINH')) + '</span>' +
            '<b class="a7ut">' + esc(A1('Get yourself back, and know what the years ahead hold',
              'Tìm lại chính mình, và biết trước những năm tới')) + '</b>' +
            '<strong>' + esc(A1('Part one shows the leak. Part two shows the road.',
              'Phần một chỉ chỗ rò. Phần hai chỉ đường.')) + '</strong>' +
            uspChinh +
            '<p class="a7usrc">' + esc(A1(
              'Part two is worked out from where the 10 planets actually were on the day you were born. It is a way to reflect, not a prediction.',
              'Phần hai tính từ vị trí thật của 10 hành tinh vào ngày bạn sinh. Là một cách suy ngẫm, không phải dự báo.')) + '</p>' +
            '<p class="a7ux">' + esc(coNgaySinh
              ? a1Gia(A1('Both parts in one reading. One payment of {gia}.',
                   'Hai phần trong một bản đọc. Trả một lần {gia}.'))
              : A1('Or add your birth date after you pay. This part appears in your reading at no extra cost.',
                   'Hoặc bổ sung ngày sinh sau khi trả tiền. Phần này hiện ra trong bản đọc, không mất thêm phí.')) + '</p>' +
          '</div>' +

          /* 10 */
          ds(nhom2) +
          '<div class="a7use"><b>' + esc(A1('How you will use this part',
            'Bạn sẽ dùng phần này thế nào')) + '</b><ol>' +
            cachDung.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') +
          '</ol></div>' +
          '<p class="a7payoff">' + esc(A1(
            'You will know which months your reading marks out, what to have ready before them, and what there is to look forward to in the next chapter of your life.',
            'Bạn sẽ biết bản đọc đánh dấu những tháng nào, cần chuẩn bị gì trước, và chương đời tiếp theo của bạn có gì đáng chờ.')) + '</p>' +
          a6Anh('qz-inline-51.jpg', 'qz-inline-44.jpg',
            'An illustration: the six everyday situations in a sample reading. The month each one comes back, and what to have ready, are worked out from where the planets actually were on your birth date. A shortened view: in your reading, each situation also has its explanation below it.',
            'Ảnh minh hoạ: sáu chuyện đời sống trong một bản đọc ví dụ. Tháng mỗi chuyện quay lại và việc nên chuẩn bị tính riêng từ vị trí thật của các hành tinh vào ngày sinh của bạn. Ảnh rút gọn: trong bản đọc, mỗi chuyện còn có phần giải thích bên dưới.') +

          /* 11 · mục lục */
          '<h3 class="a7h3">' + esc(A1('What is inside', 'Bên trong có gì')) + '</h3>' +
          '<div class="a7toc">' +
            '<b>' + esc(A1('Your Inner Weather Report · your 7-area report · 7 sections',
              'Bản đồ sức khoẻ tinh thần 7 luân xa · báo cáo 7 vùng của bạn · 7 mục')) + '</b>' +
            '<div>' + esc(A1(
              'Overview · Overall reading · Your 7-area map · Each area up close · What you need to hear · Your plan of action · Our promise',
              'Tổng quan · Luận giải tổng thể · Bản đồ 7 vùng · Đi sâu từng vùng · Kết luận cần nghe · Kế hoạch hành động · Cam kết')) + '</div>' +
            '<b>' + esc(A1('Your Spirit Map · your life map, from your birth date · 8 sections',
              'Bản đồ tâm linh · bản đồ đời bạn, tính từ ngày sinh · 8 mục')) + '</b>' +
            '<div>' + esc(A1(
              'Overview · Your cycles · Your four elements · Destiny and the next ten years · This year and next, month by month · If you keep going without knowing · Where to begin · Our promise',
              'Tổng quan · Chu kỳ vận số · Nhóm tính cách · Vận mệnh và mười năm · Năm nay và năm sau, từng tháng · Nếu cứ đi mà không biết trước · Bắt đầu từ đâu · Cam kết của chúng tôi')) + '</div>' +
          '</div>' +

          /* 12 · lý do giá — CHỮ KHOÁ, quyết định khoá số 3, không sửa một từ */
          '<h3 class="a7h3">' + esc(a1Gia(A1('Why it is {gia}', 'Vì sao chỉ {gia}'))) + '</h3>' +
          '<p>' + esc(a1Gia(A1(
            'Readings like this usually sell for $29 to $49. Yours is {gia} because we would rather you start tonight than think about it for a month. This is the price that lets you begin your journey tonight, instead of waiting any longer. If it misses, reply to the email and the money comes back.',
            'Những bản đọc kiểu này thường bán $29 tới $49. Bản của bạn là {gia} vì chúng tôi thà bạn bắt đầu ngay tối nay còn hơn nghĩ thêm một tháng. Đây là mức giá để bạn bắt đầu hành trình của mình ngay tối nay, thay vì chờ đợi thêm. Nếu trật, trả lời email là tiền quay về.'))) + '</p>' +

          /* 13 · một phần bên trong */
          '<h3 class="a7h3">' + esc(A1('A look inside', 'Xem một phần bên trong')) + '</h3>' +
          '<blockquote class="a7bq"><p>' + esc(A1(
            '“You are not a weak person. If anything, your results show someone who has grown used to holding too much: the house, the job, other people’s feelings, and the words you meant to say but swallowed in the end. But that is not who you are. It is a pace of life that has stretched you too thin.”',
            '“Bạn không phải người yếu. Ngược lại, kết quả của bạn cho thấy một người đã quen tự giữ quá nhiều thứ: giữ nhà, giữ việc, giữ cảm xúc của người khác, giữ những câu muốn nói nhưng cuối cùng lại nuốt xuống. Nhưng đó không phải tính cách của bạn. Đó là một nhịp sống đã kéo bạn quá mỏng.”')) + '</p>' +
            '<small>' + esc(A1(
              'Taken from the overview and conclusion of a sample reading. Yours is written from your own answers.',
              'Trích từ phần tổng quan và kết luận của một bản đọc mẫu. Bản của bạn được viết từ chính câu trả lời của bạn.')) + '</small></blockquote>' +
          '<details class="a7src"><summary>' + esc(A1('See this page of a sample reading',
            'Xem trang này trong một bản đọc mẫu')) + '</summary>' +
            a6Anh('qz-inline-52.jpg', 'qz-inline-46.jpg',
              'An illustration: the overview section of a sample reading, where the passage above begins.',
              'Ảnh minh hoạ: mục Tổng quan của một bản đọc ví dụ, nơi đoạn trích ở trên bắt đầu.') +
          '</details>' +

          /* 14 · hỏi đáp và "vì sao đọc tối nay" */
          '<h3 class="a7h3">' + esc(A1('Before you decide', 'Trước khi quyết định')) + '</h3>' +
          '<div class="a7faq">' + A7_FAQ.map(function (f) {
            return '<div><b>' + esc(A1(f[0], f[2])) + '</b><p>' + esc(a1Gia(A1(f[1], f[3]))) + '</p></div>';
          }).join('') + '</div>' +
          '<div class="a7today"><b>' + esc(A1('Why read it tonight',
            'Vì sao nên đọc ngay tối nay')) + '</b>' +
            homNay.map(function (t) { return '<div>' + esc(t) + '</div>'; }).join('') + '</div>' +

          /* 15 · bảng trước / sau */
          '<h3 class="a7h3">' + esc(A1('Before you read it, and after',
            'Trước khi đọc, và sau khi đọc')) + '</h3>' +
          A7_BA4.map(function (x) {
            return '<div class="a7ba"><div class="a7b4a">' + esc(A1(x[0], x[2])) + '</div>' +
              '<div class="a7b4b">' + esc(A1(x[1], x[3])) + '</div></div>';
          }).join('') +

          /* 16 · thẻ giá lần hai và chân trang */
          a7TheGia('a7pc2', 'a7buy2') +
          '<p class="a7legal">' + esc(A1(
            'For reflection, not medical advice. Not affiliated with any medical or academic institution. Questions about your order? hello@minespirit.com',
            'Để suy ngẫm về bản thân, không phải lời khuyên y tế. Không liên kết với trường học hay bệnh viện nào. Hỏi về đơn hàng: hello@minespirit.com')) + '</p>' +
          '<button class="a7lui" id="a7lui">' + esc(A1('Back to my summary',
            'Quay lại bản tóm tắt')) + '</button>' +
        '</div>' +

        /* 17 · thanh dính. Class `.foot` là cái gác `dockLone()` — xem chú thích đầu A7. */
        '<div class="foot a7stk" id="a7stk" hidden>' +
          '<div class="a7stkin"><b>' + giaHienTai() + '</b>' +
            '<button class="btn a7buy" id="a7stkbuy">' + esc(A1('Get my full reading',
              'Nhận bản đọc đầy đủ')) + '</button></div>' +
        '</div>' +

        /* 18 · lớp hỏi khi quay lại */
        '<div class="a7ask" id="a7ask" role="dialog" aria-modal="true" hidden>' +
          '<div class="a7askbox"><b>' + esc(A1('Before you go back',
            'Trước khi bạn quay lại')) + '</b>' +
            '<p>' + esc(A1(
              'Your summary is still here. Would you like to see what is in the full reading first?',
              'Bản tóm tắt của bạn vẫn ở đây. Bạn có muốn xem trong bản đọc đầy đủ có gì trước không?')) + '</p>' +
            '<button class="btn" id="a7asklui">' + esc(A1('Back to my summary',
              'Quay lại bản tóm tắt')) + '</button>' +
            '<button class="a7lui" id="a7askoLai">' + esc(A1('Keep reading this page',
              'Xem tiếp trang này')) + '</button></div>' +
        '</div>',

      bind: function () {
        var thanh = $('a7stk'), moc = $('a7moc'), scr = document.getElementById('scr');
        var hoi = $('a7ask'), lui = $('a7lui'), back = $('back');

        /* `offer_view` và lần `plan_select` đầu (gói đang bày), đúng tên và dạng của
           `quiz-giai-doan-1.js` `ganChaoHang()`, kể cả `screen: 'hub'` mà báo cáo phễu lọc. */
        if (lanXemMoi('gd1off')) {
          var goiXem = goiHienTai();
          suKienA7('offer_view', { screen: 'hub' });
          suKienA7('plan_select', { screen: 'hub', plan: goiXem.ma, price: goiXem.so });
        }

        /* ---- thanh dính --------------------------------------------------
           `IntersectionObserver` trên mốc 1px, KHÔNG ngưỡng `scrollY` cứng: chiều cao
           phần trên đổi theo tên, theo vùng và theo hai thứ tiếng, nên mọi con số cứng
           đều sai với một phần khách. Trình duyệt không có `IntersectionObserver` thì
           thanh ở nguyên trạng thái ẩn — hai nút mua trong thẻ giá vẫn đủ đường mua. */
        if (thanh && moc && scr && typeof IntersectionObserver === 'function') {
          var io = new IntersectionObserver(function (ds) {
            var e = ds[0];
            var khung = e.rootBounds || scr.getBoundingClientRect();
            thanh.hidden = !(e.boundingClientRect.bottom <= khung.top);
          }, { root: scr, threshold: 0 });
          io.observe(moc);
        }

        /* ---- lớp hỏi khi quay lại ----------------------------------------
           Cờ nằm trên `state`, tức theo LƯỢT làm quiz: `freshState()` dựng object mới khi
           khách làm lại từ đầu, nên lượt sau được hỏi lại. Để ở `localStorage` là một lần
           hỏi cho cả đời trình duyệt. */
        function quayLai() { sfx('nav'); goto(cur - 1); }

        function xinChoXem() {
          if (state.a7DaHoi || !hoi) { quayLai(); return; }
          state.a7DaHoi = true;
          hoi.hidden = false;
        }

        if (back) { back.onclick = xinChoXem; }
        if (lui) { lui.onclick = xinChoXem; }
        if (hoi) {
          $('a7asklui').onclick = function () { hoi.hidden = true; quayLai(); };
          $('a7askoLai').onclick = function () { sfx('tap'); hoi.hidden = true; };
        }

        /* ---- nút ngày sinh ở nhánh bỏ qua --------------------------------- */
        var nutBd = $('a7bd');
        if (nutBd) {
          nutBd.onclick = function () { sfx('tap'); goto(idxOf('bdate')); };
        }

        /* ---- đường tới thanh toán ----------------------------------------
           Dùng lại đúng đường `quiz-sang-trang-ban.js` đang chạy (`/cart/add.js` → gắn mã
           phiên → `/checkout`), KHÔNG chép lại: đường đó mang mã phiên ở cả thuộc tính cấp
           đơn lẫn dòng hàng, và cả hai đều đã trả giá ở đơn #1016/#1017 mới tìm ra.
           Còn giờ: chuỗi rỗng = biến thể mặc định $4.90. Hết giờ: variant $19 (`a7BienThe()`).
           Giỏ đã mở lúc còn giờ vẫn giữ $4.90 vì giá đi theo variant trên giỏ (E13). */
        function diThanhToan(nut) {
          var goi = goiHienTai();
          suKienA7('checkout_start', { plan: goi.ma, price: goi.so });
          if (typeof window.__msMuaNgay === 'function') { window.__msMuaNgay(nut, a7BienThe()); return; }
          if (typeof window.__msSangTrangBan === 'function') { window.__msSangTrangBan(); return; }
          /* Chưa khai `data-variant-goi` lẫn `data-dich-ban` — không có đích nào để đi.
             Mở lại nút để khách bấm được lần nữa sau khi cấu hình xong. */
          if (nut) { nut.disabled = false; nut.removeAttribute('aria-busy'); }
        }

        ['a7buy', 'a7buy2', 'a7stkbuy'].forEach(function (id) {
          var n = $(id);
          if (n) { n.onclick = function () { sfx('tap'); diThanhToan(n); }; }
        });

        /* ---- giỏ dựng sẵn -------------------------------------------------
           Dựng sẵn giỏ NGAY khi màn giá hiện, đừng đợi khách bấm: đo live 15/09/2026 riêng
           `cartCreate` tốn 0,87–1,08 giây. Hết giờ lúc đang xem thì `a7HetGio()` dựng lại
           giỏ cho variant $19. */
        a7DungSanGio();

        a7DongHo();
        a7NhoChoDo();
      }
    };
  };

  /* Kênh đo dùng chung của quiz. `quiz-do-duong.js` (thẻ #9) phơi `window.__msSuKien` và
     nạp SAU file này, nhưng `bind()` chỉ chạy khi khách đã đi tới màn giá nên lúc đó kênh
     đã có. Không có kênh thì im lặng bỏ qua — mất một con số, không mất một đơn. */
  /* Màn dựng lúc nạp trang (`?screen=`, `veLai()` của `quiz-giai-doan-1.js`) gọi `bind()`
     TRƯỚC khi `quiz-do-duong.js` chạy: event lúc đó nằm chờ ở đây, rồi đi ở
     `DOMContentLoaded`, khi mọi file `defer` đã chạy xong. */
  var choKenh = [];
  function suKienA7(ten, them) {
    try {
      var ev = { event: ten, screen: 'gd1off' }, k;
      if (them) { for (k in them) { if (them.hasOwnProperty(k)) { ev[k] = them[k]; } } }
      if (typeof window.__msSuKien !== 'function') { choKenh.push(ev); return; }
      window.__msSuKien(ev);
    } catch (e) {}
  }
  document.addEventListener('DOMContentLoaded', function () {
    try {
      while (choKenh.length && typeof window.__msSuKien === 'function') { window.__msSuKien(choKenh.shift()); }
    } catch (e) {}
  });

  /* Event "đã xem màn" bắn MỘT lần mỗi lần khách đi tới màn. `bind()` còn chạy lại khi
     `rerender()` dựng màn tại chỗ (hết giờ giữ giá) và lúc nạp trang màn được dựng hai lần.
     Cả hai bản `goto()` (`quiz-inner-weather.js`, `quiz-chuyen-man-muot.js`) bật `busy`
     trước `bind()` và tắt sau; `rerender()` không đụng tới nó. Lần dựng đầu trong một lần
     nạp trang cũng là một lần xem. */
  var daXemLanNap = {};
  function lanXemMoi(man) {
    var moi = busy || !daXemLanNap[man];
    daXemLanNap[man] = true;
    return moi;
  }

  /* Cổng cho `quiz-giai-doan-1.js:917`, cùng khuôn với `__msMan19` · `__msMan23` · `__msMan24`. */
  window.__msMan25 = true;

  /* ---------------------------------------------------------------------------
     A8 (phase 26) · MÀN CẢM ƠN · màn 39 `done`

     MÀN `done` CŨ BỊ BỎ, KHÔNG PHẢI SỬA CHỮ. `ref/` §1 xếp màn `done` cũ (idx 42) là BỎ
     và màn 39 là THÊM MỚI. Bản cũ (`quiz-inner-weather.js:8004`) nhắc "3-Day Path", "Joy
     of Wellbeing session" và "Open Mine Chapter" — ba thứ không còn tồn tại sau quyết định
     khoá 1 và 6. Giữ khung cũ rồi thay chữ là kéo theo cả bố cục của một sản phẩm khác;
     hàm dưới đây dựng lại từ đầu và đè hẳn hàm kia (file này nạp sau bundle).

     KHÔNG CẦN CỔNG `__msMan*`. Bản cũ nằm trong bundle, tức thẻ #3, TRƯỚC file này —
     khác `gd1off` · `hub` · `email` · `intro` vốn bị `quiz-giai-doan-1.js` (thẻ #6) khai
     lại ở phía sau. Đã đếm 21/09: không file nào sau thẻ #4 gán `RENDER.done`.

     NÚT "OPEN MY FULL READING" TRỎ ĐÚNG LINK CỦA EMAIL. Bản đọc có đúng MỘT
     đường: `/pages/your-reading#s=<mã phiên>` — trang đọc live (đo 21/09: 200, có
     `data-plg`), cùng link mà khối "Your reading is ready" ở trang cảm ơn
     (`minespirit-qua-tang/extensions/doc-ban-luan-giai`) và mẫu email Order confirmation
     (`docs/email-giao-ban-doc.md`) dựng từ thuộc tính đơn `quiz_session`. Mã đi qua MẢNH
     NEO nên hai khoá lệch tên không cần gộp: quiz cất `minespirit_phien`, trang đọc đọc
     `ms_phien`, và chính `snippets/brand-pheu-gon.liquid` chuyển `#s=` sang `ms_phien` rồi
     xoá khỏi thanh địa chỉ trước khi pixel chạy. Không có mã hợp lệ thì KHÔNG dựng nút,
     cùng luật với khối trang cảm ơn: dẫn tới trang báo "missing its key" tệ hơn không dẫn.
     ⚠️ Khách thật KHÔNG đi qua màn này: nút mua điều hướng cùng tab sang checkout Shopify
     (`quiz-sang-trang-ban.js`, `location.assign`) và trang sau thanh toán là trang cảm ơn
     của Shopify. Đường giao thật là khối trang cảm ơn (ngay) + email (giữ, đọc lại). Nút ở
     đây trỏ cùng link để không nơi nào dẫn đi chỗ khác.

     BỐN GIÁ TRỊ CỦA MÀN NÀY ĐI THEO ĐƠN. Tên · vùng thấp nhất · lựa chọn câu 2/3 · cờ bỏ qua
     ngày sinh được tính bằng các hàm `a8*` dưới đây, và CŨNG các hàm đó cấp cho
     `window.__msThuEmail` — `quiz-sang-trang-ban.js` gắn chúng vào giỏ thành thuộc tính ẩn
     `_ms_*`, mẫu email in lại. Một nguồn cho cả khối xem trước lẫn email thật, nên hai bên
     khớp chữ theo cấu trúc chứ không theo trí nhớ.

     KHỐI XEM TRƯỚC EMAIL LÀ BẢN VẼ MỤC TIÊU. Mẫu email thật nằm trong Shopify admin,
     không có API trong đợt này (`ref/` K26). Hai bên phải khớp từng chữ, nên khối mang
     `data-cho-kiem="K26"` — cùng khuôn với K25 · K34 đã có trong file.
     --------------------------------------------------------------------------- */

  var A8_STYLE = [
    '.a8h1{font-family:var(--serif);font-size:27px;line-height:1.25;margin:4px 0 16px}',
    /* `word-break` cho địa chỉ email: tên miền dài hơn bề ngang 390px thì tràn ngang cả
       màn, và `.screen` không cuộn ngang được. */
    '.a8h1 span{word-break:break-word}',
    '.screen p.a8tiny{font-size:15px!important;color:var(--ink3)!important;',
      'text-align:left!important;margin:10px 0 0}',
    /* Dòng nhắc ngày sinh phải nổi hơn chữ phụ: nó là quyền lợi khách sắp bỏ lỡ. */
    '.screen p.a8bd{background:#F4EFFC;border-left:3px solid var(--gold);border-radius:10px;',
      'padding:12px 14px;margin:14px 0 0}',
    '.a8h3{font-family:var(--serif);font-size:22px;line-height:1.3;margin:24px 0 8px}',
    /* Khối email trông ra một lá thư, không lẫn vào thân bài: nền trắng, viền, và một
       dải tiêu đề như dòng Subject của hộp thư. */
    '.a8mail{background:#fff;border:1px solid var(--line);border-radius:14px;',
      'overflow:hidden}',
    '.a8mh{background:#F7F4EE;border-bottom:1px solid var(--line);padding:11px 14px;',
      'font-family:var(--sans);font-size:15px;font-weight:700;line-height:1.4;',
      'color:var(--ink2)}',
    '.a8mb{padding:13px 14px}',
    '.screen .a8mb p{font-size:17px!important;margin:0 0 10px}',
    '.screen p.a8mtiny{font-size:14px!important;color:var(--ink3)!important;',
      'text-align:left!important;margin:0;padding-top:10px;border-top:1px solid var(--line)}'
  ].join('');

  (function a8NapStyle() {
    var el = document.createElement('style');
    el.id = 'ms-a8-style';
    el.textContent = A8_STYLE;
    document.head.appendChild(el);
  })();

  function a8Ten() { return (state.name || '').trim(); }
  function a8Vung() { return tierName(res7().edge); }
  /* Trích câu 2/3 (`M-C`) theo `stable_key`, dùng chung hàm của A7 — một đường tra cho cả
     hai màn, không dựng bản sao. Bỏ qua `M-C` thì trả rỗng và dòng "You chose: …" biến
     HẲN, ở màn lẫn email: chủ dự án chốt 20/09 là không điền lựa chọn mặc định thay khách. */
  function a8Chon() {
    var mc = a7LuaChonDau('M-C');
    return mc ? a7NhayKep(mc.chu) : '';
  }
  function a8BoNgaySinh() { return !(state.bdate && state.bdate.y); }

  /* Thuộc tính cấp đơn cho mẫu email. Mỗi giá trị dựng trong `try` riêng: hỏng một cái thì
     mất đúng câu đó trong email, ba cái kia vẫn đi. Rỗng thì không có khoá — email bỏ câu. */
  window.__msThuEmail = function () {
    var thuoc = {};
    function gan(khoa, lay) {
      try {
        var v = lay();
        if (v) { thuoc[khoa] = v === true ? '1' : v; }
      } catch (e) {}
    }
    gan('_ms_ten', a8Ten);
    gan('_ms_vung', a8Vung);
    gan('_ms_chon', a8Chon);
    gan('_ms_bo_ngay_sinh', a8BoNgaySinh);
    return thuoc;
  };

  var A8_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  function a8LinkDoc() {
    var ma = '';
    try {
      ma = (sessionStorage.getItem('minespirit_phien') ||
            localStorage.getItem('minespirit_phien') || '').trim();
    } catch (e) {}
    return A8_UUID.test(ma) ? '/pages/your-reading#s=' + encodeURIComponent(ma) : '';
  }

  RENDER.done = function () {
    var tenVung = a8Vung();
    /* `ref/` §6C: bỏ trống tên thì TIÊU ĐỀ EMAIL dùng "Friend". Đây là chỗ duy nhất của
       màn này có tên, và nó nằm trong bản vẽ email chứ không phải chữ trên màn. */
    var tenEmail = a8Ten() || A1('Friend', 'Bạn');
    var email = (state.email || '').trim();
    var chon = a8Chon();
    var link = a8LinkDoc();

    var tieuDe = email
      ? esc(A1('Thank you. We are sending your reading to ',
               'Cảm ơn bạn. Chúng tôi đang gửi bản đọc đến ')) +
        '<span>' + esc(email) + '</span>' + esc('.')
      : esc(A1('Thank you. Your payment went through, and your reading is on its way to the email you used at checkout.',
               'Cảm ơn bạn. Thanh toán đã xong, bản đọc đang được gửi tới địa chỉ email bạn dùng khi thanh toán.'));

    return {
      html: a1Topbar(false) +
        '<div class="mid">' +
          '<div class="a1kick">' + esc(A1('PAYMENT COMPLETE', 'THANH TOÁN HOÀN TẤT')) + '</div>' +
          '<h1 class="a8h1">' + tieuDe + '</h1>' +

          /* Nhánh bỏ qua ngày sinh (`ref/` K23 mục 3). Không gắn liên kết: ô nhập nằm
             TRONG chính bản đọc khách sắp mở (`assets/pheu-107-luan-giai.js` đã có form),
             nên câu này chỉ cần nói ở đâu — không cần một URL thứ hai để lệch với phase 28. */
          (!a8BoNgaySinh() ? '' :
            '<p class="a8bd">' + esc(A1(
              'Add your birth date for the years-ahead part. No extra cost: the three boxes are inside your reading, and that part appears as soon as you fill them in.',
              'Bổ sung ngày sinh để mở phần những năm tới. Không mất thêm phí: ba ô chọn nằm ngay trong bản đọc của bạn, điền xong là phần đó hiện ra.')) + '</p>') +

          /* Bản vẽ mục tiêu của email giao hàng — `data-cho-kiem="K26"`. */
          '<h3 class="a8h3">' + esc(A1('The email, two minutes later',
            'Email, hai phút sau')) + '</h3>' +
          '<div class="a8mail" data-cho-kiem="K26">' +
            '<div class="a8mh">' + esc(A1(
              'Subject: ' + tenEmail + ', your full reading: your 7 areas, scored',
              'Tiêu đề: ' + tenEmail + ', bản đọc đầy đủ của bạn: 7 vùng, đã có điểm')) + '</div>' +
            '<div class="a8mb">' +
              '<p>' + esc(isVI()
                ? 'Cảm ơn bạn. Đây là bản đọc đầy đủ của bạn. Hãy bắt đầu ở phần ' + tenVung +
                  '. Phần này giải thích vì sao bạn đuối sức ở vùng này trước và câu trả lời của bạn cho thấy gì. Sau đó, đọc phần về con người bạn ngoài tất cả những việc bạn đang lo.'
                : 'Thank you. Here is your full reading. Start with the ' + tenVung +
                  ' section. It explains why this area was the first to run low and what your answers show. Then read the section about who you are beyond everything you take care of.') + '</p>' +
              (chon ? '<p>' + esc(A1('You chose: ', 'Bạn đã chọn: ') + chon + ' ' +
                A1('Your reading includes a section about that. Your plan of action is inside too, with the first thing to do tonight.',
                   'Bản đọc có phần nói về mong muốn đó. Kế hoạch hành động cũng ở trong đó, với việc đầu tiên làm ngay tối nay.')) + '</p>' : '') +
              /* 28 ngày, KHÔNG phải 60 — "60-day" là chuỗi của bản cũ mà `ref/` §6A bắt gỡ. */
              '<p class="a8mtiny">' + esc(a1Gia(A1(
                '{gia} USD · Paid once · No subscription · If this is not for you, reply to this email within 28 days for a refund. No form.',
                '{gia} USD · Đã thanh toán một lần · Không đăng ký trả phí định kỳ · Nếu bản đọc không phù hợp, hãy trả lời email này trong vòng 28 ngày để được hoàn tiền. Không cần điền biểu mẫu.'))) + '</p>' +
            '</div>' +
          '</div>' +
        '</div>' +

        /* NÚT NẰM TRONG `.foot`, KHÔNG NẰM NGAY DƯỚI TIÊU ĐỀ NHƯ `ref/` XẾP. Hai lý do,
           cả hai đo được:
           · `dockLone()` (`quiz-inner-weather.js:26048`) tự DỜI nút `.btn` cuối cùng vào
             một thanh `.v3foot` khi màn cao hơn 1,5 màn hình VÀ trong `#scr` không có
             `.stickybar` / `.foot` / `.v3foot`. Đo 21/09 ở 390×680: nhánh tiếng Anh có
             ngày sinh cao 897px (dưới ngưỡng 1020px, nút ở nguyên chỗ), nhánh tiếng Việt
             bỏ qua ngày sinh cao 1163px (nút bị lôi xuống thanh dính). Tức là hai khách
             thấy hai bố cục khác nhau trên cùng một màn, không ai báo lỗi.
           · Mọi màn khác của file này — `bdate` · `email` · `multi7` · `hub` · `credibility`
             — đều để nút chính trong `.foot`. Đây là chuẩn của repo, không phải lựa chọn mới.
           Thứ tự đọc vẫn đúng: cảm ơn → email sắp tới trông thế nào → mở bản đọc. */
        '<div class="foot">' +
          (link ? '<button class="btn" id="a8mo">' +
            esc(A1('Open my full reading', 'Mở bản đọc đầy đủ')) + '</button>' : '') +
          /* Nhánh không email dùng `DONE_help_noemail` của `ref/` B-12. Dòng
             `DONE_btn_note_noemail` ("You can also open it right here…") KHÔNG dựng ở đây:
             `ref/` chỉ cho dựng khi nút chắc chắn mở đúng bản đọc của ĐƠN, mà mã của nút này
             lấy từ storage chứ không từ đơn, và khách thật không tới màn này sau khi trả
             tiền (xem đầu khối). Khối trang cảm ơn thì đọc mã từ chính đơn nên có dòng đó. */
          '<p class="a8tiny">' + esc(email
            ? A1('Cannot find the email? Check Spam or Promotions, or write to hello@minespirit.com.',
                 'Chưa thấy email? Kiểm tra Thư rác hoặc Quảng cáo, hoặc viết cho hello@minespirit.com.')
            : A1('If nothing has arrived in 10 minutes, check Spam or Promotions. Still nothing? Write to hello@minespirit.com with the name you used at checkout, and we will send your reading again.',
                 'Nếu sau 10 phút chưa thấy thư, kiểm tra Thư rác hoặc Quảng cáo. Vẫn chưa có? Viết cho hello@minespirit.com kèm tên bạn dùng khi thanh toán, chúng tôi sẽ gửi lại bản đọc.')) + '</p></div>',

      /* `bind` chỉ gắn đích cho nút. `screen_viewed` do `quiz-do-duong.js` bắn theo kiểu màn,
         không cần gắn tay — và vì màn không nhận dữ liệu nên nó KHÔNG có `answered`, đúng như
         `MAN_NHAP` (`:265`) đã định. */
      bind: function () {
        var nut = $('a8mo');
        if (nut) { nut.onclick = function () { sfx('tap'); window.location.assign(link); }; }
      }
    };
  };

})();
